<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card style="border: black 2px solid">
        <v-card-title class="headline mb-1">
          <span> ข้อมูลโครงการ</span>
          <span v-if="TypeProject == '1'">ข้อมูลโครงการ</span>
          <span v-if="TypeProject == '2'">ข้อมูล อบรม/เดินทางไปปฏิบัติงาน</span>
        </v-card-title>
        <v-container>
          <v-expand-transition>
            <v-card v-if="!Details_Cordi"
                    style="border: black 1px solid"
            >
              <v-row
                  justify="center"
                  class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12">
                  <v-card-title>
                    <span v-if="TypeProject == '1'">ตารางข้อมูลรายละเอียดโครงการ</span>
                    <span v-if="TypeProject == '2'">ตารางข้อมูลรายละเอียด อบรม/เดินทางไปปฏิบัติงาน</span>
                  </v-card-title>
                </v-col>
              </v-row>
              <v-list v-if="TypeProcess == '1'">
                <v-list-item class="d-flex justify-center" @change="ChooseTypeStatus" v-if="TypeProject == '1'">
                  <v-radio-group row v-model="typeStatus">
                    <!--                  <v-radio label="ทั้งหมด" value="3"></v-radio>-->
                    <!--                  <v-chip dark color="pink" class="ma-2">
                                        {{countAll}}
                                      </v-chip>-->
                    <!-- <v-radio class="font-weight-bold" label="ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี" value="1"></v-radio> -->
                    <!--                  <v-chip dark color="pink" class="ma-2">
                                        {{countFaculty}}
                                      </v-chip>-->
                    <!-- <v-radio class="font-weight-bold" label="ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"
                             value="0"></v-radio> -->
                    <!--                  <v-chip dark color="pink" class="ma-2">-->
                    <!--                    {{countDep}}-->
                    <!--                  </v-chip>-->
                  </v-radio-group>
                </v-list-item>
              </v-list>
              <v-list>
                <v-list-item class="justify-center">
                  <div align="center">
                    <p class="font-weight-bold">เลือกปีงบประมาณก่อนทำรายการ</p>
                  </div>
                </v-list-item>
                <v-list-item class="justify-center">
                  <v-radio-group row v-model="FiscalYear" v-for="fiscalYear in FiscalYearDataSel" :key="fiscalYear.year" @change="selProjFiscalYear">
                    <v-radio :value="fiscalYear.year" class="font-weight-bold" :label="('' + fiscalYear.yearth)"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item class="justify-center">
                  <v-radio-group class="font-weight-bold" v-model="sortStatus" row>
                    <v-radio label="แสดงทั้งหมด" value="1"></v-radio>
                    <v-radio label="เลือกแสดงตามสถานะ" value="2"></v-radio>
                  </v-radio-group>
                </v-list-item>

                <v-list-item v-if="sortStatus == '2'">
                  <v-row
                      justify="center"
                      class="justify-center">
                    <v-col
                        cols="12"
                        md="4"
                    >
                      <v-select
                          v-model="selStatus"
                          :items="StatusProject"
                          item-value="id"
                          item-text="status"
                      >
                        <template v-slot:item="{item}">
                          <h4 class="font-weight-bold">{{ item.status }}
                            <span style="color: #364eff"
                                  v-if="TypeProject == '1' && TypeProcess == '0'">{{
                                projectDataToTable.filter(itemProj => itemProj.IsPlanStatus == item.id).length
                              }}</span>
                            <span style="color: #364eff"
                                  v-else-if="TypeProject == '1' && TypeProcess == '1' && typeStatus == '1'">{{
                                projectDataToTable.filter(itemProj => itemProj.Approve == '1' && itemProj.IsPlanStatus == item.id && itemProj.Project_type == TypeProject).length
                              }}</span>
                            <span style="color: #364eff"
                                  v-else-if="TypeProject == '1' && TypeProcess == '1' && typeStatus == '2'">{{
                                projectDataToTable.filter(itemProj => itemProj.Approve == '0' && itemProj.IsPlanStatus == item.id && itemProj.Project_type == TypeProject).length
                              }}</span>
                            <span style="color: #364eff"
                                  v-else-if="TypeProject == '2'">{{
                                projectDataToTable.filter(itemProj => itemProj.IsPlanStatus == item.id && itemProj.Project_type == TypeProject).length
                              }}</span>
                            รายการ
                          </h4>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-list-item>

                <v-list-item class="d-flex justify-center">
                  <v-btn v-if="TypeProject == '2'" outlined color="green" class="darken-3" @click="OpenDialogReport">
                    Export ข้อมูลอบรม/เดินทางไปปฏิบัติงาน
                  </v-btn>
                </v-list-item>

                <v-list-item>
                  <v-spacer></v-spacer>
                  <v-text-field
                      v-if="TypeProcess == '0'"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="ค้นหา"
                      single-line
                      hide-details
                  ></v-text-field>
                  <v-text-field
                      v-else
                      v-model="search2"
                      append-icon="mdi-magnify"
                      label="ค้นหา"
                      single-line
                      hide-details
                  ></v-text-field>
                </v-list-item>
              </v-list>
              <v-row
                  justify="center"
                  class="justify-center">
                <v-col
                    cols="12"
                    md="12"
                >

                  <!--                        @click:row="GetData"-->
                  <v-data-table
                      :headers="allProjectHeader"
                      :items="typeStatus == '1' ? sortStatus == '1' ? allProjectDataToTable.filter(item => item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8' || item.IsPlanStatus == '9') : allProjectDataToTable.filter(item => item.IsPlanStatus == selStatus) : sortStatus == '1' ? allProjectDataToTable : allProjectDataToTable.filter(item => item.IsPlanStatus == selStatus)"
                      :search="search"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      class="elevation-1"
                      v-if="TypeProject == '1' && TypeProcess == '0'"
                  >
                    <template v-slot:header.full_Name>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        โครงการ
                      </v-label>
                    </template>
                    <template v-slot:header.Project_Status>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        สถานะ
                      </v-label>
                    </template>
                    <template v-slot:item.full_Name="{item}">
                      <div v-html="item.full_Name"></div>
                    </template>
                    <template v-slot:item.Project_Status="{item}">
                      <v-chip
                          x-large
                          v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                          :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                          style="transform: scale(0.8);color: white"
                      >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item.Project_Details="{ item }">
                      <v-btn
                          text
                          color="#FFB300"
                          @click="ShowDetail(item)"
                      >
                        รายละเอียด
                      </v-btn>
                      <v-menu offset-y
                              :value="item.Menu"
                              :close-on-content-click="false"
                              ref="menuRef"
                              v-if="MeData[0].perid == '46792'"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              text
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                          >
                            เมนู
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <v-list-item-title @click="getCreateUrl(item)">
                              <span style="color: #364eff;font-weight: bold">เปิดใช้งานลิงค์รับสมัคร</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <template v-if="!item.IsCopy">
                              <v-list-item-title text @click="Copy(item)">
                                <span style="color: #364eff;font-weight: bold">คัดลอกลิงค์รับสมัคร</span>
                              </v-list-item-title>
                            </template>
                            <template v-else>
                              <CopyToClipboard :text="url">
                                <v-list-item-title @click="CopySuccess">
                                  <span style="font-weight: bold;color: #42b983">คัดลอกลิงค์</span>
                                </v-list-item-title>
                              </CopyToClipboard>
                            </template>
                          </v-list-item>
                          <v-list-item style="cursor: pointer">
                            <v-list-item-title color="red" text
                                               @click="DelProject(item)">
                              <span style="color: red;font-weight: bold">ลบ</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer">
                            <v-list-item-title v-if="MeData[0].perid == '46792'" color="black" text
                                               @click="DelProjectOwner(item)">ลบข้อมูล
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <!--                    <v-btn v-if="MeData[0].perid == '46792'" color="red" text @click="DelProject(item)">-->
                      <!--                      ลบ-->
                      <!--                    </v-btn>-->
                      <!--                    <v-btn v-if="MeData[0].perid == '46792'" color="black" text @click="DelProjectOwner(item)">-->
                      <!--                      ลบข้อมูล-->
                      <!--                    </v-btn>-->
                    </template>
                    <!--<template v-slot:item="{item, isExpanded, expand }">
                        <tr @click="GetData(item, isExpanded , expand)" style="cursor: pointer">
                            <td></td>
                            <td><div class="datatable-cell-wrapper">{{ item.Project_code }}</div></td>
                            <td class="text-xs-right"><div class="datatable-cell-wrapper">{{ item.Project_name }}</div></td>
                        </tr>
                    </template>-->
                    <!--<template v-slot:expanded-item="{ courseHeaders, item }">
                        <td :colspan="3" style="border: 2px solid">
                            <v-list-item>
                                <v-row>
                                    <v-col
                                            cols="12"
                                            md="3">
                                        <v-chip
                                                class="ma-2"
                                                color="green"
                                                text-color="white"
                                        >
                                            รหัสโครงการ :
                                        </v-chip>
                                        <v-label>
                                            {{item.Project_code}}
                                        </v-label>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="9">
                                        <v-chip
                                                class="ma-2"
                                                color="green"
                                                text-color="white"
                                        >
                                            โครงการ :
                                        </v-chip>
                                        <v-label>
                                            {{item.Project_name}}
                                        </v-label>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item>
                                <v-row>
                                    <v-col
                                            cols="12"
                                            md="4">
                                        <v-chip
                                                class="ma-2"
                                                color="green"
                                                text-color="white"
                                        >
                                            ประเภทโครงการ :
                                        </v-chip>
                                        <v-label>
                                            {{item.Project_type_details}}
                                        </v-label>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="4">
                                        <v-chip
                                                class="ma-2"
                                                color="green"
                                                text-color="white"
                                        >
                                            หลักสูตร :
                                        </v-chip>
                                        <v-label style="color: #42b983">
                                            {{item.Course_name}}
                                        </v-label>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="4">
                                        <v-chip
                                                class="ma-2"
                                                color="green"
                                                text-color="white"
                                        >
                                            สาขาประเภทหลักสูตร :
                                        </v-chip>
                                        <v-label>
                                            {{item.Course_type_des}}
                                        </v-label>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item>
                                <v-chip
                                        class="ma-2"
                                        color="red"
                                        text-color="white"
                                >
                                    เงื่อนไขการเข้าร่วมโครงการ
                                </v-chip>
                            </v-list-item>
                            <v-list-item>
                                <v-row
                                        justify="center"
                                        class="d-flex justify-center">
                                    <v-col
                                            class="d-flex justify-center"
                                            cols="12"
                                            md="6">
                                        <v-data-table
                                                :headers="courseHeadersCondi"
                                                :items="courseCondi"
                                                :search="search"
                                                item-key="Course_code"
                                                class="elevation-1"
                                        >
                                            <template v-slot:header.Course_code>
                                                <v-label
                                                        fontSize="16px"
                                                        fontWeight="bold">
                                                    รหัสหลักสูตร
                                                </v-label>
                                            </template>
                                            <template v-slot:header.Course_name>
                                                <v-label
                                                        fontSize="16px"
                                                        fontWeight="bold">
                                                    หลักสูตรที่ต้องผ่าน
                                                </v-label>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <v-row class="d-flex">
                                                    <v-col
                                                            cols="6"
                                                            md="6">
                                                        <v-btn
                                                                outlined
                                                                color="#BF360C"
                                                                @click="DeleteCourse(item)">
                                                            ลบ
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                    <v-col
                                            cols="12"
                                            md="6">
                                        <v-data-table
                                                :headers="dataHeadersCondi"
                                                :items="DataCondi"
                                                :search="search"
                                                item-key="PosWork"
                                                class="elevation-1"
                                        >
                                            <template v-slot:header.PosName>
                                                <v-label
                                                        fontSize="16px"
                                                        fontWeight="bold">
                                                    เงื่อนไขตำแหน่ง, อายุงาน
                                                </v-label>
                                            </template>
                                            <template v-slot:header.Level>
                                                <v-label
                                                        fontSize="16px"
                                                        fontWeight="bold">
                                                    ระดับ
                                                </v-label>
                                            </template>
                                            <template v-slot:header.WSYear>
                                                <v-label
                                                        fontSize="16px"
                                                        fontWeight="bold">
                                                    อายุงานเริ่มต้น
                                                </v-label>
                                            </template>
                                            <template v-slot:header.WEYear>
                                                <v-label
                                                        fontSize="16px"
                                                        fontWeight="bold">
                                                    อายุงานสิ้นสุด
                                                </v-label>
                                            </template>
                                            <template v-slot:item.PosName="{ item }">
                                                <v-label>
                                                    {{item.PosName}}
                                                </v-label>
                                            </template>
                                            <template v-slot:item.Level="{ item }">
                                                <v-label>
                                                    {{item.Level}}
                                                </v-label>
                                            </template>
                                            <template v-slot:item.WSYear="{ item }">
                                                <v-label>
                                                    {{item.WSYear}} (ปี)
                                                </v-label>
                                            </template>
                                            <template v-slot:item.WEYear="{ item }">
                                                <v-label>
                                                    {{item.WEYear}} (ปี)
                                                </v-label>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <v-row class="d-flex">
                                                    <v-col
                                                            cols="6"
                                                            md="6">
                                                        <v-btn
                                                                outlined
                                                                color="#BF360C"
                                                                @click="DeleteDataCondi(item)">
                                                            ลบ
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item>
                                <v-textarea
                                        outlined
                                        name="input-7-4"
                                        label="รายละเอียดประกอบโครงการ"
                                        :value="item.Remarks"
                                        disabled
                                ></v-textarea>
                            </v-list-item>
                        </td>
                    </template>-->
                  </v-data-table>
                  <v-data-table
                      :headers="courseHeaders"
                      :items="typeStatus == '1' ? sortStatus == '1' ? projectDataToTable.filter(item => item.Approve == '1' && (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8' || item.IsPlanStatus == '9')) : projectDataToTable.filter(item => item.Approve == '1' && (item.IsPlanStatus == selStatus)) : sortStatus == '1' ? allProjectDataToTable.filter(item => item.Approve == '0') : projectDataToTable.filter(item => item.Approve == '0' && (item.IsPlanStatus == selStatus))"
                      :search="search2"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      class="elevation-1"
                      v-else-if="TypeProject == '1' && TypeProcess == '1'"
                  >
                    <template v-slot:header.Project_code>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        รหัสโครงการ
                      </v-label>
                    </template>
                    <template v-slot:header.full_Name>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        โครงการ
                      </v-label>
                    </template>
                    <template v-slot:header.Approve>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        อนุมัติ
                      </v-label>
                    </template>
                    <template v-slot:header.Project_Status>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        สถานะ
                      </v-label>
                    </template>
                    <template v-slot:header.Organize_project>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        เสนออนุมัติ
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetRequest>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        งบประมาณ
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetArrove>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        อนุมัติวงเงิน
                      </v-label>
                    </template>
                    <template v-slot:header.MoneyDisburse>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        จำนวนเงินเบิกจ่าย
                      </v-label>
                    </template>
                    <template v-slot:item.full_Name="{item}">
                      <div v-html="item.full_Name"></div>
                    </template>
                    <template v-slot:item.Approve="{item}">
                      <v-chip
                          x-large
                          color="#B39DDB"
                          style="transform: scale(0.8);color: white"
                          v-if="item.Approve == '0'"
                      >
                        หน่วยงาน
                      </v-chip>
                      <v-chip
                          x-large
                          color="#F50057"
                          style="transform: scale(0.8);color: white"
                          v-if="item.Approve == '1'"
                      >
                        คณะ
                      </v-chip>
                    </template>
                    <template v-slot:item.Project_Status="{item}">
                      <v-btn
                          x-large
                          v-if="item.IsPlanStatus == '0'"
                          outlined
                          color="#00C853"
                          style="transform: scale(0.8);"
                          @click="Project_proposal(item)"
                      >
                        เสนอโครงการ
                      </v-btn>
                      <v-chip
                          x-large
                          v-else-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                          :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                          style="transform: scale(0.8);color: white"
                      >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item.Organize_project="{item}">
                      <v-btn
                          x-large
                          v-if="item.Approve == '1' && item.Status == '0' && (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7')"
                          outlined
                          color="primary"
                          style="transform: scale(0.8);"
                          @click="Project_Organ(item)"
                      >
                        <span class="font-weight-bold">เสนออนุมัติ</span>
                      </v-btn>
                      <v-chip
                          x-large
                          color="primary"
                          style="transform: scale(0.8)"
                          v-else-if="item.Approve == '1' && item.Status == '1' && (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8')"
                      >
                        <span style="color: white;font-weight: bold">โครงการถูกเสนออนุมัติ!</span>
                      </v-chip>
                      <!--                    <v-chip-->
                      <!--                        color="#00C853"-->
                      <!--                        style="transform: scale(0.8)"-->
                      <!--                        v-else-if="item.Status == '7'"-->
                      <!--                    >-->
                      <!--                      <span style="color: white;font-weight: bold">อนุมัติ(คณะ)</span>-->
                      <!--                    </v-chip>-->
                    </template>
                    <template v-slot:item.BudgetRequest="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetRequest | currency }}</span>
                    </template>
                    <template v-slot:item.BudgetArrove="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetArrove | currency }}</span>
                    </template>
                    <template v-slot:item.MoneyDisburse="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.MoneyDisburse | currency }}</span>
                    </template>
                    <template v-slot:item.Project_Details="{ item }">
                      <v-btn
                          text
                          color="#FFB300"
                          @click="ShowDetail(item)"
                      >
                        รายละเอียด
                      </v-btn>
                      <v-menu offset-y
                              :value="item.Menu"
                              :close-on-content-click="false"
                              ref="menuRef"
                              v-if="(item.IsPlanStatus != '8' && item.IsPlanStatus != '9')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              text
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                          >
                            เมนู
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <v-list-item-title @click="getCreateUrl(item)">
                              <span style="color: #364eff;font-weight: bold">เปิดใช้งานลิงค์รับสมัคร</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <template>
                              <v-list-item-title text @click="Copy(item)">
                                <span style="color: #364eff;font-weight: bold">QrCode/คัดลอกลิงค์รับสมัคร   </span>
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <template>
                              <v-list-item-title text @click="selectProjectAndShowQrCodeDialog(item)">
                                <span style="color: #364eff;font-weight: bold">QrCode/คัดลอกลิงค์แบบสอบถามความพึงพอใจ   </span>
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                          <!--                        <v-list-item style="cursor: pointer">-->
                          <!--                          <v-list-item-title v-if="MeData[0].perid == '46792'" color="black" text-->
                          <!--                                             @click="DelProjectOwner(item)">ลบข้อมูล-->
                          <!--                          </v-list-item-title>-->
                          <!--                        </v-list-item>-->
                          <v-list-item style="cursor: pointer"
                                       v-if="item.Project_type == '1' && item.Status == '1' && (item.IsPlanStatus == '7')">
                            <v-list-item-title color="black" text @click="updateStatusProject(item, '8')">
                              <span style="color: #42b983;font-weight: bold">ปิดโครงการ</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer"
                                       v-if="(item.IsPlanStatus == '0' || item.IsPlanStatus == '2' || item.IsPlanStatus == '4' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7')">
                            <v-list-item-title color="black" text @click="remarksProject(item, '9')">
                              <span style="color: #ff6d81;font-weight: bold">ยกเลิก</span>
                            </v-list-item-title>
                          </v-list-item>
                          <!-- <v-list-item style="cursor: pointer">
                            <v-list-item-title @click="DelProject(item)">
                              <span style="color: red;font-weight: bold">ลบ</span>
                            </v-list-item-title>
                          </v-list-item> -->
                        </v-list>
                      </v-menu>
                      <!--                    <v-btn v-if="item.Status == '0'" color="red" text @click="DelProject(item)">-->
                      <!--                      ลบ-->
                      <!--                    </v-btn>-->
                      <!--                    <v-btn v-else-if="MeData[0].perid == '46792'" color="red" text @click="DelProject(item)">-->
                      <!--                      ลบ-->
                      <!--                    </v-btn>-->
                      <!--                    <v-btn v-if="MeData[0].perid == '46792'" color="black" text @click="DelProjectOwner(item)">-->
                      <!--                      ลบข้อมูล-->
                      <!--                    </v-btn>-->
                    </template>
                  </v-data-table>
                  <v-data-table
                      :headers="travelHeaders"
                      :items="sortStatus == '1' ? projectDataToTable : projectDataToTable.filter(item => item.IsPlanStatus == selStatus)"
                      :search="search2"
                      item-key="Project_code"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      class="elevation-1"
                      v-else-if="TypeProject == '2'"
                  >
                    <template v-slot:header.full_Name>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        หัวข้อ
                      </v-label>
                    </template>
                    <template v-slot:header.Approve>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        อนุมัติ
                      </v-label>
                    </template>
                    <template v-slot:header.Project_Status>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        สถานะ
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetRequest>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        งบประมาณ
                      </v-label>
                    </template>
                    <template v-slot:header.BudgetArrove>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        อนุมัติวงเงิน
                      </v-label>
                    </template>
                    <template v-slot:header.MoneyDisburse>
                      <v-label
                          fontSize="16px"
                          fontWeight="bold">
                        จำนวนเงินเบิกจ่าย
                      </v-label>
                    </template>
                    <template v-slot:item.full_Name="{item}">
                      <div v-html="item.full_Name"></div>
                    </template>
                    <template v-slot:item.Approve="{item}">
                      <v-chip
                          color="#B39DDB"
                          style="transform: scale(0.8);color: white"
                          v-if="item.Approve == '0'"
                      >
                        หน่วยงาน
                      </v-chip>
                      <v-chip
                          color="#F50057"
                          style="transform: scale(0.8);color: white"
                          v-if="item.Approve == '1'"
                      >
                        คณะ
                      </v-chip>
                    </template>
                    <template v-slot:item.Project_Status="{item}">
                      <v-btn
                          v-if="item.IsPlanStatus == '0'"
                          outlined
                          color="#00C853"
                          style="transform: scale(0.8);"
                          @click="Project_proposal(item)"
                          x-large
                      >
                        เสนออนุมัติ
                      </v-btn>
                      <v-chip
                          x-large
                          v-else-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                          :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                          style="transform: scale(0.8);color: white"
                      >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                      </v-chip>
                    </template>
                    <template v-slot:item.Organize_project="{item}">
                      <v-btn
                          v-if="item.Approve == '1' && item.Status == '0' && (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7')"
                          outlined
                          color="primary"
                          style="transform: scale(0.8);"
                          @click="Project_Organ(item)"
                          x-large
                      >
                        <span class="font-weight-bold">เสนออนุมัติ</span>
                      </v-btn>
                      <v-chip
                          x-large
                          color="primary"
                          style="transform: scale(0.8)"
                          v-else-if="item.Approve == '1' && item.Status == '1' && (item.IsPlanStatus == '2' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8')"
                      >
                        <span style="color: white;font-weight: bold">โครงการถูกเสนออนุมัติ!</span>
                      </v-chip>
                      <!--                    <v-chip-->
                      <!--                        color="#00C853"-->
                      <!--                        style="transform: scale(0.8)"-->
                      <!--                        v-else-if="item.Status == '7'"-->
                      <!--                    >-->
                      <!--                      <span style="color: white;font-weight: bold">อนุมัติ(คณะ)</span>-->
                      <!--                    </v-chip>-->
                    </template>
                    <template v-slot:item.BudgetRequest="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetRequest | currency }}</span>
                    </template>
                    <template v-slot:item.BudgetArrove="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetArrove | currency }}</span>
                    </template>
                    <template v-slot:item.MoneyDisburse="{item}">
                      <span style="font-weight: bold;color: #ff6d81">{{ item.MoneyDisburse | currency }}</span>
                    </template>
                    <template v-slot:item.Project_Details="{ item }">
                      <v-btn
                          text
                          color="#FFB300"
                          @click="ShowDetail(item)"
                      >
                        รายละเอียด
                      </v-btn>
                      <v-menu offset-y
                              :value="item.Menu"
                              :close-on-content-click="false"
                              ref="menuRef"
                              v-if="(item.IsLog != '1' && item.IsPlanStatus != '0' && item.IsPlanStatus != '1' && item.IsPlanStatus != '3' && item.IsPlanStatus != '4' && item.IsPlanStatus != '9' && item.IsPlanStatus != '10' && item.IsPlanStatus != '11')"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              text
                              color="primary"
                              dark
                              v-bind="attrs"
                              v-on="on"
                          >
                            เมนู
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <v-list-item-title @click="getCreateUrl(item)">
                              <span style="color: #364eff;font-weight: bold">เปิดใช้งานลิงค์รับสมัคร</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer" v-if="item.Project_type == '1'">
                            <template>
                              <v-list-item-title text @click="Copy(item)">
                                <span style="color: #364eff;font-weight: bold">QrCode/คัดลอกลิงค์รับสมัคร   </span>
                              </v-list-item-title>
                            </template>
                          </v-list-item>
                          <!--                        <v-list-item style="cursor: pointer">-->
                          <!--                          <v-list-item-title v-if="MeData[0].perid == '46792'" color="black" text-->
                          <!--                                             @click="DelProjectOwner(item)">ลบข้อมูล-->
                          <!--                          </v-list-item-title>-->
                          <!--                        </v-list-item>-->
                          <v-list-item style="cursor: pointer"
                                       v-if="item.Project_type == '1' && item.Status == '1' && (item.IsPlanStatus == '7')">
                            <v-list-item-title color="black" text @click="updateStatusProject(item, '8')">
                              <span style="color: #42b983;font-weight: bold">ปิดโครงการ</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer"
                                       v-if="(item.IsPlanStatus == '0' || item.IsPlanStatus == '2' || item.IsPlanStatus == '4' || item.IsPlanStatus == '5' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7')">
                            <v-list-item-title color="black" text @click="remarksProject(item, '9')">
                              <span style="color: #ff6d81;font-weight: bold">ยกเลิก</span>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item style="cursor: pointer">
                            <v-list-item-title @click="DelProject(item)">
                              <span style="color: red;font-weight: bold">ลบ</span>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                      <!--                    <v-btn v-if="item.Status == '0'" color="red" text @click="DelProject(item)">-->
                      <!--                      ลบ-->
                      <!--                    </v-btn>-->
                      <!--                    <v-btn v-else-if="MeData[0].perid == '46792'" color="red" text @click="DelProject(item)">-->
                      <!--                      ลบ-->
                      <!--                    </v-btn>-->
                      <!--                    <v-btn v-if="MeData[0].perid == '46792'" color="black" text @click="DelProjectOwner(item)">-->
                      <!--                      ลบข้อมูล-->
                      <!--                    </v-btn>-->
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-expand-transition>
          <v-card v-if="Details_Cordi"
                  elevation="10"
          >
            <v-list-item>
              <v-btn
                  outlined
                  color="#FF5722"
                  @click="BackMenu">
                ย้อนกลับ
              </v-btn>
            </v-list-item>
            <template v-if="TypeProject == '1'">
              <div>
                <v-stepper
                    v-model="e1"
                    :vertical="vertical"
                    :alt-labels="altLabels"
                >
                  <v-stepper-step editable step="1">
                    <span style="font-weight: bold;color: black">ข้อมูลโครงการ</span>
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <template v-if="typeStatus == '0'">
                          <v-list-item-title class="headline mb-1"><span>ข้อมูลโครงการ</span>
                          </v-list-item-title>
                          <v-list-item>
                            <v-row justify="space-around">
                              <p>วันที่เริ่มต้นโครงการ</p>
                              <p>วันที่สิ้นสุดโครงการ</p>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row justify="space-around">
                              <v-date-picker
                                  v-model="DateStart"
                                  :landscape="landscape"
                                  :reactive="reactive"
                                  :full-width="fullWidth"
                                  :show-current="showCurrent"
                                  :type="month ? 'month' : 'date'"
                                  :multiple="multiple"
                                  :readonly="readonly"
                                  :disabled="disabled"
                                  locale="th"
                                  :events="enableEvents ? functionEvents : null"
                                  style="border: 1px solid black;border-radius: 5px"
                              ></v-date-picker>

                              <v-date-picker
                                  v-model="DateEnd"
                                  :landscape="landscape"
                                  :reactive="reactive"
                                  :full-width="fullWidth"
                                  :show-current="showCurrent"
                                  :type="month ? 'month' : 'date'"
                                  :multiple="multiple"
                                  :readonly="readonly"
                                  :disabled="disabled"
                                  locale="th"
                                  :events="enableEvents ? functionEvents : null"
                                  style="border: 1px solid black;border-radius: 5px"
                              ></v-date-picker>
                            </v-row>
                          </v-list-item>
                          <v-list-item style="margin-top: 20px">
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="6"
                              >
                                <v-autocomplete
                                    v-model="DepSelect"
                                    label="หน่วยงาน"
                                    :items="depart"
                                    item-text="dep_name"
                                    item-value="dep_id"
                                    disabled
                                >
                                </v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="4"
                              >
                                <v-autocomplete
                                    v-model="FiscalYear"
                                    label="โครงการของปี"
                                    :items="FiscalYearData"
                                    item-text="yearth"
                                    item-value="year"
                                    readonly
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="2"
                              >
                                <v-text-field label="ITEM CODE" readonly v-model="itemCode"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="4"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="Project_code" label="รหัสโครงการ"
                                                :rules="[rules.required]"
                                                hide-details="auto"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="5"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="Project_name" label="ชื่อโครงการ"
                                                :rules="[rules.required]"
                                                hide-details="auto"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="3"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      v-model="Project_group"
                                      :items="projectGroup"
                                      item-value="Project_group"
                                      item-text="Project_group_des"
                                      label="ประเภทโครงการ"
                                      readonly
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="Course_code != null">
                            <v-row>
                              <v-col
                                  cols="12"
                                  md="4"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      :items="courseData"
                                      item-text="Course_name"
                                      item-value="Course_code"
                                      :rules="[rules.required]"
                                      v-model="Course_code"
                                      label="หลักสูตร"
                                      disabled
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="2"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="course_group"
                                      label="สาขาประเภทหลักสูตร"
                                      required
                                      disabled
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="2"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      disabled
                                      :items="period"
                                      item-text="name"
                                      item-value="id"
                                      v-model="Period_code"
                                      label="ระยะเวลา"
                                      :rules="[rules.required]"
                                  ></v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="4"
                              >
                                <div class="d-flex flex-column justify-center align-center">
                                  <v-checkbox
                                      v-model="roundNeed"
                                      required
                                      readonly
                                  >
                                    <template v-slot:label>
                                      <span style="font-weight: bold;color: black">มีการกำหนดรุ่น</span>
                                    </template>
                                  </v-checkbox>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <div v-else align="center" style="padding: 30px">
                                <span style="text-align: center;font-weight: bold;color: #ff6d81;">
                                  ไม่พบข้อมูลหลักสูตร
                                </span>
                          </div>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="CalHourse" label="จำนวน ช.ม"
                                                hide-details="auto"
                                                :rules="[rules.required]"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="CalCredit" label="จำนวน เครดิต"
                                                hide-details="auto"
                                                :rules="[rules.required]"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      :items="PLACESelete"
                                      item-value="id"
                                      item-text="detail"
                                      v-model="PLACE"
                                      label="โครงการถูกจัดขึ้น"
                                      readonly
                                  >
                                  </v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline" v-if="PLACE == '2'">
                                  <v-autocomplete
                                      v-model="Province_id"
                                      :items="provinces_Data"
                                      item-text="name_th"
                                      item-value="code"
                                      label="จังหวัด"
                                      readonly></v-autocomplete>
                                </div>
                                <div class="d-inline" v-if="PLACE == '3'">
                                  <v-autocomplete
                                      v-model="Country_id"
                                      :items="countryData"
                                      item-text="ct_nameTHA"
                                      item-value="ct_code"
                                      label="ประเทศ"
                                      readonly></v-autocomplete>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field v-model="BudgetRequest" label="งบประมาณที่ขอ"
                                                hide-details="auto"
                                                :rules="[rules.required]"
                                                disabled></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-autocomplete
                                      v-model="WorkBy"
                                      label="จัดโดย"
                                      :items="WorkByData"
                                      item-value="id"
                                      item-text="detail"
                                      readonly></v-autocomplete>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="WorkByName"
                                      label="ชื่อผู้จัด"
                                      hide-details="auto"
                                      readonly
                                  ></v-text-field>
                                </div>
                              </v-col>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="WorkByPhone"
                                      label="เบอร์โทรติดต่อผู้กรอกข้อมูล"
                                      hide-details="auto"
                                      readonly
                                  ></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="6"
                                  md="3"
                              >
                                <div class="d-inline">
                                  <v-text-field
                                      v-model="Location"
                                      label="สถานที่จัด"
                                      hide-details="auto"
                                      :rules="[rules.required]"
                                      readonly></v-text-field>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="12"
                              >
                                <div class="d-inline">
                                  <v-textarea
                                      v-model="Objective"
                                      outlined
                                      label="วัตถุประสงค์"
                                      readonly
                                  ></v-textarea>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="12"
                              >
                                <div class="d-inline">
                                  <v-textarea
                                      v-model="TargetGroup"
                                      outlined
                                      label="กลุ่มเป้าหมาย"
                                      readonly
                                  ></v-textarea>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="12"
                              >
                                <div class="d-inline">
                                  <v-textarea
                                      v-model="Remarks"
                                      outlined
                                      name=""
                                      label="รายละเอียดประกอบโครงการ"
                                      value=""
                                      readonly
                                  ></v-textarea>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <v-list-item v-if="FileProject.length > 0">
                            <template>
                              <v-row>
                                <v-col cols="12" sm="6" offset-sm="3">
                                  <v-card>
                                    <v-card-title>
                                      ไฟล์เอกสารประกอบ
                                    </v-card-title>
                                    <v-container fluid>
                                      <v-row>
                                        <v-col
                                            v-for="(file_i, index) in FileProject"
                                            :key="index"
                                            class="d-flex child-flex"
                                            cols="12"
                                            md="4"
                                        >
                                          <v-card flat tile>
                                            <v-img
                                                v-if="file_i.type == 'image'"
                                                :src="file_i.src"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-img
                                                v-if="file_i.type == 'pdf'"
                                                src="../../assets/Image/pdf.png"
                                                :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                              <template v-slot:placeholder>
                                                <v-row
                                                    class="fill-height ma-0"
                                                    align="center"
                                                    justify="center"
                                                >
                                                  <v-progress-circular
                                                      indeterminate
                                                      color="grey lighten-5"></v-progress-circular>
                                                </v-row>
                                              </template>
                                            </v-img>
                                            <v-card-text>
                                                                                                <span
                                                                                                    style="font-weight: bold;color: black">
                                                                                                    {{ file_i.name }}
                                                                                                </span>
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-btn text @click="ShowData(file_i.src)">
                                                                                                    <span
                                                                                                        style="color: indigo;font-weight: bold">
                                                                                                        เรียกดู
                                                                                                    </span>
                                              </v-btn>
                                            </v-card-actions>
                                          </v-card>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-else>
                          <v-list-item style="margin-top: 20px" v-if="ProjectObj != null">
                            <div class="py-4">
                              <v-row>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <p class="font-weight-bold">หน่วยงาน:
                                    {{
                                      (depart.length > 0) ? depart.filter(item => item.dep_id == ProjectObj.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == ProjectObj.Dep_Code)[0].dep_name : '-' : '-'
                                    }}</p>
                                  <p class="font-weight-bold">แผนประจำปี: {{
                                      parseInt(ProjectObj.FiscalYear) + 543
                                    }}</p>
                                  <p class="font-weight-bold" v-if="ProjectObj.Project_type == '2'">ประเภททำรายการ:
                                    {{
                                      ProjectObj.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : ProjectObj.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                    }}</p>
                                  <p class="font-weight-bold">หมวดโครงการ:
                                    {{
                                      ProjectObj.Project_category == '1' ? 'พัฒนาบุคลากร' : ProjectObj.Project_category == '2' ? 'โครงการอื่นๆ' : ProjectObj.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                    }}</p>
                                  <p class="font-weight-bold">ประเภทแผน: {{
                                      ProjectObj.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                    }}</p>
                                  <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                      'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                    }}</p>
                                  <p class="font-weight-bold" v-else-if="episode == '2'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                      'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                    }}</p>
                                  <p class="font-weight-bold" v-else-if="episode == '3'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                      'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                    }}</p>
                                  <p class="font-weight-bold" v-else-if="episode == '4'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                      'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                    }}</p>
                                  <p class="font-weight-bold" v-else-if="episode == '9'">
                                    ระยะเวลาที่คาดว่าจะจัดโครงการ:
                                    {{
                                      'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                    }}</p>
                                  <p class="font-weight-bold"
                                     v-if="ProjectObj.DateStart != null && ProjectObj.DateStart != '0000-00-00'">
                                    วันที่เริ่มต้นจัดงาน: {{ ProjectObj.DateStart | dateToThai }}</p>
                                  <p class="font-weight-bold"
                                     v-if="ProjectObj.DateEnd != null && ProjectObj.DateEnd != '0000-00-00'">
                                    วันที่สิ้นสุดจัดงาน: {{ ProjectObj.DateEnd | dateToThai }}</p>
                                  <p class="font-weight-bold">รหัสโครงการ: {{ ProjectObj.Project_code }}</p>
                                  <p class="font-weight-bold">ชื่อโครงการ: {{ ProjectObj.Project_name }}</p>
                                  <p class="font-weight-bold">ประเภทโครงการ:
                                    {{
                                      projectGroup.filter(item => item.Project_group == ProjectObj.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == ProjectObj.Project_group)[0].Project_group_des : '-'
                                    }}</p>
                                  <p class="font-weight-bold">หลักสูตร:
                                    {{
                                      courseData.filter(item => item.Course_code == ProjectObj.Course_code).length > 0 ? courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Course_name : '-'
                                    }}</p>
                                  <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                    {{
                                      courseData.filter(item => item.Course_code == ProjectObj.Course_code).length > 0 ? courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Course_type_des : '-'
                                    }}</p>
                                  <p class="font-weight-bold">ระยะเวลา:
                                    {{
                                      courseData.filter(item => item.Course_code == ProjectObj.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Period_code)[0].name : '-' : '-'
                                    }}</p>
                                </v-col>
                                <v-col
                                    cols="12"
                                    md="6">
                                  <p class="font-weight-bold">จำนวน ช.ม.: {{ ProjectObj.CalHourse }}</p>
                                  <p class="font-weight-bold">จำนวน เครดิต: {{ ProjectObj.CalCredit }}</p>
                                  <p class="font-weight-bold">งบประมาณที่ขอ: {{ ProjectObj.BudgetRequest }}</p>
                                  <p class="font-weight-bold">โครงการถูกจัดขึ้น: {{
                                      PLACESelete.filter(item => item.id == ProjectObj.PLACE).length > 0 ? PLACESelete.filter(item => item.id == ProjectObj.PLACE)[0].detail : '-'
                                    }}</p>
                                  <p class="font-weight-bold" v-if="ProjectObj.PLACE == '2'">จังหวัด: {{
                                      provinces_Data.filter(item => item.code == ProjectObj.Province_id).length > 0 ? provinces_Data.filter(item => item.code == ProjectObj.Province_id)[0].name_th : '-'
                                    }}</p>
                                  <p class="font-weight-bold" v-else-if="ProjectObj.PLACE == '3'">ประเทศ: {{
                                      countryData.filter(item => item.ct_code == ProjectObj.Country_id).length > 0 ? countryData.filter(item => item.ct_code == ProjectObj.Country_id)[0].ct_nameTHA : '-'
                                    }}</p>
                                  <p class="font-weight-bold">จัดโดย:
                                    {{
                                      WorkByData.filter(item => item.id == ProjectObj.WorkBy).length > 0 ? WorkByData.filter(item => item.id == ProjectObj.WorkBy)[0].detail : '-'
                                    }}</p>
                                  <p class="font-weight-bold">ชื่อผู้จัด: {{ ProjectObj.WorkByName }}</p>
                                  <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{
                                      ProjectObj.WorkByPhone
                                    }}</p>
                                  <p class="font-weight-bold">สถานที่จัด: {{ ProjectObj.Location }}</p>
                                  <p class="font-weight-bold">มีการกำหนดรุ่นในการจัด:
                                    {{ ProjectObj.IsRoundStatus == '0' ? 'ไม่มี' : 'มี' }}</p>
                                  <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ ProjectObj.TargetGroup }}</p>
                                  <p class="font-weight-bold">วัตถุประสงค์: {{ ProjectObj.Objective }}</p>
                                  <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{ ProjectObj.Remarks }}</p>
                                  <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                    <v-btn text color="primary" @click="showCompetency(ProjectObj)">คลิก!!</v-btn>
                                  </p>
                                  <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                    <v-btn text color="primary" @click="showFile()">คลิก!!</v-btn>
                                  </p>
                                </v-col>
                              </v-row>
                              <v-divider></v-divider>
                              <p class="mt-8" style="font-weight: bold">วันที่บันทึกข้อมูลแผนโครงการ:
                                {{ ProjectObj.Create_Time | dateToThai2 }}</p>
                              <p style="font-weight: bold">สถานะแผน:
                                <v-chip
                                    v-if="StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus).length > 0"
                                    :color="StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus)[0].color : ''"
                                    style="transform: scale(0.8);color: white"
                                >
                            <span
                                style="color: white;font-weight: bold;padding: 20px">{{
                                StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus)[0].status : ''
                              }}</span>
                                </v-chip>
                              </p>
                              <template
                                  v-if="parseInt(ProjectObj.IsPlanStatus) >= 6 && parseInt(ProjectObj.IsPlanStatus) <= 9">
                                <hr class="mb-2 mt-2"/>
                                <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                อนุมัติวงเงิน : {{ ProjectObj.BudgetArrove | currency }} บาท
                                      </span>
                                <hr class="mb-2 mt-2"/>
                                <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                จำนวนเงินเบิกจ่าย : {{ ProjectObj.MoneyDisburse | currency }} บาท
                              </span>
                              </template>
                              <v-divider></v-divider>
                            </div>
                          </v-list-item>
                        </template>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="d-flex justify-end">
                      <v-btn
                          color="primary"
                          @click="nextStep(1)"
                      >
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-stepper-content>
                  <v-stepper-step step="2" :editable="typeStatus == '0'"
                                  :disabled="typeStatus == '1'" class="font-weight-bold"
                  >
                    <span style="font-weight: bold;color: black">สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                  </v-stepper-step>
                  <v-stepper-content step="2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1"><span>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                        </v-list-item-title>
                        <v-list-item>
                          <v-row class="d-flex justify-center">
                            <v-col
                                cols="12"
                                md="12"
                            >
                              <v-row class="d-flex justify-center">
                                <v-col
                                    cols="12"
                                    md="12">
                                  <v-list-item class="d-flex justify-center"
                                               style="margin-top: 20px">
                                    <v-col
                                        cols="12"
                                        md="12">
                                      <v-responsive>
                                        <v-spacer></v-spacer>
                                        <v-text-field v-if="CompetencyToShow.length > 0" label="ค้นหา Competency"
                                                      v-model="searchCompe"></v-text-field>
                                      </v-responsive>
                                      <v-responsive>
                                        <v-treeview :activatable="true" :items="CompetencyToShow"
                                                    :search="searchCompe">
                                          <template v-slot:prepend="{ item, open }">
                                            <v-icon v-if="!item.file" color="blue lighten-2">
                                              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                            </v-icon>
                                            <v-icon v-else>
                                              {{ files[item.file] }}
                                            </v-icon>
                                          </template>
                                          <template v-slot:label="{ item, active }">
                                            <div v-if="isMobile" style="cursor: pointer"
                                                 @click="ShowCompeDetail(item)">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                              <span style="font-size: 12px;color: #364eff;font-weight: bold"
                                                    v-else>
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                            <div v-else style="cursor: pointer" @click="ShowCompeDetail(item)">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                              <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                                            </div>
                                          </template>
                                        </v-treeview>
                                      </v-responsive>
                                    </v-col>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red"
                             @click="backStep(1)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn
                          color="primary"
                          @click="nextStep(2)"
                      >
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-stepper-content>
                  <v-stepper-step editable step="3">
                    <span style="font-weight: bold;color: black">คณะทำงาน</span>
                  </v-stepper-step>
                  <v-stepper-content step="3">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1"><span>คณะทำงาน</span>
                        </v-list-item-title>
                        <template v-if="Coordinator.length > 0">
                          <v-list-item>
                            <v-row class="d-flex justify-center">
                              <v-col
                                  cols="12"
                                  md="12"
                              >
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                      md="10">
                                    <v-list-item>
                                      <v-label class="d-flex justify-center">
                                        <!--                                    กรรมการผู้ร่วมโครงการ-->
                                      </v-label>
                                    </v-list-item>
                                    <v-list-item class="d-flex justify-center"
                                                 style="margin-top: 20px">
                                      <v-data-table
                                          :headers="CoordinatorHeader"
                                          :items="Coordinator"
                                          item-key="PosWork"
                                          class="elevation-1"
                                          v-if="Coordinator.length > 0"
                                      >
                                        <template v-slot:header.Name>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            ชื่อ - สกุล
                                          </v-label>
                                        </template>
                                        <template v-slot:header.position_com>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            ตำแหน่ง
                                          </v-label>
                                        </template>
                                        <template v-slot:header.Committee_type>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            สถานะ
                                          </v-label>
                                        </template>
                                        <template v-slot:header.TEL>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            เบอร์โทร
                                          </v-label>
                                        </template>
                                        <template v-slot:header.Lecturer>
                                          <v-label
                                              fontSize="16px"
                                              fontWeight="bold">
                                            วิทยากร/คณะกรรมการ
                                          </v-label>
                                        </template>
                                        <template v-slot:item.position_com="{item}">
                                                    <span v-if="item.Committee_code == '1'" style="color: brown">
                                                        ประธาน
                                                    </span>
                                          <span v-if="item.Committee_code == '2'"
                                                style="color: coral">
                                                        รองประธาน
                                                    </span>
                                          <span v-if="item.Committee_code == '3'"
                                                style="color: darkgoldenrod">
                                                        เลขา
                                                    </span>
                                          <span v-if="item.Committee_code == '4'"
                                                style="color: darkseagreen">
                                                        เหรัญญิก
                                                    </span>
                                          <span v-if="item.Committee_code == '5'"
                                                style="color: darkslategrey">
                                                        กรรมการ
                                                    </span>
                                          <span v-if="item.Committee_code == '6'"
                                                style="color: hotpink">
                                                        วิทยากร
                                                    </span><span v-if="item.Committee_code == '7'" style="color: khaki">
                                                        ที่ปรึกษา
                                                    </span><span v-if="item.Committee_code == '8'" style="color: grey">
                                                        ผู้ทรงคุณวุฒิ
                                                    </span>
                                          <span v-if="item.Committee_code == '9'"
                                                style="color: lightskyblue">
                                                        ผู้ประสานงาน
                                                    </span>
                                        </template>
                                        <template v-slot:item.Committee_type="{item}">
                                                    <span v-if="item.Committee_type == '0'" style="color: darkblue">
                                                        บุคลากรคณะแพทย์
                                                    </span>
                                          <span v-if="item.Committee_type == '1'"
                                                style="color: darkblue">
                                                        บุคลากรคณะอื่น
                                                    </span><span v-if="item.Committee_type == '3'"
                                                                 style="color: darkblue">
                                                        บุคคลภายนอก
                                                    </span>
                                        </template>
                                        <template v-slot:item.Lecturer="{item}">
                                          <v-btn text
                                                 v-if="(item.Committee_code == '6' || item.Committee_code == '23' || item.Committee_code == '24') && item.Committee_type == '0'"
                                                 color="primary" @click="ShowDetailLecturer(item)">
                                            รายละเอียด
                                          </v-btn>
                                        </template>
                                      </v-data-table>
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-list-item>
                        </template>
                        <template v-else>
                          <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                            ไม่พบข้อมูลคณะทำงาน</p>
                        </template>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red"
                             @click="backStep(2)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn
                          color="primary"
                          @click="nextStep(3)"
                      >
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-stepper-content>
                  <v-stepper-step editable step="4">
                    <span style="font-weight: bold;color: black">รายละเอียดค่าใช้จ่าย / การเบิกจ่าย</span>
                  </v-stepper-step>
                  <v-stepper-content step="4">
                    <v-list-item-title class="headline mb-1"><span>รายละเอียดค่าใช้จ่าย / การเบิกจ่าย</span>
                    </v-list-item-title>
                    <v-list-item class="d-flex justify-center">
                      <v-radio-group v-model="TypeBuggetProject" row @change="ChangeTypeBuggetProject">
                        <v-radio
                            label="ประวัติรายละเอียดค่าใช้จ่าย"
                            value="2"
                        ></v-radio>
                        <v-radio
                            label="ประวัติการเบิกจ่าย (คณะ)"
                            value="3"
                        ></v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <template v-if="TypeBuggetProject == '2'">
                      <v-list-item class="mt-4">
                        <template v-if="budgetHistotyData.length > 0">
                          <div
                              class="d-flex flex-column justify-stretch"
                              style="width: 100%"
                          >
                            <v-data-table
                                :headers="budgetHistotyHeader"
                                :items="budgetHistotyData"
                                style="border: 1px solid black"
                            >
                              <template v-slot:item.SumMoney="{ item }">
                                <p style="font-weight: bold">
                                  {{ item.SumMoney | currency }}
                                </p>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <div class="d-flex justify-center">
                                  <v-btn
                                      class="mr-2"
                                      color="primary"
                                      outlined
                                      @click="showHistoryExpense(item)"
                                  >
                                    แสดงรายละเอียด
                                  </v-btn>
                                </div>
                              </template>
                              <template v-slot:footer>
                                <v-divider class="mt-5"></v-divider>
                                <template v-if="BudgetRequest > 0">
                                  <div align="right" style="margin-top: 15px">
                                    <span
                                        style="font-weight: bold;color: #364eff"
                                    >งบประมาณที่ขอ :
                                      {{ BudgetRequest | currency }}</span
                                    >
                                  </div>
                                  <div align="right">
                                    <span
                                        style="font-weight: bold;color: #ff6d81"
                                    >สรุปรายการค่าใช้จ่าย :
                                      {{ ExpenseGroup | currency }}</span
                                    >
                                  </div>
                                  <div align="right">
                                    <span
                                        style="font-weight: bold;color: #42b983"
                                    >คงเหลือ :
                                      {{
                                        (BudgetRequest - ExpenseGroup) | currency
                                      }}</span
                                    >
                                  </div>
                                  <div align="right">
                                    <span
                                        v-if="ExpenseGroup > BudgetRequest"
                                        style="font-weight: bold;color: darkred"
                                    >เกินงบประมาณที่ขอ :
                                      {{
                                        (ExpenseGroup > BudgetRequest
                                            ? ExpenseGroup - BudgetRequest
                                            : 0) | currency
                                      }}</span
                                    >
                                  </div>
                                </template>
                              </template>
                            </v-data-table>
                          </div>
                        </template>
                        <template v-else>
                          <p
                              style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%"
                          >
                            ไม่พบข้อมูลรายละเอียดประวัติค่าใช้จ่าย
                          </p>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-else-if="TypeBuggetProject == '3'">
                      <v-list-item class="mt-4">
                        <template v-if="expenseRealData.length > 0">
                          <div
                              class="d-flex flex-column justify-stretch"
                              style="width: 100%"
                          >
                            <v-data-table
                                :headers="expenseRealHeader"
                                :items="expenseRealData"
                                style="border: 1px solid black"
                            >
                              <template v-slot:item.Mon_total="{ item }">
                                <p style="font-weight: bold">
                                  {{ item.Mon_total | currency }}
                                </p>
                              </template>
                              <template v-slot:item.action="{ item }">
                                <div class="d-flex justify-center">
                                  <v-btn
                                      class="mr-2"
                                      color="primary"
                                      outlined
                                      @click="showHistoryExpenseReal(item)"
                                  >
                                    แสดงรายละเอียด
                                  </v-btn>
                                </div>
                              </template>
                              <template v-slot:footer>
                                <v-divider class="mt-5"></v-divider>
                                <template v-if="ExpenseRealSummay > 0">
                                  <div align="right">
                                    <span
                                        style="font-weight: bold;color: #ff6d81"
                                    >สรุปรายการเบิกจ่าย :
                                      {{ ExpenseRealSummay | currency }}</span
                                    >
                                  </div>
                                </template>
                              </template>
                            </v-data-table>
                          </div>
                        </template>
                        <template v-else>
                          <p
                              style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%"
                          >
                            ไม่พบข้อมูลรายละเอียดการเบิกจ่าย
                          </p>
                        </template>
                      </v-list-item>
                    </template>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red"
                             @click="backStep(3)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn
                          color="primary"
                          @click="nextStep(4)"
                      >
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-stepper-content>
                  <v-stepper-step editable step="5" v-if="!roundNeed">
                    <span style="font-weight: bold;color: black">กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วม</span>
                  </v-stepper-step>
                  <v-stepper-content step="5" v-if="!roundNeed">
                    <v-list-item-title class="headline mb-1"><span>กลุ่มเป้าหมาย</span>
                    </v-list-item-title>
                    <template v-if="DataCondi.length > 0">
                      <v-list-item class="d-flex justify-center">
                        <v-data-table
                            :headers="dataHeadersCondi"
                            :items="DataCondi"
                            :search="search"
                            item-key="PosWork"
                            class="elevation-1 mt-4"
                            v-if="DataCondi.length > 0"
                        >
                          <template v-slot:header.PosName>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              เงื่อนไขตำแหน่ง, อายุงาน
                            </v-label>
                          </template>
                          <template v-slot:header.Level>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ระดับ
                            </v-label>
                          </template>
                          <template v-slot:header.workAgeStart>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              อายุงานเริ่มต้น
                            </v-label>
                          </template>
                          <template v-slot:header.workAgeEnd>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              อายุงานสิ้นสุด
                            </v-label>
                          </template>
                          <template v-slot:item.PosName="{ item }">
                            <v-label>
                              {{ item.PosName }}
                            </v-label>
                          </template>
                          <template v-slot:item.Level="{ item }">
                            <v-label>
                              {{ item.Level }}
                            </v-label>
                          </template>
                          <template
                              v-slot:item.workAgeStart="{ item }">
                            <v-label>
                              {{ item.workAgeStart }} (ปี)
                            </v-label>
                          </template>
                          <template v-slot:item.workAgeEnd="{ item }">
                            <v-label>
                              {{ item.workAgeEnd }} (ปี)
                            </v-label>
                          </template>
                        </v-data-table>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                        -</p>
                    </template>
                    <v-divider class="mt-6"></v-divider>
                    <v-list-item-title class="headline mt-6">
                      <span>เงื่อนไขการเข้าร่วม</span>
                    </v-list-item-title>
                    <v-list-item>
                      <v-list-item-subtitle>
                        สถานะสมัครเข้าร่วม
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>การเปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="ChooseTypRegis == '0'"> : อนุญาตสมัครเข้าร่วมโครงการ</span>
                          <span v-else> : ไม่อนุญาตสมัครเข้าร่วมโครงการ</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center" v-if="ChooseTypRegis == '0'">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>อนุญาตให้สมัครเฉพาะ</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="ChooseTypRegis2 == '0'"> : หน่วยงานและบุคลากรทั่วไป</span>
                          <span v-else-if="ChooseTypRegis2 == '1'"> : หน่วยงาน</span>
                          <span v-else> : บุคลากรทั่วไป</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                        <span v-if="ChooseTypRegis == '0' && (dateRegStart != '0000-00-00' && dateRegStart != null)"> : {{
                            dateRegStart | dateToThai
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                        <span
                            v-if="ChooseTypRegis == '0' && (dateRegEnd != '0000-00-00' && dateRegEnd != null)"> : {{
                            dateRegEnd | dateToThai
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        ผู้เข้าร่วมโครงการ
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>จำกัดจำนวนผู้เข้าร่วมโครงการ</span>
                        </v-col>
                        <v-col
                            md="4"
                            cols="12">
                        <span
                            v-if="ProjectQuotaCount != '' || ProjectQuotaCount != null || ProjectQuotaCount != '0'"> : {{
                            ProjectQuotaCount
                          }} คน</span>
                          <span v-else> : ไม่จำกัด</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        โควตาหน่วยงานที่เข้าร่วม
                      </v-list-item-subtitle>
                    </v-list-item>
                    <template v-if="DepQuotaData.length > 0">
                      <v-list-item class="d-flex justify-center">
                        <v-data-table
                            :headers="DepQuotaHeader"
                            :items="DepQuotaData"
                            :search="searchDepQuota"
                            class="elevation-1 mt-4"
                        >
                          <template v-slot:header.type>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ประเภท
                            </v-label>
                          </template>
                          <template v-slot:header.dep_name>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ภาควิชา/หน่วยงาน
                            </v-label>
                          </template>
                          <template v-slot:header.count>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              จำนวน/คน
                            </v-label>
                          </template>
                          <template
                              v-slot:footer
                          >
                            <template>
                              <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                              </div>
                              <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(ProjectQuotaCount) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                              </div>
                              <div align="center" v-else>
                                <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                              </div>
                              <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  ProjectQuotaCount
                                }} คน</span>
                              </div>
                              <div align="center" v-else>
                                <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                              </div>
                            </template>
                          </template>
                        </v-data-table>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                        -</p>
                    </template>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red"
                             @click="backStep(4)">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn
                          color="primary"
                          @click="nextStep(5)"
                      >
                        ถัดไป
                        <v-icon right>mdi-arrow-right</v-icon>
                      </v-btn>
                    </v-list-item>
                  </v-stepper-content>
                  <v-stepper-step step="6" editable v-if="!roundNeed">
                    <span style="font-weight: bold;color: black">รายชื่อผู้เข้าร่วมโครงการ</span>
                  </v-stepper-step>
                  <v-stepper-content step="6" v-if="!roundNeed">
                    <v-list>
                      <template v-if="JoinPerson.length > 0">
                        <v-card class="mt-7">
                          <v-toolbar
                              color="primary"
                              dark
                              flat
                          >
                            <v-toolbar-title v-if="TypeReg == '0'">รายชื่อผู้เข้าร่วมโครงการ {{ JoinPerson.length }}
                              <span
                                  v-if="!ChkJoinPerson"> / {{ ProjectQuotaCount }}</span> คน
                            </v-toolbar-title>
                            <v-toolbar-title v-else-if="TypeReg == '1'">รายชื่อผู้รอลงทะเบียน {{ JoinPerson.length }}
                              <span> จากผู้เข้าร่วม {{
                                  JoinPersonDump.length
                                }}</span> คน
                            </v-toolbar-title>
                            <v-toolbar-title v-else>รายชื่อผู้ลงทะเบียน {{ JoinPerson.length }}
                              <span> จากผู้เข้าร่วม {{ JoinPersonDump.length }}</span> คน
                            </v-toolbar-title>
                          </v-toolbar>
                          <v-card-title>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="searchPerson"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                v-if="JoinPerson.length > 0"
                            ></v-text-field>
                          </v-card-title>
                          <v-data-table
                              :headers="headersPerson"
                              :items="JoinPerson"
                              :search="searchPerson"
                              v-if="JoinPerson.length > 0"
                          >
                            <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                              <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                              <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                              <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                            </template>
                            <template v-slot:item.status_reg="{item}">
                              <span style="font-weight: bold;color: #364eff"
                                    v-if="item.join_status == '1'">ลงทะเบียน</span>
                              <span style="font-weight: bold;color: #ffd54f" v-else>รอลงทะเบียน</span>
                            </template>
                            <template v-slot:item.action="{item}">
                              <v-btn
                                  color="#F44336"
                                  outlined
                                  @click="Del_item(item)">
                                ลบ
                              </v-btn>
                            </template>
                          </v-data-table>
                        </v-card>
                        <v-list-item class="d-flex justify-center ma-8" v-if="JoinPerson.length > 0">
                          <download-excel
                              class="btn btn-default mr-4"
                              :data="json_data"
                              :fields="json_fields"
                              worksheet="รายชื่อผู้เข้าร่วมโครงการ"
                              :title="array_title"
                              :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"
                          >
                            <v-btn outlined color="green" class="darken-3" @click="ExportEmpData">
                              Export รายชื่อผู้เข้าร่วม (บุคลากร)
                            </v-btn>
                          </download-excel>
                          <download-excel
                              class="btn btn-default mr-4"
                              :data="json_data_export"
                              :fields="json_fields_export"
                              worksheet="รายชื่อผู้เข้าร่วม"
                              :title="array_title"
                              :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'"
                          >
                            <v-btn outlined color="green" class="darken-3" @click="ExportData">
                              Export รายชื่อผู้เข้าร่วม (ทั้งหมด)
                            </v-btn>
                          </download-excel>
                        </v-list-item>
                      </template>
                      <template v-else>
                        <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                          ไม่พบข้อมูลผู้เข้าร่วมโครงการ</p>
                      </template>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red"
                               @click="backStep(5)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(6)"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-stepper-content>
                  <v-stepper-step step="5" editable v-if="roundNeed">
                    <span style="font-weight: bold;color: black">รุ่นในการจัด</span>
                  </v-stepper-step>
                  <v-stepper-content step="5" v-if="roundNeed">
                    <v-list>
                      <v-list-item-title class="headline mb-1"><span>รุ่นในการจัด</span>
                      </v-list-item-title>
                      <template v-if="RoundData.length > 0">
                        <v-list-item class="d-flex justify-center mt-8" v-if="RoundData.length > 0">
                          <v-data-table
                              :headers="roundHeader"
                              :items="RoundData"
                              class="elevation-1 mt-4"
                              style="width: 100%"
                          >
                            <template v-slot:header.round>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                รุ่น
                              </v-label>
                            </template>
                            <template v-slot:header.round_name>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                ชื่อรุ่น
                              </v-label>
                            </template>
                            <template v-slot:header.count_person>
                              <v-label
                                  fontSize="16px"
                                  fontWeight="bold">
                                จำนวนผู้เข้าร่วม
                              </v-label>
                            </template>
                            <template v-slot:item.action="{item}">
                              <div align="center">
                                <v-btn text color="primary" @click="GetRoundDetail(item)">
                                  รายละเอียด
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </v-list-item>
                      </template>
                      <template v-else>
                        <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                          ไม่พบข้อมูลรุ่นในการจัด</p>
                      </template>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red"
                               @click="backStep(4)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(5)"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-stepper-content>
                  <v-stepper-step editable :step="!roundNeed ? '7' : '6'" v-if="TypeProcess == '1'">
                    <span style="font-weight: bold;color: black">ตัวชี้วัด</span>
                  </v-stepper-step>
                  <v-stepper-content :step="!roundNeed ? '7' : '6'" v-if="TypeProcess == '1'">
                    <v-list>
                      <v-list-item-title class="headline mb-1"
                      ><span class="font-weight-bold">ตัวชี้วัด</span>
                      </v-list-item-title>
                      <v-list-item class="mt-8">
                        <p class="font-weight-bold mr-2">
                          ความพึงพอใจ
                          <!-- <span style="color: #ff6d81">( 0 น้อยที่สุด - 5 มากที่สุด)</span> = 
                          <span style="color: #42b983" class="ml-2 mr-2">{{ satisfaction }}</span> คะแนน -->
                        </p>
                      </v-list-item>
                      <v-list-item>
                        <v-radio-group v-model="surveyType" row>
                          <v-radio value="1">
                            <template v-slot:label>
                              <span class="font-weight-bold">ใช้แบบสอบถามมาตรฐานกลาง</span>
                            </template>
                          </v-radio>
                          <v-radio value="2">
                            <template v-slot:label>
                              <span class="font-weight-bold">ใช้แบบสอบถามที่สร้างเอง</span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-list-item>
                      <v-list-item v-if="surveyType == '1'">
                        <v-btn dark class="font-weight-bold mx-2" color="primary" @click="handleShowQrCode">แสดง QR CODE/ลิงค์ แบบสอบถาม</v-btn>
                        <v-btn dark class="font-weight-bold mx-2" color="primary" @click="handleShowQrCode2">แสดง QR CODE/ลิงค์ ผลการตอบแบบสอบถาม</v-btn>
                      </v-list-item>
                      <v-list-item v-else-if="surveyType == '2'">
                        <v-btn dark class="font-weight-bold mx-2" color="green" @click="createSurveyForm">คลิกเพื่อสร้างแบบสอบถาม</v-btn>
                        <v-btn dark class="font-weight-bold mx-2" color="primary" :loading="customAssessLoading" @click="handleShowQrCodeCustom">แสดง QR CODE/ลิงค์ แบบสอบถาม</v-btn>
                        <v-btn dark class="font-weight-bold mx-2" color="primary" :loading="customAssessLoading" @click="handleShowQrCodeCustomResult">แสดง QR CODE/ลิงค์ ผลการตอบแบบสอบถาม</v-btn>
                      </v-list-item>
                      <v-list-item class="mt-4">
                        <p class="font-weight-bold">
                          สมรรถนะ, ความรู้ความสามารถ ผู้เข้าร่วมโครงการ
                        </p>
                      </v-list-item>
                      <v-list-item class="mt-4">
                        <p class="font-weight-bold mt-2">
                          ก่อนข้าร่วมโครงการ
                          <span style="color: #42b983" class="ml-2 mr-2">{{ Knowledge_before }}</span> %
                        </p>
                        <p class="font-weight-bold ml-2 mt-2">
                          หลังข้าร่วมโครงการ
                          <span style="color: #42b983" class="ml-2 mr-2">{{ Knowledge_after }}</span> %
                        </p>
                      </v-list-item>
                      <v-list-item class="mt-4">
                        <p class="font-weight-bold">
                          จำนวนผู้เข้าร่วมโครงการ
                          <span style="color: #42b983" class="ml-2 mr-2">{{ countAllPerson | currency }}</span> คน
                        </p>
                      </v-list-item>
                      <v-list-item class="d-flex justify-end">
                        <v-btn text color="red" v-if="!roundNeed"
                               @click="backStep(6)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn text color="red" v-else
                               @click="backStep(5)">
                          <v-icon left>mdi-arrow-left</v-icon>
                          ย้อนกลับ
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(7)"
                            v-if="!roundNeed"
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="nextStep(6)"
                            v-else
                        >
                          ถัดไป
                          <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-stepper-content>
                  <v-stepper-step editable :step="!roundNeed ? '8' : '7'" v-if="TypeProcess == '1'">
                    <span style="font-weight: bold;color: black">ผลการพิจารณา</span>
                  </v-stepper-step>
                  <v-stepper-content :step="!roundNeed ? '8' : '7'" v-if="TypeProcess == '1'">
                    <v-list-item class="justify-center">
                      <v-row justify="center">
                        <v-col
                            cols="12"
                            md="12">
                          <span style="font-weight: bold">ประวัติการพิจารณาโครงการ</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <template v-if="RecordData.length > 0">
                      <v-list-item class="justify-center">
                        <v-row justify="center">
                          <v-col
                              cols="12"
                              md="12">
                            <v-list-item>
                              <v-expansion-panels popout>
                                <v-expansion-panel
                                    v-for="(item,i) in RecordData"
                                    :key="i"
                                >
                                  <v-expansion-panel-header>
                                    วันที่พิจารณา
                                    <span style="color: #364eff;margin-left: 15px">{{
                                        item.Date_Approve | DateToThai
                                      }}</span>
                                    สถานะ :
                                    <v-chip
                                        v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                        :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                        style="transform: scale(0.8);color: white"
                                        class="d-flex justify-center"
                                    >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                    </v-chip>
                                  </v-expansion-panel-header>
                                  <v-expansion-panel-content>
                                    <p>
                                      เหตุผล : {{ item.Remark }}
                                    </p>
                                    <div v-for="(file,idx) in item.files" v-bind:key="idx" style="color: #ff6d81">
                                      ไฟล์ประกอบ :
                                      <v-btn text @click="ShowData(Openfile + file.File_path)">
                                        {{ file.File_name | truncateText }}
                                      </v-btn>
                                    </div>
                                  </v-expansion-panel-content>
                                </v-expansion-panel>
                              </v-expansion-panels>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </template>
                    <template v-else>
                      <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
                        ไม่พบข้อมูลการพิจารณาโครงการ</p>
                    </template>
                    <v-list-item class="d-flex justify-end">
                      <v-btn text color="red"
                             @click="backStep(7)" v-if="!roundNeed">
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                      <v-btn text color="red"
                             @click="backStep(6)" v-else>
                        <v-icon left>mdi-arrow-left</v-icon>
                        ย้อนกลับ
                      </v-btn>
                    </v-list-item>
                  </v-stepper-content>
                </v-stepper>
              </div>
            </template>
            <template v-else-if="TypeProject == '2'">
              <div>
                <v-stepper
                    v-model="e1"
                    :vertical="vertical"
                    :alt-labels="altLabels"
                >
                  <v-stepper-step editable step="1">
                    <span
                        style="font-weight: bold">{{
                        ((ProjectObj != null && ProjectObj.Project_type == '1') ? 'ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี' : 'ข้อมูลการอบรม/เดินทางไปปฏิบัติงาน')
                      }}</span>
                  </v-stepper-step>
                  <v-stepper-content step="1">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-row>
                          <v-col
                              cols="12"
                              md="12">
                            <h2 class="font-weight-bold" style="color: #ff6d81" v-if="TypeProject == '1'">
                              {{ tab == '0' ? 'รายละเอียด' : 'ข้อมูลแผน (เดิม)' }}</h2>
                            <v-list-item style="margin-top: 20px;width: 100%" v-if="ProjectObj != null">
                              <v-row>
                                <v-divider vertical></v-divider>
                                <v-col
                                    cols="12"
                                    md="5">
                                  <p class="font-weight-bold" style="color: blue">หน่วยงาน:
                                    <span style="color: black">{{
                                        depart.filter(item => item.dep_id == ProjectObj.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == ProjectObj.Dep_Code)[0].dep_name : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ข้อมูลประจำปี:
                                    <span style="color: black">{{
                                        parseInt(ProjectObj.FiscalYear) + 543
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="ProjectObj.Project_type == '2'">
                                    <p class="font-weight-bold" style="color: blue">
                                      ประเภททำรายการ:
                                      <span style="color: black">{{
                                          ProjectObj.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : ProjectObj.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                    <p class="font-weight-bold" style="color: blue">
                                      ประเภทค่าใช้จ่าย:
                                      <span style="color: black">{{
                                          ProjectObj.IsExpense == '1' ? 'มีค่าใช้จ่าย' : ProjectObj.IsExpense == '0' ? 'ไม่มีค่าใช้จ่าย' : '-'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                    <p class="font-weight-bold" style="color: blue">
                                      ประเภทการไปปฏิบัติราชการ:

                                      <span style="color: black">{{
                                          projectGroup.filter(item => item.Project_group == ProjectObj.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == ProjectObj.Project_group)[0].Project_group_des : '-'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">หมวด:
                                    <span style="color: black">{{
                                        ProjectObj.Project_category == '1' ? 'พัฒนาบุคลากร' : ProjectObj.Project_category == '2' ? 'โครงการอื่นๆ' : ProjectObj.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="ProjectObj.Project_type == '1'">
                                    <p class="font-weight-bold" style="color: blue">ประเภทแผน:
                                      <span style="color: black">{{
                                          ProjectObj.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                        }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <template v-if="ProjectObj.Project_type == '1'">
                                    <template v-if="episode == '1'">
                                      <p class="font-weight-bold" style="color: blue">ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '2'">
                                      <p class="font-weight-bold" style="color: blue">
                                        ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '3'">
                                      <p class="font-weight-bold" style="color: blue">
                                        ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '4'">
                                      <p class="font-weight-bold" style="color: blue">
                                        ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                    <template v-else-if="episode == '9'">
                                      <p class="font-weight-bold" style="color: blue">ระยะเวลาที่คาดว่าจะจัด:
                                        <span style="color: black">{{
                                            'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </template>
                                  </template>
                                  <template v-else-if="ProjectObj.Project_type == '2'">
                                    <p class="font-weight-bold" style="color: blue">วันที่จัด:
                                      <span style="color: black" v-if="ProjectObj.DateStart == ProjectObj.DateEnd">{{
                                          ProjectObj.DateStart | dateToThai
                                        }}</span>
                                      <span style="color: black" v-else>{{
                                          ProjectObj.DateStart | dateToThai
                                        }} - {{
                                          ProjectObj.DateEnd | dateToThai
                                        }}</span>
                                    </p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">รหัสอบรม/เดินทาง: <span
                                      style="color: black">{{ ProjectObj.Project_code }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ชื่องาน / กิจจกรม:
                                    <span style="color: black">{{
                                        ProjectObj.Project_name
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">
                                    {{ ProjectObj.Project_type == '1' ? 'ประเภทแผน' : 'ประเภทการไปปฏิบัติราชการ' }}:
                                    <span style="color: black">{{
                                        projectGroup.filter(item => item.Project_group == ProjectObj.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == ProjectObj.Project_group)[0].Project_group_des : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">หลักสูตร:
                                    <span style="color: black">{{
                                        courseData.filter(item => item.Course_code == ProjectObj.Course_code).length > 0 ? courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Course_name : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">สาขาประเภทหลักสูตร:
                                    <span style="color: black">{{
                                        courseData.filter(item => item.Course_code == ProjectObj.Course_code).length > 0 ? courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Course_type_des : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ระยะเวลา:
                                    <span style="color: black">{{
                                        courseData.filter(item => item.Course_code == ProjectObj.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == ProjectObj.Course_code)[0].Period_code)[0].name : '-' : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                </v-col>
                                <v-divider vertical></v-divider>
                                <v-col
                                    cols="12"
                                    md="5">
                                  <p class="font-weight-bold" style="color: blue">จำนวน ช.ม.: <span
                                      style="color: black">{{ ProjectObj.CalHourse }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">จำนวน เครดิต: <span
                                      style="color: black">{{ ProjectObj.CalCredit }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">งบประมาณที่ขอ: <span
                                      style="color: black">{{ ProjectObj.BudgetRequest | currency }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">งานถูกจัดขึ้น: <span
                                      style="color: black">{{
                                      PLACESelete.filter(item => item.id == ProjectObj.PLACE).length > 0 ? PLACESelete.filter(item => item.id == ProjectObj.PLACE)[0].detail : '-'
                                    }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="ProjectObj.PLACE == '2'">
                                    <p class="font-weight-bold" style="color: blue">จังหวัด: <span style="color: black">{{
                                        provinces_Data.filter(item => item.code == ProjectObj.Province_id).length > 0 ? provinces_Data.filter(item => item.code == ProjectObj.Province_id)[0].name_th : '-'
                                      }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <template v-else-if="ProjectObj.PLACE == '3'">
                                    <p class="font-weight-bold" style="color: blue">ประเทศ: <span style="color: black">{{
                                        countryData.filter(item => item.ct_code == ProjectObj.Country_id).length > 0 ? countryData.filter(item => item.ct_code == ProjectObj.Country_id)[0].ct_nameTHA : '-'
                                      }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">จัดโดย:
                                    <span style="color: black">{{
                                        WorkByData.filter(item => item.id == ProjectObj.WorkBy).length > 0 ? WorkByData.filter(item => item.id == ProjectObj.WorkBy)[0].detail : '-'
                                      }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ชื่อผู้จัด: <span
                                      style="color: black">{{ ProjectObj.WorkByName }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">เบอร์โทรติดต่อผู้กรอกข้อมูล:
                                    <span style="color: black">{{ ProjectObj.WorkByPhone }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">สถานที่จัด: <span
                                      style="color: black">{{ ProjectObj.Location }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="ProjectObj.Project_type == '1'">
                                    <p class="font-weight-bold" style="color: blue">กลุ่มเป้าหมาย: <span
                                        style="color: black">{{ ProjectObj.TargetGroup }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                    <p class="font-weight-bold" style="color: blue">วัตถุประสงค์: <span
                                        style="color: black">{{ ProjectObj.Objective }}</span></p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                  <p class="font-weight-bold" style="color: blue">รายละเอียดประกอบ (เพิ่มเติม):
                                    <span style="color: black">{{ ProjectObj.Remarks }}</span></p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">Competency,Core Value,Strategic
                                    Objective:
                                    <v-btn text color="primary" @click="showCompetency(ProjectObj)">คลิก!!</v-btn>
                                  </p>
                                  <v-divider class="ma-4"></v-divider>
                                  <p class="font-weight-bold" style="color: blue">ไฟล์เอกสารประกอบ:
                                    <v-btn text color="primary" @click="showFile()">คลิก!!</v-btn>
                                  </p>
                                  <v-divider class="ma-4"></v-divider>
                                  <template v-if="ProjectObj.Project_type == '2'">
                                    <p class="font-weight-bold" style="color: blue"
                                       v-if="ProjectObj.Project_type == '2'">ผู้เข้าร่วมจำนวน {{ JoinTravel.length }}
                                      คน:
                                      <v-btn text color="primary" v-if="JoinTravel.length > 0"
                                             @click="showJoinTravel()">คลิก!!
                                      </v-btn>
                                    </p>
                                    <p class="font-weight-bold" style="color: blue"
                                       v-if="ProjectObj.Project_type == '2'">เอกสารแบบฟอร์มเสนอ (จากระบบ):
                                      <v-btn text color="primary" @click="showFileReport(ProjectObj)">คลิก!!</v-btn>
                                    </p>
                                    <v-divider class="ma-4"></v-divider>
                                  </template>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item>
                              <p class="mt-8" style="font-weight: bold">
                                <span v-if="ProjectObj.Project_type == '1'">วันที่บันทึกข้อมูลแผน:</span>
                                <span v-else-if="ProjectObj.Project_type == '2'">วันที่บันทึกข้อมูล:</span>
                                {{ ProjectObj.Create_Time | dateToThai2 }}</p>
                            </v-list-item>
                            <v-list-item>
                              <p style="font-weight: bold">สถานะ:
                                <v-chip
                                    v-if="StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus).length > 0"
                                    :color="StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus)[0].color : ''"
                                    style="transform: scale(0.8);color: white"
                                >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == ProjectObj.IsPlanStatus)[0].status : ''
                              }}</span>
                                </v-chip>
                              </p>
                            </v-list-item>
                            <v-list-item
                                v-if="parseInt(ProjectObj.IsPlanStatus) >= 6 && parseInt(ProjectObj.IsPlanStatus) <= 9">
                              <hr class="mb-2 mt-2"/>
                              <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                อนุมัติวงเงิน : {{ ProjectObj.BudgetArrove | currency }} บาท
                              </span>
                            </v-list-item>
                            <v-list-item
                                v-if="parseInt(ProjectObj.IsPlanStatus) >= 6 && parseInt(ProjectObj.IsPlanStatus) <= 9">
                              <hr class="mb-2 mt-2"/>
                              <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                จำนวนเงินเบิกจ่าย : {{ ProjectObj.MoneyDisburse | currency }} บาท
                              </span>
                            </v-list-item>
                            <v-list-item>
                              <v-card style="border: 1px solid;width: 100%">
                                <v-toolbar
                                    dark
                                    :color="appColor">
                                  <span>ประวัติสถานะขอเดินทางไปปฏิบัติราชการ</span>
                                </v-toolbar>
                                <template v-if="RecordDataDump.length > 0">
                                  <v-list-item class="justify-center">
                                    <v-row justify="center">
                                      <v-col
                                          cols="12"
                                          md="12">
                                        <v-list-item>
                                          <v-expansion-panels popout>
                                            <v-expansion-panel
                                                v-for="(item,i) in RecordDataDump"
                                                :key="i"
                                            >
                                              <v-expansion-panel-header>
                                                <span
                                                    style="color: #364eff;margin-left: 15px">{{
                                                    item.Date_Approve | DateToThai
                                                  }}</span>
                                                สถานะ :
                                                <v-chip
                                                    v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                    :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                    style="transform: scale(0.8);color: white"
                                                    class="d-flex justify-center"
                                                >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                                </v-chip>
                                              </v-expansion-panel-header>
                                              <v-expansion-panel-content>
                                                <p>
                                                  เหตุผล : {{ item.Remark }}
                                                </p>
                                                <div v-for="(file,idx) in item.files"
                                                     v-bind:key="idx"
                                                     style="color: #ff6d81">
                                                  ไฟล์ประกอบ :
                                                  <v-btn text
                                                         @click="ShowData(Openfile + file.File_path)">
                                                    {{ file.File_name | truncateText }}
                                                  </v-btn>
                                                </div>
                                              </v-expansion-panel-content>
                                            </v-expansion-panel>
                                          </v-expansion-panels>
                                        </v-list-item>
                                      </v-col>
                                    </v-row>
                                  </v-list-item>
                                </template>
                                <template v-else>
                                  <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                    ไม่พบข้อมูลประวัติผลการพิจารณาการ อบรม/เดินทางไปปฏิบัติราชการ !!</p>
                                </template>
                              </v-card>
                            </v-list-item>
                          </v-col>
                          <v-divider vertical></v-divider>
                          <v-col
                              cols="12"
                              md="12"
                              v-if="tab == '1'"
                          >
                            <h2 class="font-weight-bold" style="color: #ff6d81">ข้อมูลแผน (แก้ไขใหม่)</h2>
                            <v-list-item style="margin-top: 20px">
                              <div class="py-4">
                                <v-row>
                                  <v-col
                                      cols="12"
                                      md="6">
                                    <p class="font-weight-bold">หน่วยงาน:
                                      {{
                                        depart.filter(item => item.dep_id == Project.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == Project.Dep_Code)[0].dep_name : '-'
                                      }}</p>
                                    <p class="font-weight-bold">แผนประจำปี: {{
                                        parseInt(Project.FiscalYear) + 543
                                      }}</p>
                                    <p class="font-weight-bold" v-if="Project.Project_type == '2'">ประเภททำรายการ:
                                      {{
                                        Project.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : Project.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : ' เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                      }}</p>
                                    <p class="font-weight-bold">หมวด:
                                      {{
                                        Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                      }}</p>
                                    <p class="font-weight-bold">ประเภทแผน: {{
                                        Project.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                      }}</p>
                                    <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '2'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '3'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '4'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="episode == '9'">
                                      ระยะเวลาที่คาดว่าจะจัด:
                                      {{
                                        'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                      }}</p>
                                    <p class="font-weight-bold">รหัสแผน: {{ Project.Project_code }}</p>
                                    <p class="font-weight-bold">ชื่องาน / กิจจกรม: {{ Project.Project_name }}</p>
                                    <p class="font-weight-bold">ประเภทแผน:
                                      {{
                                        projectGroup.filter(item => item.Project_group == Project.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project.Project_group)[0].Project_group_des : '-'
                                      }}</p>
                                    <p class="font-weight-bold">หลักสูตร:
                                      {{
                                        courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project.Course_code)[0].Course_name : '-'
                                      }}</p>
                                    <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                      {{
                                        courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project.Course_code)[0].Course_type_des : '-'
                                      }}</p>
                                    <p class="font-weight-bold">ระยะเวลา:
                                      {{
                                        courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project.Course_code)[0].Period_code)[0].name : '-' : '-'
                                      }}</p>
                                  </v-col>
                                  <v-col
                                      cols="12"
                                      md="6">
                                    <p class="font-weight-bold">จำนวน ช.ม.: {{ Project.CalHourse }}</p>
                                    <p class="font-weight-bold">จำนวน เครดิต: {{ Project.CalCredit }}</p>
                                    <p class="font-weight-bold">งบประมาณที่ขอ: {{ Project.BudgetRequest }}</p>
                                    <p class="font-weight-bold">งานถูกจัดขึ้น: {{
                                        PLACESelete.filter(item => item.id == Project.PLACE).length > 0 ? PLACESelete.filter(item => item.id == Project.PLACE)[0].detail : '-'
                                      }}</p>
                                    <p class="font-weight-bold" v-if="Project.PLACE == '2'">จังหวัด: {{
                                        provinces_Data.filter(item => item.code == Project.Province_id).length > 0 ? provinces_Data.filter(item => item.code == Project.Province_id)[0].name_th : '-'
                                      }}</p>
                                    <p class="font-weight-bold" v-else-if="Project.PLACE == '3'">ประเทศ: {{
                                        countryData.filter(item => item.ct_code == Project.Country_id).length > 0 ? countryData.filter(item => item.ct_code == Project.Country_id)[0].ct_nameTHA : '-'
                                      }}</p>
                                    <p class="font-weight-bold">จัดโดย:
                                      {{
                                        WorkByData.filter(item => item.id == Project.WorkBy).length > 0 ? WorkByData.filter(item => item.id == Project.WorkBy)[0].detail : '-'
                                      }}</p>
                                    <p class="font-weight-bold">ชื่อผู้จัด: {{ Project.WorkByName }}</p>
                                    <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{
                                        Project.WorkByPhone
                                      }}</p>
                                    <p class="font-weight-bold">สถานที่จัด: {{ Project.Location }}</p>
                                    <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ Project.TargetGroup }}</p>
                                    <p class="font-weight-bold">วัตถุประสงค์: {{ Project.Objective }}</p>
                                    <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{
                                        Project.Remarks
                                      }}</p>
                                    <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                      <v-btn text color="primary" @click="showTempCompetency(Project)">คลิก!!
                                      </v-btn>
                                    </p>
                                    <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                      <v-btn text color="primary" @click="showTempFile(Project)">คลิก!!</v-btn>
                                    </p>
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <p class="mt-8" style="font-weight: bold">วันที่บันทึกข้อมูลขอแก้ไขแผน:
                                  {{ Project.Create_Time | dateToThai2 }}</p>
                                <v-divider></v-divider>
                              </div>
                            </v-list-item>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-end">
                    </v-list-item>
                  </v-stepper-content>
                  <template v-if="tab == '0'">
                    <template
                        v-if="(ProjectObj.IsPlanStatus != '0' && ProjectObj.IsPlanStatus != '4' && ProjectObj.IsPlanStatus != '8' && ProjectObj.IsPlanStatus != '9') && (ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                      <v-stepper-step step="2" editable>
                        <span
                            class="font-weight-bold">พิจารณาแผน</span>
                      </v-stepper-step>
                      <v-stepper-content step="2">
                        <v-card style="border: 1px solid">
                          <template v-if="RecordDataDump.length > 0">
                            <v-list-item class="justify-center">
                              <v-row justify="center">
                                <v-col
                                    cols="12"
                                    md="12">
                                  <v-list-item>
                                    <v-expansion-panels popout>
                                      <v-expansion-panel
                                          v-for="(item,i) in RecordDataDump"
                                          :key="i"
                                      >
                                        <v-expansion-panel-header>
                                          ประวัติการพิจารณาแผน
                                          วันที่พิจารณา
                                          <span
                                              style="color: #364eff;margin-left: 15px">{{
                                              item.Date_Approve | DateToThai
                                            }}</span>
                                          สถานะ :
                                          <v-chip
                                              v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                              :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                              style="transform: scale(0.8);color: white"
                                              class="d-flex justify-center"
                                          >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                          </v-chip>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                          <p>
                                            เหตุผล : {{ item.Remark }}
                                          </p>
                                          <div v-for="(file,idx) in item.files"
                                               v-bind:key="idx"
                                               style="color: #ff6d81">
                                            ไฟล์ประกอบ :
                                            <v-btn text
                                                   @click="ShowData(Openfile + file.File_path)">
                                              {{ file.File_name | truncateText }}
                                            </v-btn>
                                          </div>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-list-item>
                          </template>
                          <template v-else>
                            <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                              ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                          </template>
                        </v-card>
                      </v-stepper-content>
                    </template>
                  </template>
                </v-stepper>
              </div>
            </template>
          </v-card>
        </v-container>
      </v-card>
      <template>
        <v-dialog v-model="dialogProposal" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>
            <v-card-text>ต้องการยื่นเสนออนุมัติโครงการใช่หรือไม่ ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogProposal = false">ยกเลิก</v-btn>
              <v-btn color="green darken-1" text @click="proposal_To_Db">ตกลง</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog v-model="dialogOrganProj" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>
            <v-card-text v-if="projOgan != null">ต้องการเสนออนุมัติโครงการ {{ projOgan.Project_name }} ใช่หรือไม่ ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogOrganProj = false">ยกเลิก</v-btn>
              <v-btn color="green darken-1" text @click="Organize_project_exec">ตกลง</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span
                style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-if="item.Lecturer != null" style="margin-top: 25px">
                      <span style="font-weight: bold">
                        รายละเอียดเพิ่มเติมการเป็นวิทยากร (เพิ่มเติม)
                      </span>
                      <v-list v-for="(lec, idx) in item.Lecturer" v-bind:key="idx">
                        <v-list-item>
                          โครงการ : {{ lec.lec_project_name }}
                        </v-list-item>
                        <v-list-item>
                          จำนวน ช.ม. : {{ lec.lec_hour }}
                        </v-list-item>
                        <v-list-item>
                          ผู้เชิญ : {{ lec.lec_invite }}
                        </v-list-item>
                        <v-list-item>
                          วันที่เริ่มต้นเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{ lec.lec_date_start | dateToThai }}
                        </v-list-item>
                        <v-list-item>
                          เวลาเริ่มการบรรยาย : {{ lec.lec_time_start }} น.
                        </v-list-item>
                        <v-list-item>
                          วันที่สิ้นสุดเป็นวิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน : {{ lec.lec_date_end | dateToThai }}
                        </v-list-item>
                        <v-list-item>
                          เวลาสิ้นสุดการบรรยาย : {{ lec.lec_time_time_end }} น.
                        </v-list-item>
                        <v-list-item>
                          สถุานที่ : {{ lec.lec_place }}
                        </v-list-item>
                        <v-list-item>
                          เลขที่หนังสือ : {{ lec.lec_docno }}
                        </v-list-item>
                        <v-list-item>
                          วันที่ออกหนังสือ : {{ lec.lec_datedocno }}
                        </v-list-item>
                        <v-divider></v-divider>
                      </v-list>
                    </div>
                    <div v-if="item.File_path != null">
                      <v-btn color="primary" text @click="ShowData(Openfile + item.File_path)">ไฟล์ : {{
                          item.File_name | truncateText
                        }}
                      </v-btn>
                    </div>
                    <div style="margin-bottom: 25px">
                      รายละเอียด : {{ item.Rm }}
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_travel_start="{item}">
                <span v-if="item.date_travel_start != '0000-00-00' && item.date_travel_start != null">{{
                    item.date_travel_start | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.date_travel_end="{item}">
                <span v-if="item.date_travel_end != '0000-00-00' && item.date_travel_end != null">{{
                    item.date_travel_end | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.date_start="{item}">
                <span v-if="item.date_start != '0000-00-00' && item.date_start != null">{{
                    item.date_start | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.date_end="{item}">
                <span v-if="item.date_end != '0000-00-00' && item.date_end != null">{{
                    item.date_end | dateToThai
                  }}</span>
                </template>
                <template v-slot:item.time_start="{item}">
                  <span v-if="item.time_start != '00:00:00' && item.time_start != null">{{ item.time_start }}</span>
                </template>
                <template v-slot:item.time_end="{item}">
                  <span v-if="item.time_end != '00:00:00' && item.time_end != null">{{ item.time_end }}</span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template>
        <v-dialog
            v-model="dialogGroupDetail"
            width="500"
        >
          <v-card>
            <v-card-title class="headline grey lighten-2" v-if="groupDetail != null">
              <span style="font-weight: bold">{{ groupDetail.group_name }}</span>
            </v-card-title>

            <v-card-text v-if="groupQuataDump.length > 0">
              <div v-for="(qroup, idx) in groupQuataDump" :key="idx" style="color: black" class="pa-2">
                <span>{{ idx + 1 }} - {{ qroup.dep_name }} จำนวนผู้เข้าร่วม : {{ qroup.count }} คน</span>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red"
                  text
                  @click="dialogGroupDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogRound"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar
              dark
              color="primary"
              dense fixed
          >
            <v-btn
                icon
                dark
                @click="dialogRound = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>กำหนดรุ่นการจัด</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  class="text-h4 darken-4"
                  @click="dialogRound = false"
                  style="background-color: red"
              >
                ยกเลิก
              </v-btn>
            </v-toolbar-items>
          </v-app-bar>
          <v-row class="d-flex justify-center mt-10">
            <v-col
                cols="12"
                md="8">
              <v-tabs
                  color="red darken-3"
                  show-arrows
                  v-model="tabs"
              >
                <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
                <v-tab
                    key="CoriTab"
                >
                  รุ่น/กลุ่มเป้าหมาย/เงื่อนไขการเข้าร่วมโครงการ
                </v-tab>
                <v-tab
                    key="JoinTab"
                >
                  ผู้เข้าร่วมโครงการ
                  <v-chip color="red" dark class="ml-3">
                    {{ JoinPerson.length }}
                  </v-chip>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs">
                <v-tab-item
                    key="CoriTab"
                >
                  <v-list>
                    <v-list-item-title class="headline mb-1">
                      รุ่นโครงการ
                    </v-list-item-title>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>รุ่นที่</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span> : {{ round }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>ชื่อรุ่น</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span> : {{ round_name }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เริ่มต้น</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="dateRegS != '' && dateRegS != '0000-00-00'"> : {{ dateRegS | dateToThai }}</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่สิ้นสุด</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="dateRegE != '' && dateRegE != '0000-00-00'"> : {{ dateRegE | dateToThai }}</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>เวลาเริ่มต้น</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="time_start != '00:00:00'"> : {{ time_start }} น.</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>เวลาสิ้นสุด</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="time_end != '00:00:00'"> : {{ time_end }} น.</span>
                          <span v-else> : -</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item-title class="headline mt-1">กลุ่มเป้าหมาย
                    </v-list-item-title>
                    <v-list-item class="d-flex justify-center">
                      <v-data-table
                          :headers="dataHeadersCondi"
                          :items="DataCondi"
                          :search="search"
                          item-key="PosWork"
                          class="elevation-1 mt-4"
                          v-if="DataCondi.length > 0"
                      >
                        <template v-slot:header.PosName>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            เงื่อนไขตำแหน่ง, อายุงาน
                          </v-label>
                        </template>
                        <template v-slot:header.Level>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ระดับ
                          </v-label>
                        </template>
                        <template v-slot:header.workAgeStart>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อายุงานเริ่มต้น
                          </v-label>
                        </template>
                        <template v-slot:header.workAgeEnd>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อายุงานสิ้นสุด
                          </v-label>
                        </template>
                        <template v-slot:item.PosName="{ item }">
                          <v-label>
                            {{ item.PosName }}
                          </v-label>
                        </template>
                        <template v-slot:item.Level="{ item }">
                          <v-label>
                            {{ item.Level }}
                          </v-label>
                        </template>
                        <template
                            v-slot:item.workAgeStart="{ item }">
                          <v-label>
                            {{ item.workAgeStart }} (ปี)
                          </v-label>
                        </template>
                        <template v-slot:item.workAgeEnd="{ item }">
                          <v-label>
                            {{ item.workAgeEnd }} (ปี)
                          </v-label>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-row class="d-flex">
                            <v-col
                                cols="6"
                                md="6">
                              <v-btn
                                  outlined
                                  color="#BF360C"
                                  @click="DeleteDataCondi(item)">
                                ลบ
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                      </v-data-table>
                    </v-list-item>
                    <v-divider class="mt-6"></v-divider>
                    <v-list-item-title class="headline mt-6">
                      เงื่อนไขการเข้าร่วม
                    </v-list-item-title>
                    <v-list-item>
                      <v-list-item-subtitle>
                        สถานะสมัครเข้าร่วม
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>การเปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="ChooseTypRegis == '0'"> : อนุญาตสมัครเข้าร่วม</span>
                          <span v-else> : ไม่อนุญาตสมัครเข้าร่วม</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center" v-if="ChooseTypRegis == '0'">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>อนุญาตให้สมัครเฉพาะ</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                          <span v-if="ChooseTypRegis2 == '0'"> : หน่วยงานและบุคลากรทั่วไป</span>
                          <span v-else-if="ChooseTypRegis2 == '1'"> : หน่วยงาน</span>
                          <span v-else> : บุคลากรทั่วไป</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                        <span v-if="ChooseTypRegis == '0' && (dateRegStart != '0000-00-00' && dateRegStart != null)"> : {{
                            dateRegStart | dateToThai
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>วันที่เปิดรับสมัคร</span>
                        </v-col>
                        <v-col
                            md="6"
                            cols="12">
                        <span
                            v-if="ChooseTypRegis == '0' && (dateRegEnd != '0000-00-00' && dateRegEnd != null)"> : {{
                            dateRegEnd | dateToThai
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        ผู้เข้าร่วม
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-row>
                        <v-col
                            md="4"
                            cols="12">
                          <span>จำกัดจำนวนผู้เข้าร่วม</span>
                        </v-col>
                        <v-col
                            md="4"
                            cols="12">
                        <span
                            v-if="ProjectQuotaCount != '' && ProjectQuotaCount != null && ProjectQuotaCount != '0'"> : {{
                            ProjectQuotaCount
                          }} คน</span>
                          <span v-else> : ไม่จำกัด</span>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                      <v-list-item-subtitle>
                        โควตาหน่วยงานที่เข้าร่วม
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center">
                      <v-data-table
                          :headers="DepQuotaHeader"
                          :items="DepQuotaData"
                          :search="searchDepQuota"
                          class="elevation-1 mt-4"
                      >
                        <template v-slot:header.type>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ประเภท
                          </v-label>
                        </template>
                        <template v-slot:header.dep_name>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            ภาควิชา/หน่วยงาน
                          </v-label>
                        </template>
                        <template v-slot:header.count>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            จำนวน/คน
                          </v-label>
                        </template>
                        <template
                            v-slot:footer
                        >
                          <template>
                            <div align="center" style="margin-top: 15px">
                            <span style="font-weight: bold;color: #364eff">จำกัดหน่วยงาน : {{
                                ProjectQuotaDepCount
                              }} คน</span>
                            </div>
                            <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                            <span style="font-weight: bold;color: #ff6d81">ทั่วไป : {{
                                parseInt(ProjectQuotaCount) - parseInt(ProjectQuotaDepCount)
                              }} คน</span>
                            </div>
                            <div align="center" v-else>
                              <span style="font-weight: bold;color: #ff6d81">ทั่วไป : ไม่จำกัดคน</span>
                            </div>
                            <div align="center" v-if="!ChkJoinPerson && parseInt(ProjectQuotaCount) > 0">
                              <span
                                  style="font-weight: bold;color: #42b983">รวม : {{
                                  ProjectQuotaCount
                                }} คน</span>
                            </div>
                            <div align="center" v-else>
                              <span style="font-weight: bold;color: #42b983">รวม : ไม่จำกัดคน</span>
                            </div>
                          </template>
                        </template>
                      </v-data-table>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item
                    key="JoinTab"
                >
                  <v-card class="mt-7">
                    <v-toolbar
                        color="primary"
                        dark
                        flat
                    >
                      <v-toolbar-title>รายชื่อผู้เข้าร่วม {{ JoinPerson.length }} <span
                          v-if="!ChkJoinPerson"> / {{ ProjectQuotaCount }}</span> คน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <template v-if="JoinPerson.length > 0">
                        <v-list style="width: 100%">
                          <v-list-item>
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="searchPerson"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                                v-if="JoinPerson.length > 0"
                            ></v-text-field>
                          </v-list-item>
                          <v-list-item class="mt-4">
                            <v-data-table
                                :headers="headersPerson"
                                :items="JoinPerson"
                                :search="searchPerson"
                                style="width: 100%"
                                v-if="JoinPerson.length > 0"
                            >
                              <template v-slot:item.type="{item}">
                                                            <span v-if="item.registerType_id == '0'"
                                                                  style="color: #ff6d81">
                                                                บุคลากรคณะแพทย์
                                                            </span>
                                <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                                                                นักศึกษาคณะแพทย์
                                                            </span>
                                <span v-if="item.registerType_id == '2'" style="color: blue">
                                                                บุคลากรคณะอื่น
                                                            </span>
                                <span v-if="item.registerType_id == '3'" style="color: blue">
                                                                นักศึกษาคณะอื่น
                                                            </span>
                                <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                                                                บุคคลภายนอก
                                                            </span>
                                <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                                                                นักศึกษาภายนอก
                                                            </span>
                              </template>
                              <template v-slot:item.status_reg="{item}">
                              <span style="font-weight: bold;color: #364eff"
                                    v-if="item.join_status == '1'">ลงทะเบียน</span>
                                <span style="font-weight: bold;color: #ffd54f" v-else>รอลงทะเบียน</span>
                              </template>
                            </v-data-table>
                          </v-list-item>
                        </v-list>
                      </template>
                      <template v-else>
                        <v-list-item class="d-flex justify-center align-center">
                          <span style="font-weight: bold;color: red">ไม่พบข้อมูลผู้เข้าร่วม</span>
                        </v-list-item>
                      </template>
                    </v-card-title>
                  </v-card>
                  <v-list-item class="d-flex justify-center ma-8" v-if="JoinPerson.length > 0">
                    <download-excel
                        class="btn btn-default mr-4"
                        :data="json_data"
                        :fields="json_fields"
                        worksheet="รายชื่อผู้เข้าร่วม"
                        :title="array_title"
                        :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'"
                    >
                      <v-btn outlined color="green" class="darken-3" @click="ExportEmpData">
                        Export รายชื่อผู้เข้าร่วม (บุคลากร)
                      </v-btn>
                    </download-excel>
                    <download-excel
                        class="btn btn-default mr-4"
                        :data="json_data_export"
                        :fields="json_fields_export"
                        worksheet="รายชื่อผู้เข้าร่วม"
                        :title="array_title"
                        :name="'รายชื่อผู้เข้าร่วม ' + Project_name + '.xls'"
                    >
                      <v-btn outlined color="green" class="darken-3" @click="ExportData">
                        Export รายชื่อผู้เข้าร่วม (ทั้งหมด)
                      </v-btn>
                    </download-excel>
                  </v-list-item>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <template>
        <v-dialog
            v-model="dialogApproveForm"
            scrollable
            fullscreen
        >
          <v-card>
            <v-card-title>
              <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
            </v-card-title>
            <v-card-text v-if="ApproveForm.length > 0 && ProjectRecord.length > 0">
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                >
                  <v-card>
                    <v-card-title class="font-weight-bold justify-center">
                      <span style="color: #364eff">แบบฟอร์มขออนุมัติโครงการโดยคณะ</span>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col
                            cols="12"
                            md="6"
                        >
                          <list>
                            <v-list-item class="font-weight-bold">
                              <p style="font-size: 22px;font-weight: bold">เรียน รองคณบดีฝ่ายทรัพยากรมนุษย์</p>
                            </v-list-item>
                            <v-list-item>
                              <p style="font-size: 20px;text-align: left;margin-left: 30px">
                                {{ ApproveForm[0].message }}</p>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <p style="font-size: 20px;text-align: right">{{ ApproveForm[0].name }}</p>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>
                              <p style="font-size: 20px;text-align: right">{{ ApproveForm[0].position }}</p>
                            </v-list-item>
                            <v-list-item>
                              <v-spacer></v-spacer>
                              <p style="font-size: 20px;text-align: right">
                                {{ ApproveForm[0].create_time.split(' ')[0].split('-')[2] }} /
                                {{ ApproveForm[0].create_time.split(' ')[0].split('-')[1] }} /
                                {{ (parseInt(ApproveForm[0].create_time.split(' ')[0].split('-')[0]) + 543) }}
                              </p>
                            </v-list-item>
                            <v-list-item class="d-lg-flex d-none justify-end mt-6">
                              <p
                                  style="font-weight: bold;font-size: 20px;text-align: center;margin-right: 185px">
                                อนุมัติ</p>
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end mt-6">
                              <p
                                  style="font-weight: bold;font-size: 20px;text-align: center;margin-right: 88px">
                                อนุมัติ</p>
                            </v-list-item>
                            <v-list-item class="d-lg-flex d-none justify-end mt-10">
                              <img src="../../assets/Image/license_or_thred.png" height="50"
                                   style="position: absolute;top: -36px;right: 83px">
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                              <img src="../../assets/Image/license_or_thred.png" height="50"
                                   style="position: absolute;top: -36px;right: -16px">
                            </v-list-item>
                            <v-list-item class="d-lg-flex d-none justify-end">
                              <p style="font-size: 20px;text-align: center;margin-right: 124px">(ผศ.นพ.เทอดพงศ์
                                ทองศรีราช)</p>
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end">
                              <p style="font-size: 20px;text-align: center;margin-right: 21px">(ผศ.นพ.เทอดพงศ์
                                ทองศรีราช)</p>
                            </v-list-item>

                            <v-list-item class="d-lg-flex d-none justify-end">
                              <p style="font-size: 20px;text-align: center;margin-right: 160px">
                                {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                            </v-list-item>
                            <v-list-item class="d-md-flex d-lg-none justify-end">
                              <p style="font-size: 20px;text-align: center;margin-right: 64px">
                                {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                            </v-list-item>
                          </list>
                        </v-col>
                      </v-row>
                      <v-container v-show="false">
                        <v-row id="FormExpensesPrintData">
                          <v-col
                              cols="6"
                              md="12"
                          >
                            <list>
                              <v-list-item class="font-weight-bold">
                                <p style="font-size: 22px;font-weight: bold">เรียน รองคณบดีฝ่ายทรัพยากรมนุษย์</p>
                              </v-list-item>
                              <v-list-item>
                                <p style="font-size: 20px;text-align: left;margin-left: 30px">
                                  {{ ApproveForm[0].message }}</p>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <p style="font-size: 20px;text-align: right">{{ ApproveForm[0].name }}</p>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <v-spacer></v-spacer>
                                <p style="font-size: 20px;text-align: right">{{ ApproveForm[0].position }}</p>
                              </v-list-item>
                              <v-list-item>
                                <v-spacer></v-spacer>
                                <p style="font-size: 20px;text-align: right">
                                  {{ ApproveForm[0].create_time.split(' ')[0].split('-')[2] }} /
                                  {{ ApproveForm[0].create_time.split(' ')[0].split('-')[1] }} /
                                  {{ (parseInt(ApproveForm[0].create_time.split(' ')[0].split('-')[0]) + 543) }}
                                </p>
                              </v-list-item>
                              <v-list-item class="d-lg-flex d-none justify-end mt-6">
                                <p
                                    style="font-weight: bold;font-size: 20px;text-align: center;margin-right: 185px">
                                  อนุมัติ</p>
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end mt-6">
                                <p
                                    style="font-weight: bold;font-size: 20px;text-align: center;margin-right: 88px">
                                  อนุมัติ</p>
                              </v-list-item>
                              <v-list-item class="d-lg-flex d-none justify-end mt-10">
                                <img src="../../assets/Image/license_or_thred.png" height="50"
                                     style="position: absolute;top: -36px;right: 83px">
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end mt-10">
                                <img src="../../assets/Image/license_or_thred.png" height="50"
                                     style="position: absolute;top: -36px;right: -16px">
                              </v-list-item>
                              <v-list-item class="d-lg-flex d-none justify-end">
                                <p style="font-size: 20px;text-align: center;margin-right: 124px">(ผศ.นพ.เทอดพงศ์
                                  ทองศรีราช)</p>
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end">
                                <p style="font-size: 20px;text-align: center;margin-right: 21px">(ผศ.นพ.เทอดพงศ์
                                  ทองศรีราช)</p>
                              </v-list-item>

                              <v-list-item class="d-lg-flex d-none justify-end">
                                <p style="font-size: 20px;text-align: center;margin-right: 160px">
                                  {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                  {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                  {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                              </v-list-item>
                              <v-list-item class="d-md-flex d-lg-none justify-end">
                                <p style="font-size: 20px;text-align: center;margin-right: 64px">
                                  {{ this.ProjectRecord[0].Create_Time.split(' ')[0].split('-')[2] }} /
                                  {{ ProjectRecord[0].Create_Time.split(' ')[0].split('-')[1] }} /
                                  {{ (parseInt(ProjectRecord[0].Create_Time.split(' ')[0].split('-')[0]) + 543) }}</p>
                              </v-list-item>
                            </list>
                          </v-col>
                        </v-row>
                      </v-container>
                      <!--                    <v-list>-->
                      <!--                      <v-list-item v-html="FormExpensesPrintData"></v-list-item>-->
                      <!--                    </v-list>-->
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined color="primary" @click="printFormExpanse">พิมพ์</v-btn>
              <v-btn outlined color="red" @click="dialogApproveForm = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogUrlRound"
            scrollable
            max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span>เลือกรุ่นโครงการ เพื่อเปิดลิงค์รับสมัคร</span>
            </v-card-title>
            <v-card-text>
              <template v-if="ProjectRound.length > 0">
                <v-radio-group
                    v-model="rdoGenUrlRound"
                    column
                >
                  <v-radio
                      v-for="(round, idx) in ProjectRound"
                      :key="idx"
                      :label="'รุ่นที่ ' + round.Round + ' ชื่อรุ่น ' + round.Round_name"
                      :value="round.id"
                  ></v-radio>
                </v-radio-group>
              </template>
              <template v-else>
                <v-list-item class="d-flex justify-center align-center">
                  <span style="font-weight: bold;color: red">ไม่พบข้อมูลรุ่นในการจัดโครงการ ไม่สามารถเปิดใช้งานลิงค์รับสมัครได้ !!</span>
                </v-list-item>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined color="primary" @click="GenerateRoundUrl" v-if="ProjectRound.length > 0"
                     :disabled="btnDisable">Generate ลิงค์
              </v-btn>
              <v-btn outlined color="red" @click="dialogUrlRound = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogUrlRound2"
            scrollable
            max-width="800px"
        >
          <v-card>
            <v-card-title>
              <span>เลือกรุ่นโครงการ เพื่อทำการ สร้าง Qr Code/Copy ลิงค์รับสมัคร</span>
            </v-card-title>
            <v-card-text>
              <template v-if="ProjectRound.length > 0">
                <v-radio-group
                    v-model="rdoGenUrlRound2"
                    column
                >
                  <v-radio
                      v-for="(round, idx) in ProjectRound"
                      :key="idx"
                      :label="'รุ่นที่ ' + round.Round + ' ชื่อรุ่น ' + round.Round_name"
                      :value="round.id"
                  ></v-radio>
                </v-radio-group>
              </template>
              <template v-else>
                <v-list-item class="d-flex justify-center align-center">
                  <span style="font-weight: bold;color: red">ไม่พบข้อมูลรุ่นในการจัดโครงการ ไม่สามารถ Copy ลิงค์รับสมัครได้ !!</span>
                </v-list-item>
              </template>
            </v-card-text>
            <v-card-actions v-if="ProjectObj != null">
              <v-spacer></v-spacer>
              <v-btn outlined color="primary" @click="CopyUrl" v-if="ProjectRound.length > 0" :disabled="btnDisable2">
                ทำรายการต่อ
              </v-btn>
              <v-btn outlined color="red" @click="dialogUrlRound2 = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogQr"
            max-width="800px"
            persistent
        >
          <v-card v-if="ProjectObj != null">
            <v-card-title>
              QR Code ลิงค์รับสมัคร โครงการ : {{ ProjectObj.Project_name.replace(/&quot;/g, '"') }}
            </v-card-title>
            <v-card-text>
              <template v-if="url != ''">
                <div align="center">
                  <v-img :src="qrUrl" max-width="600px" max-height="600px"></v-img>
                </div>

              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="orange" text style="font-weight: bold" @click="downloadURI">ดาวน์โหลด QR CODE</v-btn>
              <CopyToClipboard :text="url">
                <v-list-item-title @click="CopySuccess">
                  <v-btn text style="font-weight: bold;color: #42b983">คัดลอกลิงค์</v-btn>
                </v-list-item-title>
              </CopyToClipboard>
              <v-btn @click="dialogQr = false" color="red" text> ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogCompetency"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              Competency,Core Value,Strategic Objective
            </v-card-title>
            <v-card-text>
              <template v-if="CompetencyToShow.length > 0">
                <v-treeview :activatable="true" :items="CompetencyToShow">
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file" color="blue lighten-2">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                  <template v-slot:label="{ item, active }">
                    <div v-if="isMobile" style="cursor: pointer">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="font-size: 12px;color: #364eff;font-weight: bold"
                            v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                    <div v-else style="cursor: pointer">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                  </template>
                </v-treeview>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                  Competency,Core Value,Strategic Objective</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogCompetency = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogFile"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="FileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in FileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogFile = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            max-width="1200"
            persistent
            v-model="dialogJoinTravel">
          <v-card>
            <v-card-title>
              <h2 class="pb-4" style="font-weight: bold">ข้อมูลรายชื่อผู้เข้าร่วมเดินทาง</h2>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-6">
              <v-list>
                <v-list-item>
                  <v-data-table
                      class="mt-6"
                      :items="JoinTravel"
                      :headers="JoinTravelHeader"
                      style="width: 100%"
                  >
                    <template v-slot:header.customTravelDetail>
                      <h3 class="font-weight-bold">ผู้เดินทาง</h3>
                    </template>
                    <template v-slot:header.position>
                      <h3 class="font-weight-bold">ตำแหน่งระดับ(วันบรรจุ)</h3>
                    </template>
                    <template v-slot:header.Allowance>
                      <h3 class="font-weight-bold">ค่าเบี้ยเลี้ยง</h3>
                    </template>
                    <template v-slot:header.AccommodationCost>
                      <h3 class="font-weight-bold">ค่าที่พัก</h3>
                    </template>
                    <template v-slot:header.ShippingCosts>
                      <h3 class="font-weight-bold">ค่าพาหนะ</h3>
                    </template>
                    <template v-slot:header.RegistrationFee>
                      <h3 class="font-weight-bold">ค่าลงทะเบียน</h3>
                    </template>
                    <template v-slot:header.AllTravelExpenses>
                      <h3 class="font-weight-bold">รวมค่าเดินทาง</h3>
                    </template>
                    <template v-slot:header.RemainingBudget>
                      <h3 class="font-weight-bold">งบวิชาการคงเหลือ</h3>
                    </template>
                    <template v-slot:item="{item}">
                      <tr>
                        <td>
                          <div v-html="item.customTravelDetail"></div>
                        </td>
                        <td>{{ item.Allowance | currency }}</td>
                        <td>{{ item.AccommodationCost | currency }}</td>
                        <td>{{ item.ShippingCosts | currency }}</td>
                        <td>{{ item.RegistrationFee | currency }}</td>
                        <td>{{ item.AllTravelExpenses | currency }}</td>
                        <td>{{ item.RemainingBudget | currency }}</td>
                      </tr>
                      <!--                  <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text @click="editJoinTravel(item)">แก้ไข</v-btn>
                                        <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(item)">ลบ</v-btn>-->
                    </template>
                    <template v-slot:footer>
                      <v-divider></v-divider>
                      <v-row class="mt-4">
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าเบี้ยเลี้ยง:
                            <span style="color: black">{{ SumAllowance | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าที่พัก:
                            <span style="color: black">{{ SumAccommodationCost | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าพาหนะ:
                            <span style="color: black">{{ SumShippingCosts | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าลงทะเบียน:
                            <span style="color: black">{{ SumRegistrationFee | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าเดินทาง:
                            <span style="color: black">{{ SumAllTravelExpenses | currency }}</span>
                          </p>
                        </v-col>
<!--                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าใช้จ่ายทั้งสิ้น:
                            <span style="color: black">{{
                                (parseFloat(SumAllowance) + parseFloat(SumAccommodationCost) + parseFloat(SumShippingCosts) + parseFloat(SumRegistrationFee) + parseFloat(SumAllTravelExpenses))  | currency
                              }}</span>
                          </p>
                        </v-col>-->
                      </v-row>
                    </template>
                  </v-data-table>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="dialogJoinTravel = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
        v-model="dialogShowHistoryExpense"
        max-width="1000"
        persistent>
      <v-card>
        <v-card-title class="font-weight-bold" v-if="groupExpenseObj != null">
          <span>รายละเอียดค่าใช้จ่าย : {{ groupExpenseObj.Expense_name }}</span>
        </v-card-title>
        <v-card-text>
          <template v-if="budgetHistotyDetailData.length > 0">
            <v-list-item>
              <div class="d-flex flex-column justify-stretch" style="width: 100%">
                <v-data-table
                    :headers="budgetHeader"
                    :items="budgetHistotyDetailData"
                    class="elevation-1"
                >
                  <template v-slot:header.Custom_Expense_des>
                    <span style="font-weight: bold;font-size: 16px">รายการ</span>
                  </template>
                  <template v-slot:header.SumMoney>
                    <span style="font-weight: bold;font-size: 16px">จำนวนเงินรวม (ทั้งสิ้น)</span>
                  </template>
                  <template v-slot:item.Custom_Expense_des="props">
                    <div v-html="props.item.Custom_Expense_des"></div>
                  </template>
                  <template v-slot:item.SumMoney="props">
                    <p style="font-weight: bold">{{ props.item.SumMoney | currency }}</p>
                  </template>
                  <template v-slot:item.ReqMoney="props">
                    <p style="font-weight: bold">{{ props.item.ReqMoney | currency }}</p>
                  </template>
                  <template
                      v-slot:footer
                  >
                    <template v-if="budgetHistotyDetailData > 0">
                      <!-- <div align="center" style="margin-top: 15px">
                    <span style="font-weight: bold;color: #364eff">งบประมาณที่ขอ : {{
                        BudgetRequest | currency
                      }}</span>
                      </div> -->
                      <div align="right">
                      <span style="font-weight: bold;color: #ff6d81;font-size: 16px">รวมค่าใช้จ่าย : {{
                          ExpenseGroupDetail | currency
                        }}</span>
                      </div>
                      <!-- <div align="center">
                    <span
                        style="font-weight: bold;color: #42b983">คงเหลือ : {{
                        BudgetRequest - Expense | currency
                      }}</span>
                      </div> -->
                    </template>
                  </template>
                </v-data-table>
              </div>
            </v-list-item>
          </template>
          <template v-else>
            <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
              ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              x-large
              color="red"
              dark
              @click="dialogShowHistoryExpense = false"
          >Close
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogShowHistoryExpenseReal"
        max-width="1000"
        persistent>
      <v-card>
        <v-card-title class="font-weight-bold" v-if="groupExpenseRealObj != null">
          <span>รายละเอียดการเบิกจ่าย : {{ groupExpenseRealObj.Item }}</span>
        </v-card-title>
        <v-card-text>
          <template v-if="expenseDetailRealHistotyData.length > 0">
            <v-list-item>
              <div class="d-flex flex-column justify-stretch" style="width: 100%">
                <v-data-table
                    :headers="expenseDetailRealHistotyHeader"
                    :items="expenseDetailRealHistotyData"
                    class="elevation-1"
                >
                  <template v-slot:item.Mon_debit="props">
                    <p style="font-weight: bold">{{ props.item.Mon_debit | currency }}</p>
                  </template>
                  <template v-slot:item.Monthly="props">
                    <p style="font-weight: bold">{{ props.item.Monthly | monthToThai }}</p>
                  </template>
                  <template
                      v-slot:footer
                  >
                    <template v-if="expenseDetailRealHistotyData > 0">
                    </template>
                  </template>
                </v-data-table>
              </div>
            </v-list-item>
          </template>
          <template v-else>
            <p style="font-size: 20px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px;width: 100%">
              ไม่พบข้อมูลรายละเอียดค่าใช้จ่าย</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              x-large
              color="red"
              dark
              @click="dialogShowHistoryExpenseReal = false"
          >Close
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    <v-dialog
        v-model="dialogCancelOrCloseProject"
        max-width="600px"
    >
      <v-card v-if="ProjectObj != null">
        <v-card-title class="font-weight-bold">
          <span>กรุณาระบุเหตุผลยกเลิกการจัด โครงการ : {{ProjectObj.Project_name}} ({{ ProjectObj.Project_code }})</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
              v-model="remarksCloseProject"
              label="เหตุผลการยกเลิกการจัดโครงการ"
              :error-messages="remarksCloseProject == '' ? 'เหตุผล ห้ามว่าง' : ''"
              :error="remarksCloseProject == ''"
              outlined
              required
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              @click="updateStatusProject(ProjectObj, closeStatus)"
          >บันทึก</v-btn>
          <v-btn
              color="red"
              @click="dialogCancelOrCloseProject = false"
          >ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSelectRound" max-width="500px">
      <v-card>
      <v-card-title>เลือกรุ่น</v-card-title>
      <v-card-text>
        <v-list>
        <v-list-item v-for="(item, index) in RoundData" :key="index" @click="selectRound(item)">
          <v-list-item-content>
          <v-list-item-title>
            รุ่นที่ {{ item.round }} :
            {{ item.round_name }}
          </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list>
      </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogQrSatisfaction"
      max-width="800px"
      persistent
    >
      <v-card v-if="ProjectObj != null">
        <v-card-title>
          QR Code ตัวชี้วัด แบบสอบถาม : {{ ProjectObj.Project_name.replace(/&quot;/g, '"') }}
        </v-card-title>
        <v-card-text>
          <template v-if="urlSatisfaction != ''">
            <div align="center">
              <v-img :src="qrUrlSatisfaction" max-width="600px" max-height="600px"></v-img>
            </div>

          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" text style="font-weight: bold" @click="downloadURISatisfaction(qrUrlSatisfaction)">ดาวน์โหลด QR CODE</v-btn>
          <CopyToClipboard :text="urlSatisfaction + ProjectObj.Project_code + '&vname=' + sanitizeProjectNameSatisfaction(ProjectObj.Project_name) + (selectedRound ? ' รุ่น ' + (selectedRound.round || '') + ' ' + (selectedRound.round_name || '') : '') + '&uuid=' + (selectedRound ? selectedRound.No : 0)">
            <v-list-item-title @click="CopySuccessSatisfaction()">
              <v-btn text style="font-weight: bold;color: #42b983">คัดลอกลิงค์</v-btn>
            </v-list-item-title>
          </CopyToClipboard>
          <v-btn @click="dialogQrSatisfaction = false" color="red" text> ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogQrSatisfaction2"
      max-width="800px"
      persistent
    >
      <v-card v-if="ProjectObj != null">
        <v-card-title>
          QR Code ตัวชี้วัด ผลการตอบแบบสอบถาม : {{ ProjectObj.Project_name.replace(/&quot;/g, '"') }}
        </v-card-title>
        <v-card-text>
          <template v-if="urlSatisfaction2 != ''">
            <div align="center">
              <v-img :src="qrUrlSatisfaction2" max-width="600px" max-height="600px"></v-img>
            </div>

          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" text style="font-weight: bold" @click="downloadURISatisfaction(qrUrlSatisfaction2)">ดาวน์โหลด QR CODE</v-btn>
          <CopyToClipboard :text="urlSatisfaction2 + ProjectObj.Project_code + '&vname=' + sanitizeProjectNameSatisfaction(ProjectObj.Project_name) + (selectedRound ? ' รุ่น ' + (selectedRound.round || '') + ' ' + (selectedRound.round_name || '') : '') + '&uuid=' + (selectedRound ? selectedRound.No : 0)">
            <v-list-item-title @click="CopySuccessSatisfaction()">
              <v-btn text style="font-weight: bold;color: #42b983">คัดลอกลิงค์</v-btn>
            </v-list-item-title>
          </CopyToClipboard>
          <v-btn @click="dialogQrSatisfaction2 = false" color="red" text> ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogQrSurveyType" max-width="600px" persistent>
      <v-card v-if="ProjectObj != null">
        <v-card-title>QrCode/คัดลอกลิงค์ผลการตอบแบบสอบถามความพึงพอใจ</v-card-title>
        <v-card-text>
          <v-radio-group v-model="qrMenuSurveyType" row>
            <v-radio value="1">
              <template v-slot:label>
                <span class="font-weight-bold">ใช้แบบสอบถามมาตรฐานกลาง</span>
              </template>
            </v-radio>
            <v-radio value="2">
              <template v-slot:label>
                <span class="font-weight-bold">ใช้แบบสอบถามที่สร้างเอง</span>
              </template>
            </v-radio>
          </v-radio-group>
          <div v-if="qrMenuSurveyType == '1'" class="mt-2">
            <v-btn dark class="font-weight-bold mx-2 mb-2" color="primary" @click="handleShowQrCode">แสดง QR CODE/ลิงค์ แบบสอบถาม</v-btn>
            <v-btn dark class="font-weight-bold mx-2 mb-2" color="primary" @click="handleShowQrCode2">แสดง QR CODE/ลิงค์ ผลการตอบแบบสอบถาม</v-btn>
          </div>
          <div v-else-if="qrMenuSurveyType == '2'" class="mt-2">
            <v-btn dark class="font-weight-bold mx-2 mb-2" color="green" @click="createSurveyForm">คลิกเพื่อสร้างแบบสอบถาม</v-btn>
            <v-btn dark class="font-weight-bold mx-2 mb-2" color="primary" :loading="customAssessLoading" @click="handleShowQrCodeCustom">แสดง QR CODE/ลิงค์ แบบสอบถาม</v-btn>
            <v-btn dark class="font-weight-bold mx-2 mb-2" color="primary" :loading="customAssessLoading" @click="handleShowQrCodeCustomResult">แสดง QR CODE/ลิงค์ ผลการตอบแบบสอบถาม</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogQrSurveyType = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <v-dialog v-model="dialogExportPlanProj" max-width="800">
        <v-card>
          <v-card-title>
            <span style="font-width: bold;">เลือกรายละเอียดข้อมูลก่อนทำรายการ Export ข้อมูล อบรม/เดินทางไปปฏิบัติงานประจำปี {{
              parseInt(FiscalYear) + 543
              }}</span>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-radio-group v-model="exportType" row>
                  <v-radio class="font-weight-bold" label="เดินทางไปราชการ (ในวิชาชีพ)" value="1"></v-radio>
                  <v-radio class="font-weight-bold" label="เดินทางไปราชการ (นอกวิชาชีพ)" value="2"></v-radio>
                  <v-radio class="font-weight-bold" label="เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)" value="3"></v-radio>
                </v-radio-group>
              </v-list-item>
              <v-list-item>
                <v-radio-group v-model="exportType4" row>
                  <v-radio class="font-weight-bold" label="ทั้งหมด" value="1"></v-radio>
                  <v-radio class="font-weight-bold" label="เฉพาะที่อนุมัติ" value="0"></v-radio>
                  <v-radio class="font-weight-bold" label="เลือกเฉพาะ งานคลังอนุมัติวงเงิน, เบิกจ่ายเสร็จสิ้น, ปิดโครงการ" value="2"></v-radio>
                </v-radio-group>
              </v-list-item>
              <v-list-item v-if="exportType4 != '1' && exportType4 != '' && exportType4 != null">
                <v-radio-group v-model="exportType3" row>
                  <v-radio class="font-weight-bold" label="ทั้งหมด" value="9"></v-radio>
                  <v-radio class="font-weight-bold" label="มีรายการเบิกจ่าย" value="1"></v-radio>
                  <v-radio class="font-weight-bold" label="ไม่มีรายการเบิกจ่าย" value="0"></v-radio>
                </v-radio-group>
              </v-list-item>
              <v-list-item>
                  <v-autocomplete
                  v-model="exportDepGroup"
                  :items="[{ dep_group_id: 'all', dep_group_name: 'ทั้งหมด' }, ...groupDepart]"
                  item-text="dep_group_name"
                  item-value="dep_group_id"
                  label="เลือกกลุ่มหน่วยงาน"
                  clearable
                  ></v-autocomplete>
              </v-list-item>
              <v-list-item class="d-flex justify-center">
                <download-excel class="btn btn-default" :data="json_data_proj" :fields="json_fields_proj"
                  worksheet="แผนทั้งหมดภายในปี"
                  :name="'ข้อมูลอบรม/เดินทางไปปฏิบัติงานประจำปี ' + (parseInt(this.FiscalYear) + 543) + '.xls'">
                  <v-btn class="font-weight-bold" outlined color="primary" @click="ExportDataProj">Export ข้อมูล</v-btn>
                </download-excel>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="font-weight-bold" text color="red" @click="dialogExportPlanProj = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import ConstData from '../../const/Const'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import TinyURL from "tinyurl";
import CopyToClipboard from 'vue-copy-to-clipboard'
import QRCode from 'qrcode'
import queryString from "query-string";
import Vue from "vue";

// import Vue from "vue";

export default {
  name: "ProjectCourse",
  components: {
    CopyToClipboard
  },
  data() {
    return {
      exportDepGroup: null,
      dialogExportPlanProj: false,
      exportType: null,
      exportType3: null,
      exportType4: null,
      json_fields_proj: {
        '#': 'index',
        'รหัสอบรม/เดินทาง': 'Project_code',
        "ชื่องาน / กิจกรรม": 'Project_name',
        "วันที่เริ่มต้น": 'DateStart',
        "วันที่สิ้นสุด": 'DateEnd',
        "หลักสูตร": 'Course_name',
        "งบประมาณที่ขอ": 'BudgetRequest',
        "จำนวน ช.ม.": 'CalHourse',
        "จำนวน เครดิต": 'CalCredit',
        "งาน / กิจกรรม ถูกจัดขึ้น": 'PLACE',
        "จัดโดย": 'WorkBy',
        "ชื่อผู้จัด": 'WorkByName',
        "เบอร์โทรติดต่อผู้กรอกข้อมูล": 'WorkByPhone',
        "สถานที่จัด": 'Location',
        "หน่วยงาน": 'Dep_Name',
        "ประจำปี": 'FiscalYear2',
        "รายละเอียด": 'Remarks',
        "สถานะ": 'IsStatusName',
        "วันที่บันทึก": 'Create_Time',
      },
      json_data_proj: [],
      json_meta_proj: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      dialogQrSatisfaction: false,
      dialogSelectRound: false,
      selectedRound: null,
      qrType: 0,
      urlSatisfaction: "https://assess.medicine.psu.ac.th/assess_forms.php?assess_id=MTE0MQ==&vch=1&vproject=",
      qrUrlSatisfaction: "",
      dialogQrSatisfaction2: false,
      urlSatisfaction2: "https://assess.medicine.psu.ac.th/assess_result_detail.php?assess_id=1141&vproject=",
      qrUrlSatisfaction2: "",
      surveyType: '1',
      qrMenuSurveyType: '1',
      dialogQrSurveyType: false,
      customAssessId: '',
      customAssessIdBtoa: '',
      customAssessLoading: false,
      remarksCloseProject: '',
      closeStatus: null,
      dialogCancelOrCloseProject: false,
      FiscalYearDataSel: [],
      fiscalYear: new Date().getFullYear(),
      ExpenseRealSummay: 0,
      ExpenseDetailRealSummay: 0,
      ExpenseGroup: 0,
      ExpenseGroupDetail: 0,
      groupExpenseObj: null,
      groupExpenseRealObj: null,
      dialogShowHistoryExpense: false,
      dialogShowHistoryExpenseReal: false,
      expenseRealData: [],
      budgetHistotyDetailData: [],
      expenseDetailRealHistotyData: [],
      budgetHistotyData: [],
      budgetRealHistotyData: [],
      expenseRealHeader: [
        {text: "ชื่อรายการ", value: "Item"},
        {text: "จำนวนเงิน", value: "Mon_total"},
        {text: "", value: "action"},
      ],
      budgetHistotyHeader: [
        {text: "ชื่อรายการ", value: "Expense_name"},
        {text: "วันที่สร้าง", value: "Create_Time"},
        {text: "จำนวนเงินรวม", value: "SumMoney"},
        {text: "", value: "action"},
      ],
      expenseDetailRealHistotyHeader: [
        {text: "ชื่อรายการ", value: "Expense_des"},
        {text: "ชื่อรายการ", value: "Mon_debit"},
        {text: "เดือนที่ทำรายการ", value: "Monthly"},
        {text: "", value: "action"},
      ],
      budgetHistotyDetailHeader: [
        {text: "ชื่อรายการ", value: "Expense_name"},
        {text: "วันที่สร้าง", value: "Create_Time"},
        {text: "", value: "action"},
      ],
      nameHistoryExpense: '',
      dialogCreateNameHistoryExpense: false,
      TypeBuggetProject: "1",
      countAllPerson: 0,
      Knowledge_after: 0,
      Knowledge_before: 0,
      satisfaction: 0,
      sortStatus: '1',
      selStatus: '0',
      RecordDataDump: [],
      SumAllowance: 0,
      SumAccommodationCost: 0,
      SumShippingCosts: 0,
      SumRegistrationFee: 0,
      SumAllTravelExpenses: 0,
      JoinTravel: [],
      JoinTravelHeader: [
        {text: 'ผู้เดินทาง', value: 'customTravelDetail'},
        {text: 'ค่าเบี้ยเลี้ยง', value: 'Allowance'},
        {text: 'ค่าที่พัก', value: 'AccommodationCost'},
        {text: 'ค่าพาหนะ', value: 'ShippingCosts'},
        {text: 'ค่าลงทะเบียน', value: 'RegistrationFee'},
        {text: 'รวมค่าเดินทาง', value: 'AllTravelExpenses'},
        {text: 'งบวิชาการคงเหลือ', value: 'RemainingBudget'},
      ],
      dialogJoinTravel: false,
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร": 'perid',
        "คำนำหน้า": 'iname',
        "ชื่อ": 'name',
        "นามสกุล": 'surname',
        "หน่วยงาน": 'dep_name_old',
        "กลุ่มหน่วยงาน": 'dep_group_name',
        "ตำแหน่ง": 'pos_name',
        "ศาสนา": 'religion_name',
        "งบวิชาการตามสิทธิ์ที่ได้รับ": 'money_permiss',
        "หมายเหตุ": 'remark',
      },
      array_title: [],
      json_data: [],
      json_fields_export: {
        'ลำดับ': 'index',
        "รหัสบุคลากร/นักศึกษา/อ้างอิงบุคคลภายนอก": 'uid',
        "ชื่อ - สกุล": 'full_Name',
        "สังกัด": 'affiliation',
        "ประเภท": 'type_details',
      },
      json_data_export: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      dialogFile: false,
      dialogCompetency: false,
      DepSelect: null,
      episode: null,
      projOgan: null,
      dialogOrganProj: false,
      form1: true,
      form2: false,
      countAll: 0,
      countAll2: 0,
      countDep: 0,
      countFaculty: 0,
      count0: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      count6: 0,
      count9: 0,
      qrUrl: '',
      url: '',
      dialogQr: false,
      btnDisable: false,
      btnDisable2: false,
      rdoGenUrlRound: null,
      rdoGenUrlRound2: null,
      dialogUrlRound: false,
      dialogUrlRound2: false,
      FormExpensesPrintData: '',
      ProjectObj: null,
      dialogApproveForm: false,
      JoinPersonDump: [],
      TypeReg: '0',
      dialogRound: false,
      tabs: null,
      RoundDataDump: null,
      groupDetail: null,
      groupQuataDump: [],
      dialogGroupDetail: false,
      roundHeader: [
        {text: 'รุ่น', value: 'round'},
        {text: 'ชื่อรุ่น', value: 'round_name'},
        {text: 'จำนวนผู้เข้าร่วม', value: 'count_person'},
        {text: '', value: 'action'},
      ],
      roundNeed: false,
      RoundData: [],
      round: '',
      round_name: '',
      dateRegS: '',
      dateRegE: '',
      time_start: '',
      time_end: '',
      // typeStatus: '3',
      typeStatus: '1',
      typeStatus2: '8',
      IsPlan: '',
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      ProjectPlan: '',
      Project_plan: [],
      TypeCreateProject: '0',
      FiscalYearData: [],
      TypeProcess: '1',
      projectDataToTable: [],
      allProjectDataToTable: [],
      allProjectDataToTableDump: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      WorkGroupData: [],
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataFormDB: '',
      editorData: '',
      editorData2: '',
      editorData3: '',
      dialogLoading: false,
      ExpenseSummary: 0,
      Expense: 0,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      CompetencyToShow: [],
      ReqMoney: '',
      Rm: '',
      selection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      proposal: [],
      dialogProposal: false,
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      RecordData: [],
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
      ],
      JoinPerson: [],
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 8,
      vertical: true,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      FiscalYear: null,
      Project_type: '',
      WorkBy: '',
      WorkByName: '',
      WorkByPhone: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Objective: '',
      TargetGroup: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      MoneyDisburse: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Objective: '',
        TargetGroup: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        MoneyDisburse: '',
        Project_group: '',
        Approve: '',
        FiscalYear: '',
        IsPlan: '',
        IsPlanStatus: '',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        Create_By: '',
        Create_Time: '',
        Update_By: '',
        Update_Time: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      search2: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร/คณะกรรมการ/นำเสนอผลงาน', value: 'Lecturer'},
        {text: '', value: 'action'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในประเทศ'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'หน่วยงาน/คณะ มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      allProjectHeader: [
        {
          text: 'รหัสหลักสูตร', class: 'HeaderTable',
          align: 'start',
          value: 'Project_code',
        },
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'อนุมัติโดย', value: 'Approve'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: '', value: 'Project_Details'}
      ],
      courseHeaders: [
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: 'เสนออนุมัติ', value: 'Organize_project'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: 'จำนวนเงินอนุมัติ', value: 'BudgetArrove'},
        {text: 'จำนวนเงินเบิกจ่าย', value: 'MoneyDisburse'},
        {text: '', value: 'Project_Details'}
      ],
      travelHeaders: [
        {text: 'หัวข้อ', value: 'full_Name'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: 'จำนวนเงินอนุมัติ', value: 'BudgetArrove'},
        {text: 'จำนวนเงินเบิกจ่าย', value: 'MoneyDisburse'},
        {text: '', value: 'Project_Details'}
      ],
      budgetHeader: [
        {text: 'รายการ', value: 'Custom_Expense_des'},
        {text: 'จำนวนอัตรา', value: 'SumMoney'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
      axiosHeaderPUT: {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      },
      axiosHeaderUPDATE: {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      ProjectFromFiscalYearUser: "Project/getProjectFromFiscalYearUser",
      committee_Posi: 'Project/getComitteeType',
      ProjectCommittee: "Project/getProjectCommittee",
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      projectPalnData: 'Project/getProjectPlan',
      GroupExamData: 'Project/getGroupExamProject',
      QuotaDepartData: 'Project/getQuotaDepart',
      JoinProjectData: 'Project/getJoinProject',
      GroupQuotaData: 'Project/getGroupQuota',
      GroupQuotaMS: 'Project/getGroupQuota_Ms',
      ProjectRound: 'Project/getProjectRound',
      ApproveForm: 'Project/getApproveForm',
      ProjectRecord: 'Project/getProjectRecord',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      ApproveMaster: 'Staff/getApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      PermissionAdmin: 'Permission/getPermission',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      PermissionApprove: 'Permission/getPermissionApprove',
      PermissionUserApprove: 'Permission/getPermissionUserApprove',
      OptPermission: 'Permission/getOptPermission',
      getOptUserPermission: 'Permission/getOptUserPermission',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      ManageProjectPage: 'Project/getManageProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
      StatusProject: 'Project/getStatusProject',
      TravelForm: 'Project/getTravelForm',
      JoinTravelRes: 'Project/getJoinTravel',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initProjDataFromFiscalYearUser: "Project/initProjDataFromFiscalYearUser",
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProjCommittee: 'Project/initProjCommittee',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getProjectRoundData: 'Project/getProjectRoundData',
      getGroupExamProjectByCordi: 'Project/getGroupExamProjectByCordi',
      getQuotaDepartRegisterByCordi: 'Project/getQuotaDepartRegisterByCordi',
      getJoinProjectByCordi: 'Project/getJoinProjectByCordi',
      initApproveFormData: 'Project/initApproveFormData',
      initProjectRecordData: 'Project/initProjectRecordData',
      initAllProjectRecordData: 'Project/initAllProjectRecordData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getPermissionByApprove: 'Permission/getPermissionByApprove',
      getPermissionUserByApprove: 'Permission/getPermissionUserByApprove',
      initPermissionOptionData: 'Permission/initPermissionOptionData',
      initPermissionOptionUserData: 'Permission/initPermissionOptionUserData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      initLogProject: 'Project/initLogProject',
      initLogCompetencyProject: 'Project/initLogCompetencyProject',
      initLogFileProject: 'Project/initLogFileProject',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeManageProjectPage: 'Project/changeManageProjectPage',
      initFileReportTravel: 'Project/initFileReportTravel',
      initJoinTravel: 'Project/initJoinTravel',
    }),
    init: function () {
      this.dialogLoading = true
      this.allProjectDataToTable = []
      this.allProjectDataToTableDump = []
      this.projectDataToTable = []
      this.FiscalYearData = []
      this.initComitteeType()
      this.initCountryData()

      this.groupDepart = []
      if (this.CheckAdmin) {
        this.getPermissionDep({
          perid: this.MeData[0].perid
        }).then(resDep => {
          if (resDep) {
            const groupMap = {}
            this.depart.forEach(dep => {
              if (dep.dep_group_id && !groupMap[dep.dep_group_id]) {
                groupMap[dep.dep_group_id] = {
                  dep_group_id: dep.dep_group_id,
                  dep_group_name: dep.dep_group_name
                }
              }
            })

            // สร้างรายการ groupDepart โดยนำ Permission_Dep มาเทียบกับ depart และเก็บกลุ่มที่ตรงกัน (ไม่ซ้ำ)
            this.groupDepart = []
            if (this.Permission_Dep && this.Permission_Dep.length > 0) {
              this.Permission_Dep.forEach(perm => {
                const depMatch = this.depart.find(d => d.dep_id == perm.dep_id)
                if (depMatch && depMatch.dep_group_id && groupMap[depMatch.dep_group_id]) {
                  const grp = groupMap[depMatch.dep_group_id]
                  if (!this.groupDepart.find(g => g.dep_group_id === grp.dep_group_id)) {
                    this.groupDepart.push(grp)
                  }
                }
              })
            }
          }
        })
      } else if (this.CheckSubAdmin) {
        this.getPermissionDepUserData({
          perid: this.MeData[0].perid
        }).then(resDepUser => {
          if (resDepUser) {
            const groupMap = {}
            this.depart.forEach(dep => {
              if (dep.dep_group_id && !groupMap[dep.dep_group_id]) {
                groupMap[dep.dep_group_id] = {
                  dep_group_id: dep.dep_group_id,
                  dep_group_name: dep.dep_group_name
                }
              }
            })

            // สร้างรายการ groupDepart โดยนำ Permission_Dep_User มาเทียบกับ depart และเก็บกลุ่มที่ตรงกัน (ไม่ซ้ำ)
            this.groupDepart = []
            if (this.Permission_Dep_User && this.Permission_Dep_User.length > 0) {
              this.Permission_Dep_User.forEach(perm => {
                const depMatch = this.depart.find(d => d.dep_id == perm.dep_id)
                if (depMatch && depMatch.dep_group_id && groupMap[depMatch.dep_group_id]) {
                  const grp = groupMap[depMatch.dep_group_id]
                  if (!this.groupDepart.find(g => g.dep_group_id === grp.dep_group_id)) {
                    this.groupDepart.push(grp)
                  }
                }
              })
            }
          }
        })
      }


      for (var i = (new Date().getFullYear() - 1); i <= (new Date().getFullYear() + 1); i++) {
        this.FiscalYearData.push({
          year: i,
          yearth: i + 543
        })
      }

      this.FiscalYear = this.FiscalYearData[this.FiscalYearData.length - 1].year

      // this.initProjectData({
      //   perid: this.MeData[0].perid
      // })

      this.initDepartData().then(resDep => {
        if (resDep) {
          this.selProjFiscalYear()
          } else {
            this.dialogLoading = false
          }
      })

      this.initGroup_Quota()

      this.initGroup_Quota_Ms()

      this.initExpenseData({
        cost_type: this.TypeProject
      })

      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      if (this.Comittee_Data.length == 0) {
        this.initComitteeData()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      if (this.Competency_Data.length == 0) {
        this.initCompetencyData()
      }

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }

    },
    saveUrl() {
      var checkUpdate = false
      if (this.ProjectObj != null) {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + this.ProjectObj.project_id + '/active/1').then(resGet => {
          if (resGet.data) {
            if (resGet.data.length > 0) {
              if (this.ProjectObj.IsRoundStatus == '0' && resGet.data.filter(url_I => url_I.D_project_round_id != '').length > 0) {
                checkUpdate = true
                resGet.data.map(url_I => {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + url_I.id, {
                    active: '0',
                    update_by: this.MeData[0].perid
                  })
                })
              } else if (this.ProjectObj.IsRoundStatus == '1' && resGet.data.filter(url_I => url_I.D_project_round_id == '').length > 0) {
                checkUpdate = true
                resGet.data.map(url_I => {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + url_I.id, {
                    active: '0',
                    update_by: this.MeData[0].perid
                  })
                })
              }
            } else {
              if (this.ProjectObj.IsRoundStatus == '0' && resGet.data.D_project_round_id != '') {
                checkUpdate = true
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                  active: '0',
                  update_by: this.MeData[0].perid
                })
              } else if (this.ProjectObj.IsRoundStatus == '1' && resGet.data.D_project_round_id == '') {
                checkUpdate = true
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                  active: '0',
                  update_by: this.MeData[0].perid
                })
              }
            }

            if (!checkUpdate) {
              if (resGet.data.length > 0) {
                var result = resGet.data.filter(url_I => url_I.D_project_round_id == this.rdoGenUrlRound)
                if (result.length > 0) {
                  result.map(url_I => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + url_I.id, {
                      active: '0',
                      update_by: this.MeData[0].perid
                    })
                  })
                }
                this.GenerateUrl(this.ProjectObj.uuid + '/' + this.rdoGenUrlRound).then(resUrl => {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                    D_project_id: this.ProjectObj.project_id,
                    D_project_round_id: this.rdoGenUrlRound,
                    url: resUrl,
                    create_by: this.MeData[0].perid,
                    create_time: 'now()'
                  }, this.axiosHeaderPUT).then(resPUT => {
                    if (resPUT.data.status) {
                      this.btnDisable = false
                      this.dialogUrlRound = false
                      this.ClearCopyAndMenu()
                      this.$swal.fire({
                        timer: 1500,
                        showConfirmButton: false,
                        icon: 'success',
                        title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + this.ProjectObj.Project_name + ' สำเร็จ!!'
                      }, 1500)
                    }
                  })
                })
              } else {
                if (resGet.data.D_project_round_id == this.rdoGenUrlRound) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                    active: '0',
                    update_by: this.MeData[0].perid
                  }).then(resUpdate => {
                    if (resUpdate.data.status) {
                      this.GenerateUrl(this.ProjectObj.uuid + '/' + this.rdoGenUrlRound).then(resUrl => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                          D_project_id: this.ProjectObj.project_id,
                          D_project_round_id: this.rdoGenUrlRound,
                          url: resUrl,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, this.axiosHeaderPUT).then(resPUT => {
                          if (resPUT.data.status) {
                            this.btnDisable = false
                            this.dialogUrlRound = false
                            this.ClearCopyAndMenu()
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + this.ProjectObj.Project_name + ' สำเร็จ!!'
                            }, 1500)
                          }
                        })
                      })
                    }
                  })
                } else {
                  this.GenerateUrl(this.ProjectObj.uuid + '/' + this.rdoGenUrlRound).then(resUrl => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                      D_project_id: this.ProjectObj.project_id,
                      D_project_round_id: this.rdoGenUrlRound,
                      url: resUrl,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()'
                    }, this.axiosHeaderPUT).then(resPUT => {
                      if (resPUT.data.status) {
                        this.btnDisable = false
                        this.dialogUrlRound = false
                        this.ClearCopyAndMenu()
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + this.ProjectObj.Project_name + ' สำเร็จ!!'
                        }, 1500)
                      }
                    })
                  })
                }
              }
            } else {
              this.GenerateUrl(this.ProjectObj.uuid + '/' + this.rdoGenUrlRound).then(resUrl => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                  D_project_id: this.ProjectObj.project_id,
                  D_project_round_id: this.rdoGenUrlRound,
                  url: resUrl,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()'
                }, this.axiosHeaderPUT).then(resPUT => {
                  if (resPUT.data.status) {
                    this.btnDisable = false
                    this.dialogUrlRound = false
                    this.ClearCopyAndMenu()
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + this.ProjectObj.Project_name + ' สำเร็จ!!'
                    }, 1500)
                  }
                })
              })
            }
          } else {
            this.GenerateUrl(this.ProjectObj.uuid + '/' + this.rdoGenUrlRound).then(resUrl => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                D_project_id: this.ProjectObj.project_id,
                D_project_round_id: this.rdoGenUrlRound,
                url: resUrl,
                create_by: this.MeData[0].perid,
                create_time: 'now()'
              }, this.axiosHeaderPUT).then(resPUT => {
                if (resPUT.data.status) {
                  this.btnDisable = false
                  this.dialogUrlRound = false
                  this.ClearCopyAndMenu()
                  this.$swal.fire({
                    timer: 1500,
                    showConfirmButton: false,
                    icon: 'success',
                    title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + this.ProjectObj.Project_name + ' สำเร็จ!!'
                  }, 1500)
                }
              })
            })
          }
        })
      }
    },
    GenerateRoundUrl() {
      if (this.rdoGenUrlRound == null) {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาเลือกรุ่น ในการสร้างลิงค์รับสมัคร !!'
        })
      } else {
        this.btnDisable = true
        this.saveUrl()
      }
    },
    getCreateUrl(item) {
      this.initMeData().then(res => {
        if (res) {
          this.$swal.fire({
            title: 'Generate Url รับสมัคร !!',
            text: "คุณต้องการสร้างลิงค์รับสมัครโครงการ " + item.Project_name + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then(async (result) => {
            if (result.value) {
              var checkUpdate = false
              this.ProjectObj = null
              this.ProjectObj = item
              this.ProjectObj.Menu = true
              this.rdoGenUrlRound = null
              if (item.uuid == null || item.uuid == '') {
                var uuid = this.$uuid.v1()
                await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/id/' + item.project_id, {
                  uuid: uuid,
                  update_by: this.MeData[0].perid
                }).then(resUpdate => {
                  if (resUpdate.data.status) {
                    item.uuid = uuid
                    this.ProjectObj.uuid = uuid
                    if (item.IsRoundStatus == '0') {
                      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + item.project_id + '/active/1').then(resGet => {
                        if (resGet.data) {
                          if (resGet.data.length > 0) {
                            if (item.IsRoundStatus == '0' && resGet.data.filter(url_I => url_I.D_project_round_id != '').length > 0) {
                              checkUpdate = true
                              resGet.data.map(url_I => {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + url_I.id, {
                                  active: '0',
                                  update_by: this.MeData[0].perid
                                })
                              })
                            } else if (item.IsRoundStatus == '1' && resGet.data.filter(url_I => url_I.D_project_round_id == '').length > 0) {
                              checkUpdate = true
                              resGet.data.map(url_I => {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + url_I.id, {
                                  active: '0',
                                  update_by: this.MeData[0].perid
                                })
                              })
                            }
                          } else {
                            if (item.IsRoundStatus == '0' && resGet.data.D_project_round_id != '') {
                              checkUpdate = true
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                                active: '0',
                                update_by: this.MeData[0].perid
                              })
                            } else if (item.IsRoundStatus == '1' && resGet.data.D_project_round_id == '') {
                              checkUpdate = true
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                                active: '0',
                                update_by: this.MeData[0].perid
                              })
                            }
                          }

                          if (!checkUpdate) {
                            if (resGet.data.length > 0) {
                              var result = resGet.data.filter(url_I => url_I.D_project_round_id == this.rdoGenUrlRound)
                              if (result.length > 0) {
                                result.map(url_I => {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + url_I.id, {
                                    active: '0',
                                    update_by: this.MeData[0].perid
                                  })
                                })
                              }
                              this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                                  D_project_id: item.project_id,
                                  D_project_round_id: null,
                                  url: resUrl,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, this.axiosHeaderPUT).then(resPUT => {
                                  if (resPUT.data.status) {
                                    this.ClearCopyAndMenu()
                                    this.$swal.fire({
                                      timer: 1500,
                                      showConfirmButton: false,
                                      icon: 'success',
                                      title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                                    }, 1500)
                                  }
                                })
                              })
                            } else {
                              if (resGet.data.D_project_round_id == this.rdoGenUrlRound) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                                  active: '0',
                                  update_by: this.MeData[0].perid
                                }).then(resUpdate => {
                                  if (resUpdate.data.status) {
                                    this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                                        D_project_id: item.project_id,
                                        D_project_round_id: null,
                                        url: resUrl,
                                        create_by: this.MeData[0].perid,
                                        create_time: 'now()'
                                      }, this.axiosHeaderPUT).then(resPUT => {
                                        if (resPUT.data.status) {
                                          this.ClearCopyAndMenu()
                                          this.$swal.fire({
                                            timer: 1500,
                                            showConfirmButton: false,
                                            icon: 'success',
                                            title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                                          }, 1500)
                                        }
                                      })
                                    })
                                  }
                                })
                              } else {
                                this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                                    D_project_id: item.project_id,
                                    D_project_round_id: null,
                                    url: resUrl,
                                    create_by: this.MeData[0].perid,
                                    create_time: 'now()'
                                  }, this.axiosHeaderPUT).then(resPUT => {
                                    if (resPUT.data.status) {
                                      this.ClearCopyAndMenu()
                                      this.$swal.fire({
                                        timer: 1500,
                                        showConfirmButton: false,
                                        icon: 'success',
                                        title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                                      }, 1500)
                                    }
                                  })
                                })
                              }
                            }
                          } else {
                            this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                                D_project_id: item.project_id,
                                D_project_round_id: null,
                                url: resUrl,
                                create_by: this.MeData[0].perid,
                                create_time: 'now()'
                              }, this.axiosHeaderPUT).then(resPUT => {
                                if (resPUT.data.status) {
                                  this.ClearCopyAndMenu()
                                  this.$swal.fire({
                                    timer: 1500,
                                    showConfirmButton: false,
                                    icon: 'success',
                                    title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                                  }, 1500)
                                }
                              })
                            })
                          }
                        } else {
                          this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                              D_project_id: item.project_id,
                              D_project_round_id: null,
                              url: resUrl,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, this.axiosHeaderPUT).then(resPUT => {
                              if (resPUT.data.status) {
                                this.ClearCopyAndMenu()
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                                }, 1500)
                              }
                            })
                          })
                        }
                      })
                    } else {
                      this.getProjectRoundData({
                        Project_code: item.Project_code
                      }).then(res => {
                        if (res) {
                          this.dialogUrlRound = true
                        }
                      })
                    }
                  } else {
                    this.$swal.fire({
                      icon: 'error',
                      title: 'พบข้อผิดพลาด ไม่สามารถสร้างลิงค์รับสมัครได้ โปรดติดต่อผู้ดูแลระบบ !!'
                    })
                  }
                })
              } else {
                if (item.IsRoundStatus == '0') {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + item.project_id + '/active/1/?limit=1').then(resGet => {
                    if (resGet.data) {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/id/' + resGet.data.id, {
                        active: '0',
                        update_by: this.MeData[0].perid
                      }).then(resUpdate => {
                        if (resUpdate.data.status) {
                          this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                              D_project_id: item.project_id,
                              D_project_round_id: null,
                              url: resUrl,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, this.axiosHeaderPUT).then(resPUT => {
                              if (resPUT.data.status) {
                                this.ClearCopyAndMenu()
                                this.$swal.fire({
                                  timer: 1500,
                                  showConfirmButton: false,
                                  icon: 'success',
                                  title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                                }, 1500)
                              }
                            })
                          })
                        }
                      })
                    } else {
                      this.GenerateUrl(item.uuid + '/' + item.Project_code).then(resUrl => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/', {
                          D_project_id: item.project_id,
                          D_project_round_id: null,
                          url: resUrl,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, this.axiosHeaderPUT).then(resPUT => {
                          if (resPUT.data.status) {
                            this.ClearCopyAndMenu()
                            this.$swal.fire({
                              timer: 1500,
                              showConfirmButton: false,
                              icon: 'success',
                              title: 'สร้างลิงค์รับสมัครสำเร็จ โครงการ ' + item.Project_name + ' สำเร็จ!!'
                            }, 1500)
                          }
                        })
                      })
                    }
                  })
                } else {
                  this.getProjectRoundData({
                    Project_code: item.Project_code
                  }).then(res => {
                    if (res) {
                      this.dialogUrlRound = true
                    }
                  })
                }
              }
            }
          })
        }
      })
    },
    Copy(item) {
      this.initMeData().then(res => {
        if (res) {
          // this.$refs.menuRef.isActive = false
          var opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            quality: 1,
            margin: 1,
            scale: 20
          }
          var qr = ''
          this.url = ''
          this.qrUrl = ''
          this.ProjectObj = null
          this.ProjectObj = item
          this.ProjectObj.Menu = true
          if (item.IsRoundStatus == '0') {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + item.project_id + '/active/1/?limit=1').then(async resGet => {
              if (resGet.data) {
                this.url = resGet.data.url
                this.ProjectObj.IsCopy = true
                QRCode.toDataURL(this.url, opts, (err, url) => {
                  qr = url
                })
                this.qrUrl = qr
                this.dialogQr = true
                // this.$swal.fire({
                //   position: 'top-end',
                //   icon: 'warning',
                //   title: 'โปรดคลิกปุ่ม คัดลอกลิงค์ อีกครั้ง!!',
                //   showConfirmButton: false,
                //   timer: 1500
                // })
              } else {
                this.allProjectDataToTable.map(itemP => itemP.IsCopy = false)
                this.allProjectDataToTableDump.map(itemP => itemP.IsCopy = false)
                this.projectDataToTable.map(itemP => itemP.IsCopy = false)
                this.ProjectObj.Menu = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูล ลิงค์รับสมัคร โปรดทำรายการเปิดใช้งานลิงค์รับสมัครก่อนทำการ copy ลิงค์รับสมัคร !!'
                })
              }
            })
          } else {
            this.ProjectObj.Menu = false
            this.getProjectRoundData({
              Project_code: item.Project_code
            }).then(res => {
              if (res) {
                this.dialogUrlRound2 = true
              }
            })
          }
        }
      })
    },
    CopyUrl() {
      this.initMeData().then(res => {
        if (res) {
          var opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            quality: 1,
            margin: 1,
            scale: 20
          }
          var qr = ''
          this.url = ''
          this.qrUrl = ''
          this.btnDisable2 = true
          if (this.rdoGenUrlRound2 != null) {
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + this.ProjectObj.project_id + '/D_project_round_id/' + this.rdoGenUrlRound2 + '/active/1/?limit=1').then(resGet => {
              if (resGet.data) {
                this.url = resGet.data.url

                this.btnDisable2 = false
                this.ProjectObj.IsCopy = true
                QRCode.toDataURL(this.url, opts, (err, url) => {
                  qr = url
                })
                this.qrUrl = qr
                this.dialogQr = true
                // this.$swal.fire({
                //   position: 'top-end',
                //   icon: 'warning',
                //   title: 'โปรดคลิกปุ่ม คัดลอกลิงค์ อีกครั้ง!!',
                //   showConfirmButton: false,
                //   timer: 1500
                // })
              } else {
                this.allProjectDataToTable.map(itemP => itemP.IsCopy = false)
                this.allProjectDataToTableDump.map(itemP => itemP.IsCopy = false)
                this.projectDataToTable.map(itemP => itemP.IsCopy = false)
                this.btnDisable2 = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'ไม่พบข้อมูล ลิงค์รับสมัคร โปรดทำรายการเปิดใช้งานลิงค์รับสมัครก่อนทำการ copy ลิงค์รับสมัคร !!'
                })
              }
            })
          } else {
            this.allProjectDataToTable.map(itemP => itemP.IsCopy = false)
            this.allProjectDataToTableDump.map(itemP => itemP.IsCopy = false)
            this.projectDataToTable.map(itemP => itemP.IsCopy = false)
            this.btnDisable2 = false
            this.$swal.fire({
              icon: 'error',
              title: 'กรุณาเลือกรุ่นในการจัดโครงการ เพื่อ copy ลิงค์รับสมัคร !!'
            })
          }
        }
      })
    },
    CopySuccess() {
      this.dialogUrlRound2 = false
      this.allProjectDataToTable.map(itemP => itemP.IsCopy = false)
      this.allProjectDataToTableDump.map(itemP => itemP.IsCopy = false)
      this.projectDataToTable.map(itemP => itemP.IsCopy = false)
      this.allProjectDataToTable.map(itemP => itemP.Menu = false)
      this.allProjectDataToTableDump.map(itemP => itemP.Menu = false)
      this.projectDataToTable.map(itemP => itemP.Menu = false)
      this.$swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'คัดลอกลิงค์ ' + this.url + ' สำเร็จ !!',
        showConfirmButton: false,
        timer: 1000
      })
    },
    downloadURI() {
      if (this.qrUrl != '' && this.ProjectObj != null) {
        var link = document.createElement("a");
        link.download = 'ไฟล์ภาพ QR CODE โครงการ ' + this.ProjectObj.Project_name;
        link.href = this.qrUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link.remove();
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่พบข้อมูล QR CODE โปรดทำรายการคัดลอกลิงค์รับสมัครก่อนทำการดาวน์โหลด !!'
        })
      }
    },
    ClearCopyAndMenu() {
      this.ProjectObj.Menu = false
      this.allProjectDataToTable.map(itemP => itemP.IsCopy = false)
      this.allProjectDataToTableDump.map(itemP => itemP.IsCopy = false)
      this.projectDataToTable.map(itemP => itemP.IsCopy = false)
      this.allProjectDataToTable.map(itemP => itemP.Menu = false)
      this.allProjectDataToTableDump.map(itemP => itemP.Menu = false)
      this.projectDataToTable.map(itemP => itemP.Menu = false)
    },
    GenerateUrl(appendUrl) {
      return new Promise(resolve => {
        TinyURL.shorten(ConstData.ProjectGenerateLink + appendUrl).then(function (res) {
          resolve(res)
        }, function (err) {
          console.log(err)
        })
      })
    },
    GetRoundDetail(item) {
      this.RoundDataDump = null
      this.RoundDataDump = item
      this.ProjectQuotaDepCount = 0
      var RoundDump = this.RoundData.filter(Round_i => Round_i.id == item.id)
      if (RoundDump.length > 0) {
        this.round = RoundDump[0].round
        this.round_name = RoundDump[0].round_name
        this.dateRegS = RoundDump[0].dateRegS
        this.dateRegE = RoundDump[0].dateRegE
        this.time_start = RoundDump[0].time_start
        this.time_end = RoundDump[0].time_end
        this.DataCondi = RoundDump[0].WorkAgeData
        if (this.DataCondi.length > 0) {
          this.DataCondi.map(dataI => {
            dataI.workAgeStart = dataI.WSYear
            dataI.workAgeEnd = dataI.WEYear
          })
        }
        this.ChooseTypRegis = RoundDump[0].ChooseTypRegis
        this.ChooseTypRegis2 = RoundDump[0].ChooseTypRegis2
        this.dateRegStart = RoundDump[0].dateRegStart
        this.dateRegEnd = RoundDump[0].dateRegEnd
        this.ChkJoinPerson = RoundDump[0].ChkJoinPerson
        if (RoundDump[0].ProjectQuotaCount == '0') {
          this.ProjectQuotaCount = ''
        } else {
          this.ProjectQuotaCount = RoundDump[0].ProjectQuotaCount
        }

        this.DepQuotaData = RoundDump[0].DepQuotaData
        if (this.DepQuotaData.length > 0) {
          this.DepQuotaData.map(Group_I => {
            this.ProjectQuotaDepCount += parseInt(Group_I.count)
          })
        }
        this.JoinPerson = RoundDump[0].JoinPersonData

      }
      this.dialogRound = true
    },
    filterTypeReg() {
      if (this.JoinPersonDump.length == 0) {
        this.JoinPersonDump = this.JoinPerson
      }
      switch (this.TypeReg) {
        case "0":
          this.JoinPerson = this.JoinPersonDump
          break
        case "1":
          this.JoinPerson = this.JoinPersonDump.filter(item => item.join_status == '0')
          break
        case "2":
          this.JoinPerson = this.JoinPersonDump.filter(item => item.join_status == '1')
          break
        default:
          break
      }
    },
    ChangeTypeProject() {
      console.log(this.TypeProcess)
    },
    ChooseTypeStatus() {
      this.projectDataToTable = []
      if (this.TypeProject == '1') {
        this.projectDataToTable = this.allProjectDataToTableDump.filter(item => item.Project_type == this.TypeProject && item.Approve == this.typeStatus)
      } else {
        this.projectDataToTable = this.allProjectDataToTableDump.filter(item => item.Project_type == this.TypeProject)
      }

      // if (this.typeStatus == '3' && this.typeStatus2 == '8') {
      //   this.projectDataToTable = this.allProjectDataToTableDump
      // } else if (this.typeStatus == '3' && this.typeStatus2 != '8') {
      //   this.projectDataToTable = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == this.typeStatus2)
      // } else if (this.typeStatus != '3' && this.typeStatus2 == '8') {
      //   this.projectDataToTable = this.allProjectDataToTableDump.filter(item => item.Approve == this.typeStatus)
      // } else if (this.typeStatus != '3' && this.typeStatus2 != '8') {
      //   this.projectDataToTable = this.allProjectDataToTableDump.filter(item => item.Approve == this.typeStatus && item.IsPlanStatus == this.typeStatus2)
      // }
      this.cal_count_type()
    },
    cal_count_type() {
      this.countAll = this.allProjectDataToTableDump.length
      this.countFaculty = this.allProjectDataToTableDump.filter(item => item.Approve == '1').length
      this.countDep = this.allProjectDataToTableDump.filter(item => item.Approve == '0').length

      if (this.typeStatus == '3') {

        this.countAll2 = this.allProjectDataToTableDump.length
        this.count0 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '0').length
        this.count1 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '1').length
        this.count2 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '2').length
        this.count3 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '3').length
        this.count4 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '4').length
        this.count5 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '5').length
        this.count6 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '6').length
        this.count9 = this.allProjectDataToTableDump.filter(item => item.IsPlanStatus == '9').length

      } else if (this.typeStatus == '1') {

        this.countAll2 = this.allProjectDataToTableDump.filter(item => item.Approve == '1').length
        this.count0 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '0').length
        this.count1 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '1').length
        this.count2 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '2').length
        this.count3 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '3').length
        this.count4 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '4').length
        this.count5 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '5').length
        this.count6 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '6').length
        this.count9 = this.allProjectDataToTableDump.filter(item => item.Approve == '1' && item.IsPlanStatus == '9').length

      } else {
        this.countAll2 = this.allProjectDataToTableDump.filter(item => item.Approve == '0').length
        this.count0 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '0').length
        this.count1 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '1').length
        this.count2 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '2').length
        this.count3 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '3').length
        this.count4 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '4').length
        this.count5 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '5').length
        this.count6 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '6').length
        this.count9 = this.allProjectDataToTableDump.filter(item => item.Approve == '0' && item.IsPlanStatus == '9').length
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail.push(item.History_Experts[0])
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate(param) {
      // this.dialogTemplate = true
      // this.generateReport()
      var CheckIsEmpty = false
      if (param == '1' && (this.editorData == null || this.editorData == '')) {
        CheckIsEmpty = true
      } else if (param == '2' && (this.editorData2 == null || this.editorData2 == '')) {
        CheckIsEmpty = true
      } else if (param == '3' && (this.editorData3 == null || this.editorData3 == '')) {
        CheckIsEmpty = true
      }
      if (CheckIsEmpty) {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่พบข้อมูลแบบฟอร์มที่เลือก !!'
        })
      } else {
        let routeData = this.$router.resolve({
          name: 'PrintData',
          query: {data: (param == '1' ? this.editorData : param == '2' ? this.editorData2 : this.editorData3)}
        });
        window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
      }
    },
    printFormExpanse() {
      let routeData = this.$router.resolve({
        name: 'PrintData',
        query: {data: document.getElementById('FormExpensesPrintData').innerHTML}
      });
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != '' && this.dateEForLecturer != '' && this.timeSForLecturer != '' && this.timeEForLecturer != '') {
        this.Lecturer.push({
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer
        })
        this.SubjectForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    ChangeForm(idForm) {
      if (idForm == '1') {
        this.form1 = true
        this.form2 = false
      } else {
        this.form1 = false
        this.form2 = true
      }
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    BackMenu() {
      this.Details_Cordi = false
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    ShowCompeDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    getInitProjectCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/active/1/Project_code/' + item.Project_code
      axios.get(urlConnection).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          // Error Competency
        }
      })
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      this.dialogLoading = true
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/' + item.Project_code + '/active/1'
      axios.get(urlConnection).then(res => {
        if (res.data) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          this.dialogCompetency = true
          this.dialogLoading = false
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
        }
      })
    },
    showFile() {
      this.dialogFile = true
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    getLecturer(param) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/active/1/perid/' + param.perid + '/Ref_id/' + param.Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = null
          }
          resolve(dumpArr)
        }).catch(res => {
          if (res) {
            resolve(null)
          }
        })
      })
    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/active/1/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    DelProjectOwner(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบข้อมูลโครงการ " + item.Project_name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then(async (result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code + '/?limit=1', '', {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + res.data.Ref_id, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Lecturer/Ref_id/' + res.data.Ref_id, '', headerAxios)
            }
          })

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_round/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Person_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_url/D_project_id/' + item.project_id, '', headerAxios)

          setTimeout(() => {
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'ลบข้อมูลโครงการ  ' + item.Project_name + '  สำเร็จ!!'
            }, 1500)
            this.init()
          })
        }
      })
    },
    DelProject(item) {
      this.initMeData().then(res => {
        if (res) {
          this.CheckPermission().then(res => {
            if (res) {
              this.$swal.fire({
                title: 'ยืนยันการทำรายการ',
                text: "คุณต้องการลบข้อมูลโครงการ " + item.Project_name + ' ใช่หรือไม่ ??',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
              }).then((result) => {
                if (result.value) {
                  axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                    queryName: 'deleteProjData',
                    param: btoa(JSON.stringify({
                      id: item.Project_code,
                      Update_By: this.MeData[0].perid
                    }))
                  }).then(res => {
                    if (res.data.status) {
                      this.dialogLoading = true
                      setTimeout(() => {
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'ลบข้อมูลโครงการ  ' + item.Project_name + '  สำเร็จ!!'
                        }, 1500)
                        this.selProjFiscalYear()
                      })
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'พบข้อผิดพลาดไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    remarksProject(item, status) {
      this.ProjectObj = item
      this.closeStatus = status
      this.dialogCancelOrCloseProject = true
    },
    updateStatusProject(item, status) {
      this.initMeData().then(res => {
        if (res) {
          this.CheckPermission().then(res => {
            if (res) {
              if (this.remarksCloseProject == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'กรุณาระบุเหตุผลในการปิดหรือยกเลิกโครงการ'
                })
              } else {
                this.$swal.fire({
                  title: 'ยืนยันการทำรายการ',
                  text: (status == '8' ? "ต้องการปิดโครงการ " + item.Project_name + ' ใช่หรือไม่ ??' : "ต้องการยกเลิกโครงการ " + item.Project_name + ' ใช่หรือไม่ ??'),
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'ตกลง',
                  cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                  if (result.value) {
                    this.dialogLoading = true
                    axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                      queryName: 'updateStatus',
                      param: btoa(JSON.stringify({
                        id: item.Project_code,
                        status: status,
                        remarks: this.remarksCloseProject,
                        Update_By: this.MeData[0].perid
                      }))
                    }).then(res => {
                      if (res.data.status) {
                        if ((item.Approve == '1' && item.Project_type == '1') || (item.Project_type == '2' && (item.IsProcess == '3' || item.IsExpense == '0'))) {
                          this.initApproveMasterByType({
                            type: item.Project_category
                          }).then(res => {
                            if (res) {
                              if (this.ApproveMaster.length > 0) {
                                var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == item.Project_category && Approveitem.sendmail == '1' && Approveitem.readonly == '0' && Approveitem.project_type != '1')
                                if (SendMailApprove.length > 0) {
                                  SendMailApprove.map(SendMailI => {
                                    if (status == '8') {
                                      this.SendMailSucProject(SendMailI, item)
                                    } else {
                                      // ยกเลิกโครงการไม่ส่งเมล
                                      // this.SendMailCancelPlan(SendMailI, item)
                                    }
                                  })
                                }
                              }
                            }
                          })
                        } else {
                          if (status == '8') {
                            this.execProcessSendMail("2", item)
                          } else {
                            this.execProcessSendMail("3", item)
                          }
                        }

                        setTimeout(() => {
                          this.$swal.fire({
                            timer: 1500,
                            showConfirmButton: false,
                            icon: 'success',
                            title: (status == '8' ? 'ปิดโครงการ  ' + item.Project_name + '  สำเร็จ!!' : 'ยกเลิกโครงการ  ' + item.Project_name + '  สำเร็จ!!')
                          }, 1500)
                        })
                        this.remarksCloseProject = false
                        this.dialogCancelOrCloseProject = false
                        this.selProjFiscalYear()

                      } else {
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาดไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                        })
                      }
                    })
                  }
                })
              }
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    async ShowDetail(item) {
      this.dialogLoading = true
      this.e1 = '1'
      this.Expense = 0
      this.ExpenseSummary = 0
      this.satisfaction = 0
      this.Knowledge_before = 0
      this.Knowledge_after = 0
      this.countAllPerson = 0

      this.files = []
      this.Coordinator = []
      this.courseCondi = []
      this.competency_DataForSubmit = []
      this.expense_DataForSubmit = []
      this.expense_p_DataForSubmit = []
      this.FileProject = []
      this.DataCondi = []
      this.JoinPerson = []
      this.RecordData = []
      this.budgetData = []
      this.Lecturer = []
      this.TemplateProject = []
      this.DepQuotaData = []
      this.RoundData = []
      this.RecordDataDump = []
      this.JoinTravel = []

      this.editorData = ''
      this.editorData2 = ''
      this.editorData3 = ''
      this.roundNeed = false
      this.TypeReg = '0'
      this.JoinPersonDump = []
      this.TypeBuggetProject = '2'


      this.Details_Cordi = true
      this.ProjectObj = null
      this.ProjectObj = item
      this.Project = item
      this.Project_code = item.Project_code
      this.Project_name = item.Project_name
      this.Course_code = item.Course_code
      this.course_group = item.Course_group
      this.Period_code = item.Period_code
      this.Project_type = item.Project_type
      this.Objective = item.Objective
      this.TargetGroup = item.TargetGroup
      this.Remarks = item.Remarks
      this.CalCredit = item.CalCredit
      this.CalHourse = item.CalHourse
      this.PLACE = item.PLACE
      this.Province_id = item.Province_id
      this.Country_id = item.Country_id
      this.BudgetRequest = item.BudgetRequest
      this.ExpenseSummary = parseFloat(item.ExpenseSummary)
      this.Expense = parseFloat(item.ExpenseSummary)
      this.Location = item.Location
      this.WorkBy = item.WorkBy
      this.WorkByName = item.WorkByName
      this.WorkByPhone = item.WorkByPhone
      this.DateStart = item.DateStart
      this.DateEnd = item.DateEnd
      this.DepSelect = item.Dep_Code
      this.Project_group = item.Project_group
      this.FiscalYear = parseInt(item.FiscalYear)
      this.IsPlan = item.IsPlan
      this.itemCode = item.Item_Code

      this.ChooseTypeDep = item.Approve
      this.ChooseTypRegis = item.Status_Reg
      this.ChooseTypRegis2 = item.Status_Type_Reg
      this.dateRegStart = item.DateS_Reg
      this.dateRegEnd = item.DateE_Reg
      this.ProjectQuotaCount = item.Count_Reg
      this.episode = item.DatePeriod

      this.satisfaction = item.indicators.length > 0 ? item.indicators[0].satisfaction != null ? parseFloat(item.indicators[0].satisfaction) : 0 : 0;
      this.Knowledge_before = item.indicators.length > 0 ? item.indicators[0].Knowledge_before == null ? 0 : parseFloat(item.indicators[0].Knowledge_before) : 0;
      this.Knowledge_after = item.indicators.length > 0 ? item.indicators[0].Knowledge_after == null ? 0 : parseFloat(item.indicators[0].Knowledge_after) : 0;


      this.SumAllowance = 0
      this.SumAccommodationCost = 0
      this.SumShippingCosts = 0
      this.SumRegistrationFee = 0
      this.SumAllTravelExpenses = 0
      var qr = ''
      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 1,
        margin: 1,
        scale: 20
      }
      QRCode.toDataURL(this.urlSatisfaction + this.ProjectObj.Project_code + '&vname=' + this.sanitizeProjectNameSatisfaction(this.ProjectObj.Project_name), opts, (err, url) => {
        qr = url
      })
      this.qrUrlSatisfaction = qr
      QRCode.toDataURL(this.urlSatisfaction2 + this.ProjectObj.Project_code + '&vname=' + this.sanitizeProjectNameSatisfaction(this.ProjectObj.Project_name), opts, (err, url) => {
        qr = url
      })
      this.qrUrlSatisfaction2 = qr

      this.ChangeTypeBuggetProject()

      if (this.TypeProject == '2') {
        var checkMatch = false
        this.initJoinTravel({
          Project_code: this.Project_code
        }).then(res => {
          if (res) {
            this.JoinTravelRes.map((item) => {
              checkMatch = false
              this.staffData.map(staff_i => {
                if (staff_i.perid == item.uid) {
                  checkMatch = true
                  this.JoinTravel.push({
                    ...item,
                    ...staff_i,
                    idx: this.JoinTravel.length + 1,
                    full_Name: item.full_name,
                    customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                        '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                    AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                    Lecturer: this.Lecturer.length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid).length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid) : null : null,
                    files: [],
                    idCard: item.id_card,
                    status_reg: item.join_status
                  })
                }
              })
              if (!checkMatch) {
                this.JoinTravel.push({
                  ...item,
                  idx: this.JoinTravel.length + 1,
                  full_Name: item.full_name,
                  customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                      '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                  AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                  Lecturer: this.Lecturer.length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid).length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid) : null : null,
                  files: [],
                  idCard: item.id_card,
                  status_reg: item.join_status
                })
              }
            })
            if (this.JoinTravel.length > 0) {
              this.JoinTravel.map((item, idx) => {
                item.idx = (this.JoinTravel.length - (idx + 1)) + 1
                this.SumAllowance += parseFloat(item.Allowance)
                this.SumAccommodationCost += parseFloat(item.AccommodationCost)
                this.SumShippingCosts += parseFloat(item.ShippingCosts)
                this.SumRegistrationFee += parseFloat(item.RegistrationFee)
                this.SumAllTravelExpenses += parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee)
              })
            }
          }
        })
      }

      await this.initAllProjectRecordData({
        Project_code: item.Project_code
      }).then(res => {
        if (res) {
          this.RecordDataDump = this.ProjectRecord
          if (this.RecordDataDump.length > 0) {
            this.RecordDataDump.map(item => {
              item.files = []
            })
            axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
              if (res.data) {
                this.dialogLoading = false
                // var files_Project = []
                if (res.data.length > 0) {
                  res.data.map(file_i => {
                    this.RecordDataDump.map(record_i => {
                      if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                        record_i.files.push(file_i)
                      }
                    })
                  })
                } else {
                  this.dialogLoading = false
                  this.RecordDataDump.map(record_i => {
                    if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                      record_i.files.push(res.data)
                    }
                  })
                }
              } else {
                this.dialogLoading = false
              }
            })
          }
        }
      })

      if (item.IsRoundStatus == '0') {
        this.roundNeed = false

        if (item.Status_Count_Reg == '0') {
          this.ChkJoinPerson = false
        } else {
          this.ChkJoinPerson = true
        }
      } else {
        this.roundNeed = true
        this.getRoundData()
      }

      this.getInitProjectCompetency(item)

      this.initProjectCompetencyData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
        }
      })

      this.initProjCommittee({
        Project_code: this.Project_code,
        permiss_check: this.MeData[0].perid
      }).then(res => {
        if (res) {
          this.Coordinator = this.ProjectCommittee
          this.Committee_ToShow = this.ProjectCommittee.filter(itemLecturer => itemLecturer.Committee_code != '6')
          this.LecturerToShow = this.ProjectCommittee.filter(itemLecturer => itemLecturer.Committee_code == '6')
        } else {
          this.projectNeed = false
          this.Coordinator = []
        }
      })

      this.initProjectExpenseData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectExpense.map(ProjectEx => {
            this.expense_Data.map(expenseData => {
              if (ProjectEx.Expense_id == expenseData.cost_id) {
                this.budgetData.push({
                  Expense_id: expenseData.cost_id,
                  Expense_des: expenseData.cost_desc,
                  ReqMoney: ProjectEx.ReqMoney,
                  Rm: ProjectEx.Rm,
                  ReqPerson: ProjectEx.ReqPerson,
                  SumMoney: ProjectEx.SumMoney,
                  Custom_Expense_des: ProjectEx.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + expenseData.cost_desc + '</p>' +
                      '<p style="font-weight: bold;color: cornflowerblue">' + ProjectEx.Rm + '</p>' +
                      '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(ProjectEx.ReqMoney)) + ' บาท ต่อ ' + ProjectEx.ReqPerson + ' คน</p>' :
                      '<p style="font-weight: bold;color: #364eff">' + expenseData.cost_desc + '</p>' +
                      '<p style="font-weight: bold;color: cornflowerblue">' + ProjectEx.Rm + '</p>' +
                      '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(ProjectEx.ReqMoney)) + ' บาท'
                })
              }
            })
          })
        }
      })

      if (item.IsRoundStatus == '0') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/active/1/Project_code/' + this.Project_code + '/?limit=9999').then(res => {
          if (res.data) {
            var type = ''
            if (res.data.length > 0) {
              this.projectNeed = true
              res.data.map((item_qua) => {
                type = ''
                if (item_qua.dep_type == '0') {
                  type = 'หน่วยงาน/ภาควิชา'
                } else {
                  type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                }
                this.DepQuotaData.push({
                  quotaType: item_qua.dep_type,
                  type: type,
                  type_id: item_qua.dep_type,
                  dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                  count: item_qua.count
                })
              })
            } else {
              this.projectNeed = true
              type = ''
              if (res.data.dep_type == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: res.data.dep_type,
                type: type,
                type_id: res.data.dep_type,
                dep_name: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_group_id,
                count: res.data.count
              })
            }

            if (this.DepQuotaData.length > 0) {
              this.DepQuotaData.map(item_dep_q => {
                this.ProjectQuotaDepCount += parseInt(item_dep_q.count)
              })
            }
          } else {
            this.projectNeed = false
            this.DepQuotaData = []
          }
        })
      }

      /* axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code + '/active/1/?limit=9999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.WorkGroupData = res.data
          } else {
            this.projectNeed = true
            this.WorkGroupData.push(res.data)
          }

          if (this.WorkGroupData.length > 0) {
            this.WorkGroupData.map(item_w => {
              this.getLecturer(item_w).then(res => {
                item_w.Lecturer = res
              })
              this.getTrainFiles(item_w.Ref_id).then(res => {
                item_w.files = res
              })
            })
          }
        } else {
          this.projectNeed = false
          this.WorkGroupData = []
        }
      }) */

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + item.Project_code + '/?sort=id_DESC&limit=9999').then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + item.Project_code + '/?sort=id_DESC&limit=9999').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }

            } else {
              this.dialogLoading = false
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
        }
      })

      if (item.IsRoundStatus == '0') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/active/1/Project_code/' + item.Project_code + '/?limit=9999').then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              this.DataCondi = res.data
            } else {
              this.DataCondi.push(res.data)
            }
            if (this.DataCondi.length > 0) {
              this.DataCondi.map(item => {
                item.workAgeStart = item.WSYear
                item.workAgeEnd = item.WEYear
              })
            }
          } else {
            this.DataCondi = []
          }
        })
      }

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code + '/?limit=9999').then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.courseCondi = res.data
          } else {
            this.courseCondi.push(res.data)
          }
        } else {
          this.courseCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Type/0/Project_code/' + item.Project_code + '/?limit=9999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProject.push({
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.FileProject.push({
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          } else {
            switch (res.data.File_type) {
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                this.FileProject.push({
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'image',
                  type_Img: res.data.File_type
                })
                break
              case 'application/pdf':
                this.FileProject.push({
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'pdf',
                  type_Img: res.data.File_type
                })
                break
              default:
                break
            }
          }
        } else {
          this.FileProject = []
        }
      })

      if (item.IsRoundStatus == '0') {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project_view/Project_code/' + item.Project_code + '/active/1/?limit=9999').then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              res.data.map((item) => {
                this.countAllPerson++
                this.staffData.map(staff_i => {
                  if (staff_i.perid == item.uid) {
                    this.JoinPerson.push({
                      ...item,
                      ...staff_i,
                      full_Name: item.name + ' ' + item.sname,
                      idCard: item.id_card,
                      status_reg: item.join_status
                    })
                  }
                })
              })
              if (this.JoinPerson.length > 0) {
                this.JoinPerson.map((item, idx) => {
                  item.idx = (this.JoinPerson.length - (idx + 1)) + 1
                })
              }
            } else {
              this.staffData.map((staff_i) => {
                if (staff_i.perid == res.data.uid) {
                  this.JoinPerson.push({
                    ...res.data,
                    ...staff_i,
                    idx: this.JoinPerson.length + 1,
                    full_Name: res.data.name + ' ' + res.data.sname,
                    idCard: res.data.id_card,
                    status_reg: res.data.join_status
                  })
                }
              })
              if (this.JoinPerson.length > 0) {
                this.JoinPerson.map((item, idx) => {
                  item.idx = (this.JoinPerson.length - (idx + 1)) + 1
                })
              }
            }
          } else {
            this.JoinPerson = []
          }
        })
      }
    },
    ExecQuotaDepartRegisterProject(Project_code, objItem) {
      var QuotaDepDump = []
      return new Promise(resolve => {
        this.getQuotaDepartRegisterByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resQuota => {
          if (resQuota) {
            if (this.QuotaDepartData.length > 0) {
              var type = ''
              this.QuotaDepartData.map((item_qua) => {
                type = ''
                if (item_qua.dep_type == '0') {
                  type = 'หน่วยงาน/ภาควิชา'
                } else {
                  type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
                }
                QuotaDepDump.push({
                  quotaType: item_qua.dep_type,
                  type: type,
                  type_id: item_qua.dep_type,
                  dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                  dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                  dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                  count: item_qua.count
                })
              })
            }
            resolve(QuotaDepDump)
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    ExecJoinProject(Project_code, objItem) {
      var JoinPersonDump = []
      return new Promise(resolve => {
        this.getJoinProjectByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resJoin => {
          if (resJoin) {
            if (this.JoinProjectData.length > 0) {
              this.JoinProjectData.map((item) => {
                JoinPersonDump.push({
                  ...item,
                  full_Name: item.name + ' ' + item.sname,
                  idCard: item.id_card,
                  status_reg: item.join_status
                })
              })
            }
            resolve(JoinPersonDump)
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    ExecGroupExamProject(Project_code, objItem) {
      return new Promise(resolve => {
        this.getGroupExamProjectByCordi({
          Project_code: Project_code,
          id: objItem.id
        }).then(resGroup => {
          if (resGroup) {
            if (this.GroupExamData.length > 0) {
              resolve(this.GroupExamData)
            }
          }
        }).catch(reason => {
          if (reason) {
            resolve([])
          }
        })
      })
    },
    Project_proposal(item) {
      this.initMeData().then(res => {
        if (res) {
          this.CheckPermission().then(res => {
            if (res) {
              this.proposal = []
              this.proposal = item
              this.dialogProposal = true
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    Project_Organ(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.projOgan = []
          this.projOgan = item
          this.dialogOrganProj = true
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '9001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '9001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    CheckSendmail(perid) {
      return new Promise(resolve => {
        this.initPermissionOptionData({
          perid: perid
        }).then(res => {
          if (res) {
            if (this.OptPermission.length > 0) {
              this.OptPermission.map(optI => {
                this.Option.map(optI2 => {
                  if (optI2.value == 'email') {
                    if (optI.email == '1') {
                      resolve(true)
                    }
                  }
                })
              })
            } else {
              resolve(false)
            }
          } else {
            resolve(false)
          }
        })
      })
    },
    CheckSendmail2(perid) {
      return new Promise(resolve => {
        this.initPermissionOptionUserData({
          perid: perid
        }).then(res => {
          if (res) {
            if (this.getOptUserPermission.length > 0) {
              this.getOptUserPermission.map(optI => {
                this.Option.map(optI2 => {
                  if (optI2.value == 'email') {
                    if (optI.email == '1') {
                      resolve(true)
                    }
                  }
                })
              })
            } else {
              resolve(false)
            }
          } else {
            resolve(false)
          }
        })
      })
    },
    SendMail(obj) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.proposal.Create_By,
        headerName: this.TypeProject == '1' ? 'แจ้งเตือนการพิจารณาโครงการ ' + this.proposal.Project_name + ' (' + this.proposal.Project_code + ')' : 'แจ้งเตือนการพิจารณาคำร้อง เดินทางไปราชการ ' + this.proposal.Project_name + ' (' + this.proposal.Project_code + ')',
        header: this.proposal.Project_name + ' (' + this.proposal.Project_code + ')',
        body: this.TypeProject == '1' ? '<p style="font-size: 25px;color: peru;font-weight: bold">มีการสนออนุมัติเข้ามาใหม่ ชื่อโครงการ: โครงการ ' + this.proposal.Project_name + ' (' + this.proposal.Project_code + ')' + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาโครงการของ ภาควิชา/หน่วยงาน</span> โปรดพิจารณาโครงการในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Project/"> พิจารณาโครงการ </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
            '<p style="font-size: 25px;color: peru;font-weight: bold">เดินทางไปราชการ ' + this.proposal.Project_name + ' (' + this.proposal.Project_code + ')' + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาโครงการของ ภาควิชา/หน่วยงาน</span> โปรดพิจารณาโครงการในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveTravelByDep/' + this.proposal.Project_code + '"> พิจารณาเดินทางไปราชการ </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    execProcessSendMail(callFunc, objProj = null) {
      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'getPermissionByDep',
        param: btoa(JSON.stringify({
          dep_id: this.proposal.Dep_Code,
          permission_id: '1001',
          type: '1'
        }))
      }).then(res => {
        if (res.data.length > 0) {
          res.data.map(App_item => {
            if (App_item.sendmail == '1') {
              switch (callFunc) {
                case "1":
                  this.SendMail(App_item)
                  break
                case "2":
                  this.SendMailSucProject(App_item, objProj)
                  break
                case "3":
                  this.SendMailCancelPlan(App_item, objProj)
                  break
                default:
                  break
              }
            }
          })
        }
      }).catch(res => {
        if (res) {
          console.log(res)
        }
      })

      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'getPermissionByDep',
        param: btoa(JSON.stringify({
          dep_id: this.proposal.Dep_Code,
          permission_id: '1001',
          type: '2'
        }))
      }).then(res2 => {
        if (res2.data.length > 0) {
          res2.data.map(App_item => {
            if (App_item.sendmail == '1') {
              switch (callFunc) {
                case "1":
                  this.SendMail(App_item)
                  break
                case "2":
                  this.SendMailSucProject(App_item, objProj)
                  break
                case "3":
                  this.SendMailCancelPlan(App_item, objProj)
                  break
                default:
                  break
              }
            }
          })
        }
      }).catch(res => {
        if (res) {
          console.log(res)
        }
      })
    },
    Organize_project_exec() {
      this.dialogLoading = true
      this.dialogOrganProj = false
      this.allProjectDataToTable = []
      this.projectDataToTable = []
      const param = {
        Status: '1',
        Update_By: this.MeData[0].perid
      }

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.projOgan.Project_code, param, headerAxios).then(res => {
        if (res.data.status) {
          this.ExecInsertLogApprove(this.projOgan.Project_code, '1').then(resLog => {
            if (resLog) {
              this.selProjFiscalYear()
              if ((this.projOgan.Approve == '1' && (this.projOgan.Project_type == '1') || (this.projOgan.Project_type == '2' && (this.projOgan.IsProcess == '3' || this.projOgan.IsExpense == '0')))) {
                this.initApproveMasterByType({
                  type: this.projOgan.Project_category
                }).then(res => {
                  if (res) {
                    if (this.ApproveMaster.length > 0) {
                      var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.projOgan.Project_category && Approveitem.sendmail == '1' && Approveitem.readonly == '0' && Approveitem.project_type != '1')
                      if (SendMailApprove.length > 0) {
                        SendMailApprove.map(SendMailI => {
                          this.SendMailProject(SendMailI, this.projOgan)
                        })
                      }
                    }
                  }
                })
              } else {
                this.execProcessSendMail("1")
              }
            }
          })
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    proposal_To_Db() {
      this.dialogLoading = true
      this.dialogProposal = false
      this.allProjectDataToTable = []
      this.projectDataToTable = []
      const param = {
        IsPlanStatus: '1',
        Update_By: this.MeData[0].perid
      }

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.proposal.Project_code, param, headerAxios).then(res => {
        if (res.data.status) {
          this.ExecInsertLog(this.proposal.Project_code, '1').then(resLog => {
            if (resLog) {
              this.selProjFiscalYear()
              this.execProcessSendMail("1")
            }
          })
        }
        this.dialogLoading = false
      }).catch(resErr => {
        if (resErr) {
          this.dialogLoading = false
        }
      })
    },
    ExecInsertLog(ProjectCode, Status) {
      return new Promise(resolve => {
        var param = {
          Project_code: ProjectCode,
          Type: '2',
          Status: Status,
          Remark: '',
          Date_Approve: this.getDateNowToDB(),
          Create_By: this.MeData[0].perid,
          Create_Time: 'now()',
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }).then(res => {
          if (res.data.status) {
            this.RecordData = []
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(res => {
          if (res) {
            resolve(false)
          }
        })
      })
    },
    getDateNowToDB() {
// Get current timestamp in milliseconds
      const timestamp = Date.now();

// Convert timestamp to Date object
      const date = new Date(timestamp);

// Convert Date object to ISO 8601 format
      const isoString = date.toISOString();

      return isoString
    },
    ExecInsertLogApprove(ProjectCode) {
      return new Promise(resolve => {
        var param = {
          Project_code: ProjectCode,
          Status: '1',
          Create_By: this.MeData[0].perid,
          Create_Time: 'now()',
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_approve/', param, {
          headers: {
            'Content-Type': 'application/json',
            'X-REST-METHOD': 'PUT'
          }
        }).then(res => {
          if (res.data.status) {
            this.RecordData = []
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(res => {
          if (res) {
            resolve(false)
          }
        })
      })
    },
    GetData(item, IsExp, FuncExp) {
      this.DataCondi = []
      this.courseCondi = []
      if (IsExp) {
        FuncExp(false)
      } else {
        FuncExp(true)

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/active/1/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.DataCondi = res.data
            } else {
              this.DataCondi.push(res.data)
            }
          } else {
            this.DataCondi = []
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/active/1/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.courseCondi = res.data
            } else {
              this.courseCondi.push(res.data)
            }
          } else {
            this.courseCondi = []
          }
        })
      }
    },
    ChangeStatus: function (item) {
      if (item.Course_status == '1') {
        const param = {
          Course_status: '9'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data) {
            this.init()
          }
        })
      } else {
        const param = {
          Course_status: '1'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data.status) {
            this.init()
          }
        })
      }
    },
    FormExpenses(ProjectCode) {
      this.FormExpensesPrintData = ''
      this.dialogLoading = true
      this.initApproveFormData({
        Project_code: ProjectCode
      }).then(async res => {
        if (res) {
          if (this.ApproveForm.length > 0) {
            this.ApproveForm[0].message = this.ApproveForm[0].message != null ? this.ApproveForm[0].message.replaceAll('&quot;', '"') : null
            await this.initProjectRecordData({
              Project_code: ProjectCode
            })
            this.dialogApproveForm = true
            this.dialogLoading = false
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลแบบฟอร์ฺมการเบิกจ่ายเงิน !!'
            })
          }
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูลแบบฟอร์ฺมการเบิกจ่ายเงิน !!'
          })
        }
      })
    },
    SendMailApproveForHR(receiverPerid = null, sendPerid = null, projectCode = '-', topic = '-') {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: receiverPerid,
        perid: sendPerid,
        headerName: 'พิจารณาการเดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา) ' + topic + ' (' + projectCode + ')',
        header: topic + ' (' + projectCode + ')',
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">' + topic + ' (' + projectCode + ')' + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณา</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + projectCode + '"> พิจารณาเดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailProject(obj, item) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: item.Create_By,
        headerName: this.TypeProject == '1' ? 'แจ้งเตือนการเสนออนุมัติหลักการโครงการจากแผนตั้งงบประมาณประจำปี ' + item.Project_name + ' (' + item.Project_code + ')' : 'พิจารณาการเดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา) ' + item.Project_name + ' (' + item.Project_code + ')',
        header: item.Project_name + ' (' + item.Project_code + ')',
        body: this.TypeProject == '1' ? '<p style="font-size: 25px;color: peru;font-weight: bold">แผน: ' + item.Project_name + ' (' + item.Project_code + ') ได้ถูกเสนออนุมัติหลักการแล้ว</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/BudgetProject/"> พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
            '<p style="font-size: 25px;color: peru;font-weight: bold"> ' + item.Project_name + ' (' + item.Project_code + ')</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณา</span>โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + item.Project_code + '"> พิจารณาเดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailSucProject(obj, item) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: item.Create_By,
        headerName: this.TypeProject == '1' ? 'แจ้งเตือนการเสร็จสิ้นโครงการจากแผนตั้งงบประมาณประจำปี ' + item.Project_name + ' (' + item.Project_code + ')' : 'แจ้งเตือนการเสร็จสิ้นคำร้องเดินทางไปราชการ ' + item.Project_name + ' (' + item.Project_code + ')',
        header: item.Project_name + ' (' + item.Project_code + ')',
        body: this.TypeProject == '1' ? '<p style="font-size: 25px;color: peru;font-weight: bold">แผน: ' + item.Project_name + ' (' + item.Project_code + ') ณ ขณะนี้ได้เสร็จสิ้นโครงการแล้ว</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/BudgetProject/"> พิจารณาเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
            '<p style="font-size: 25px;color: peru;font-weight: bold">เดินทางไปราชการ: ' + item.Project_name + ' (' + item.Project_code + ') ณ ขณะนี้ได้ดำเนินการเสร็จสิ้นแล้ว</p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailCancelPlan(obj, item) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: item.Create_By,
        headerName: this.TypeProject == '1' ? 'แจ้งเตือนการการยกเลิกเสนอแผนตั้งงบประมาณประจำปี ' + item.Project_name + ' (' + item.Project_code + ')' : 'แจ้งเตือนการการยกเลิกคำร้องเดินทางไปราชการ ' + item.Project_name + ' (' + item.Project_code + ')',
        header: item.Project_name + ' (' + item.Project_code + ')',
        body: this.TypeProject == '1' ? '<p style="font-size: 25px;color: peru;font-weight: bold">มีการยกเลิกแผนเสนอขอตั้งงบประมาณประจำปี ชื่อแผน: ' + item.Project_name + ' (' + item.Project_code + ')</p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
            '<p style="font-size: 25px;color: peru;font-weight: bold">มีการยกเลิกคำร้องเดินทางไปราชการ: ' + item.Project_name + ' (' + item.Project_code + ')</p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    showDialogRound() {
      this.round = "";
      this.round_name = "";
      this.dateRegS = "";
      this.dateRegE = "";
      this.time_start = "";
      this.time_end = "";
      this.DataCondi = [];
      this.ChooseTypRegis = "1";
      this.ChooseTypRegis2 = "0";
      this.ChooseTypRegis3 = "0";
      this.dateRegStart = "";
      this.dateRegEnd = "";
      this.ChkJoinPerson = true;
      this.ProjectQuotaCount = "";
      this.ProjectQuotaDepCount = 0;
      this.DepQuotaData = [];
      this.JoinPerson = [];
      this.MessageSuc = "";
      this.ShowAlertSuc = false;
      this.MessageError = "";
      this.ShowAlertErr = false;
      this.staffSel = "";
      this.departSel = "";
      this.dialogRound = true;
      this.RoundDataDump = null;
      this.save = true;
    },
    getRoundData() {
      return new Promise(resolve => {
        var CheckJoin = false;
        this.RoundData = [];
        axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php",
            {
              queryName: "getProjectRound",
              param: btoa(
                encodeURIComponent(
                  JSON.stringify({
                    Project_code: this.Project_code,
                    permiss_check: this.MeData[0].perid,
                  })
                )
              ),
            }
        ).then((res) => {
          if (res.data.status) {
            if (res.data.Project_round.length > 0) {
              var QuotaDepDump = [];
              res.data.Project_round.map((itemR) => {
                this.countAllPerson += itemR.joinPerjData.length;
                QuotaDepDump = []
                if (itemR.DepQuotaData.length > 0) {
                  var type = "";
                  itemR.DepQuotaData.map((item_qua) => {
                    type = "";
                    if (item_qua.dep_type == "0") {
                      type = "หน่วยงาน/ภาควิชา";
                    } else {
                      type = "กลุ่มหน่วยงาน/กลุ่มภาควิชา";
                    }
                    QuotaDepDump.push({
                      quotaType: item_qua.dep_type,
                      type: type,
                      type_id: item_qua.dep_type,
                      dep_name: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_name,
                      dep_id: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_id,
                      dep_group_id: this.depart.filter(
                          (item) => item.dep_id == item_qua.dep_id
                      )[0].dep_group_id,
                      count: item_qua.count,
                    });
                  });
                }
                if (itemR.Status_Count_Reg == "0") {
                  CheckJoin = false;
                } else {
                  CheckJoin = true;
                }
                this.RoundData.push({
                  id: this.RoundData.length,
                  No: itemR.No,
                  Ref_id: itemR.id,
                  round: itemR.Round,
                  round_name: itemR.Round_name,
                  dateRegS: itemR.DateS,
                  dateRegE: itemR.DateE,
                  time_start: itemR.TimeS,
                  time_end: itemR.TimeE,
                  WorkAgeData: itemR.personLvData,
                  ChooseTypRegis: itemR.Status_Reg,
                  ChooseTypRegis2: itemR.Status_Type_Reg,
                  ChooseTypRegis3: itemR.Status_Type_Reg2,
                  dateRegStart: itemR.DateS_Reg,
                  dateRegEnd: itemR.DateE_Reg,
                  ChkJoinPerson: CheckJoin,
                  ProjectQuotaCount: itemR.Count_Reg,
                  DepQuotaData: QuotaDepDump,
                  JoinPersonData: itemR.joinPerjData,
                  count_person: itemR.joinPerjData.length,
                });
              });
            }
            resolve(true);
          } else {
            resolve(false);
          }
        }).catch((err) => {
          console.log(err);
          resolve(false);
        });
      })
    },
    ExportEmpData() {
      this.json_data = []
      this.array_title = []
      var staff = []
      if (this.ProjectObj.DateStart == '' || this.ProjectObj.DateEnd == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน'
        })
      } else {
        this.array_title.push(this.ProjectObj.Project_name)
        if (this.RoundDataDump != null) {
          this.array_title.push('รุ่นที่ ' + this.RoundDataDump.round + ' ชื่อรุ่น ' + this.RoundDataDump.round_name)
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.dateRegS) + ' ถึง ' + Vue.filter('DateToThai')(this.dateRegE))
        } else {
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.ProjectObj.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.ProjectObj.DateEnd))
        }
        this.array_title.push('สถานที่ ' + this.ProjectObj.Location)
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map((item, idx) => {
            staff = this.staffData.filter(value => value.perid == item.uid)
            if (staff.length > 0) {
              if (parseInt(staff[0].salary) > 20000) {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: '',
                  index: idx + 1,
                  money_permiss: '15500',
                })
              } else {
                this.json_data.push({
                  ...item,
                  perid: staff[0].perid,
                  surname: staff[0].surname,
                  dep_id: staff[0].dep_id,
                  dep_group_id: staff[0].dep_group_id,
                  dep_name: staff[0].dep_name,
                  pos_name: staff[0].pos_name,
                  religion_name: staff[0].religion_name,
                  remark: '',
                  index: idx + 1,
                  money_permiss: '11000'
                })
              }
            }
          })
          this.json_data = this.json_data.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
          this.json_data.map((item, idx) => {
            item.index = (idx + 1)
          })
        }
      }
    },
    ExportData() {
      this.json_data = []
      this.array_title = []
      if (this.ProjectObj.DateStart == '' || this.ProjectObj.DateEnd == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุวันที่เริ่มต้น - วันที่สิ้นสุดโครงการ ให้ครบถ้วน'
        })
      } else {
        this.array_title.push(this.ProjectObj.Project_name)
        if (this.RoundDataDump != null) {
          this.array_title.push('รุ่นที่ ' + this.RoundDataDump.round + ' ชื่อรุ่น ' + this.RoundDataDump.round_name)
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.dateRegS) + ' ถึง ' + Vue.filter('DateToThai')(this.dateRegE))
        } else {
          this.array_title.push('วันที่ ' + Vue.filter('DateToThai')(this.ProjectObj.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.ProjectObj.DateEnd))
        }
        this.array_title.push('สถานที่ ' + this.ProjectObj.Location)
        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map((item, idx) => {
            this.json_data_export.push({
              ...item,
              index: idx + 1,
              full_Name: item.name + ' ' + item.sname
            })
          })
        }
        this.json_data_export = this.json_data_export.sort((a, b) => a.dep_id.localeCompare(b.dep_id));
        this.json_data_export.map((item, idx) => {
          item.index = (idx + 1)
        })
      }
    },
    showFileReport(proj) {
      this.dialogLoading = true
      this.initFileReportTravel({
        Project_code: proj.Project_code
      }).then(res => {
        if (res) {
          this.dialogLoading = false
          if (this.TravelForm.length > 0) {
            window.open(ConstData.ConnectionHost + '/HrTrain2/upload/file/' + this.TravelForm[0].file_name, '_blank');
          }
        }
      })
    },
    showJoinTravel() {
      this.dialogJoinTravel = false
      this.dialogJoinTravel = true
    },
    sortStatusFunc() {

    },
    selProjFiscalYear() {
      this.dialogLoading = true;
      this.projectDataToTable = []
      this.initProjDataFromFiscalYearUser({
        FiscalYear: this.FiscalYear,
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
      }).then((res) => {
        if (res) {
          if (this.ProjectFromFiscalYearUser.length > 0) {
            this.ProjectFromFiscalYearUser.map((Project) => {
              var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
              if (DepBy.length > 0) {
                this.projectDataToTable.push({
                  ...Project,
                  IsCopy: false,
                  Menu: false,
                  full_Name: '' +
                      ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span>' + (Project.IsLog == '1' ? ' <span style="font-weight: bold;color: red">(ถูกล็อค)</span>' : '') + '</div>' +
                      ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                      ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                      ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>' +
                      (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                  Owner: true
                })
              } else if (DepBy.length == 0) {
                this.projectDataToTable.push({
                  ...Project,
                  IsCopy: false,
                  Menu: false,
                  full_Name: '' +
                      ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span>' + (Project.IsLog == '1' ? ' <span style="font-weight: bold;color: black">(ถูกล็อค)</span>' : '') + '</div>' +
                      ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                      ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>' +
                      (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                  Owner: true
                })
              } else {
                this.projectDataToTable.push({
                  ...Project,
                  IsCopy: false,
                  Menu: false,
                  full_Name: '' +
                      ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')' + (Project.IsLog == '1' ? ' <span style="font-weight: bold;color: black">(ถูกล็อค)</span>' : '') + '</span></div>' +
                      ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                      (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                  Owner: true
                })
              }
            })
            this.allProjectDataToTableDump = this.projectDataToTable
          } else {
            this.$swal.fire({
              icon: "error",
              title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
            });
          }
          this.ChooseTypeStatus()
        } else {
          this.$swal.fire({
            icon: "error",
            title: "ไม่พบข้อมูลโครงการในปีงบประมาณนี้",
          });
        }
      }).catch((res) => {
        console.log(res);
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
    ChangeTypeBuggetProject() {
      switch (this.TypeBuggetProject) {
        case "1":

          break;
        case "2":
          this.ExpenseGroup = 0;
          this.budgetHistotyData = [];
          var checkExpense = false
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'getExpenseProject',
            param: btoa(encodeURIComponent(JSON.stringify({
              id: this.Project_code,
              permiss_check: this.MeData[0].perid,
            })))
          }).then(res => {
            if (res.data.length > 0) {
              checkExpense = res.data.filter((item) => item.Expense_name).length > 0 ? true : false
              if (checkExpense) {
                this.budgetHistotyData = res.data;
                this.budgetHistotyData.map((item) => {
                  this.ExpenseGroup += parseFloat(item.SumMoney)
                })
              }
            }
          })
          break;
        case "3":
          this.expenseRealData = [];
          this.ExpenseRealSummay = 0;
          axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
            queryName: 'getExpenseRealProject',
            param: btoa(encodeURIComponent(JSON.stringify({
              id: this.Project_code,
              permiss_check: this.MeData[0].perid,
            })))
          }).then(res => {
            if (res.data.length > 0) {
              this.expenseRealData = res.data;
              this.expenseRealData.map((item) => {
                this.ExpenseRealSummay += parseFloat(item.Mon_total)
              })
            }
          })
          break;
        default:
          break;
      }
    },
    showHistoryExpense(item) {
      this.budgetHistotyDetailData = [];
      this.groupExpenseObj = item
      this.ExpenseGroupDetail = 0
      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
        queryName: 'getExpenseDetailProject',
        param: btoa(encodeURIComponent(JSON.stringify({
          id: item.id,
          permiss_check: this.MeData[0].perid,
        })))
      }).then(res => {
        if (res.data.status && res.data.data.length > 0) {
          res.data.data.map((item) => {
            this.ExpenseGroupDetail += parseFloat(item.SumMoney)
            this.budgetHistotyDetailData.push({
              ...item,
              Expense_id: item.cost_id,
              Expense_des: item.cost_desc,
              Custom_Expense_des: item.ReqPerson > 0 ? '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                  '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                  '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท ต่อ ' + item.ReqPerson + ' คน</p>' :
                  '<p style="font-weight: bold;color: #364eff">' + item.cost_desc + '</p>' +
                  '<p style="font-weight: bold;color: cornflowerblue">' + item.Rm + '</p>' +
                  '<p style="font-weight: bold;color: #ff6d81"> จำนวน : ' + (Vue.filter('currency')(item.ReqMoney)) + ' บาท'
            })
          })
          this.dialogShowHistoryExpense = true;
        }
      }).catch((err) => {
        console.log(err);
        this.$swal.fire({
          icon: "error",
          title: "พบข้อผิดพลาด",
          text: "ไม่สามารถแสดงข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ",
        });
      })
    },
    showHistoryExpenseReal(item) {
      this.expenseDetailRealHistotyData = [];
      this.groupExpenseRealObj = item
      this.expenseDetailRealHistotyData = item.ExpenseDetail
      this.dialogShowHistoryExpenseReal = true;
    },
    CopySuccessSatisfaction() {
      this.$swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'คัดลอกลิงค์สำเร็จ !!',
        showConfirmButton: false,
        timer: 1000
      })
    },
    downloadURISatisfaction(qrUrl) {
      if (qrUrl != '' && this.ProjectObj != null) {
        var link = document.createElement("a");
        link.download = 'ไฟล์ภาพ QR CODE โครงการ ' + this.ProjectObj.Project_name;
        link.href = qrUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link.remove();
      } else {
        this.$swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูล QR CODE",
        });
      }
    },
    selectProjectAndShowQrCode(item, isSatisfaction) {
      if (!item) {
        console.warn("selectProjectAndShowQrCode: item is null or undefined");
        return;
      }
      this.Project = item;
      this.ProjectObj = item;  // ← ตั้ง ProjectObj เพื่อให้ dialog แสดงข้อมูล
      this.Project_code = item.Project_code;  // ← ตั้ง Project_code สำหรับ getRoundData()
      this.qrType = isSatisfaction ? 1 : 2;
      this.selectedRound = null;
      this.handleShowQrCode();
    },
    handleShowQrCode() {
      this.qrType = 1;
      // Reset RoundData ก่อนเรียก getRoundData ใหม่
      this.RoundData = [];
      this.dialogLoading = true;
      // ถ้า RoundData ว่างเปล่า ให้ไป fetch ข้อมูลรุ่นก่อน
      this.getRoundData().then(() => {
        this.dialogLoading = false;
        // fetchเสร็จแล้ว ตรวจสอบว่า RoundData มีข้อมูลหรือไม่
        if (this.RoundData && this.RoundData.length > 0) {
          // มีข้อมูลรอบ → แสดงตัวเลือกรอบ
          this.dialogSelectRound = true;
        } else {
          // ไม่พบข้อมูลรอบ → แสดง QR dialog โดยไม่เลือกรอบ
          this.selectedRound = null;
          this.generateQrCode();
          this.dialogQrSatisfaction = true;
        }
      });
    },
    handleShowQrCode2() {
      this.qrType = 2;
      // Reset RoundData ก่อนเรียก getRoundData ใหม่
      this.RoundData = [];
      this.dialogLoading = true;
      // ถ้า RoundData ว่างเปล่า ให้ไป fetch ข้อมูลรุ่นก่อน
      this.getRoundData().then(() => {
        this.dialogLoading = false;
        // fetchเสร็จแล้ว ตรวจสอบว่า RoundData มีข้อมูลหรือไม่
        if (this.RoundData && this.RoundData.length > 0) {
          // มีข้อมูลรอบ → แสดงตัวเลือกรอบ
          this.dialogSelectRound = true;
        } else {
          // ไม่พบข้อมูลรอบ → แสดง QR dialog โดยไม่เลือกรอบ
          this.selectedRound = null;
          this.generateQrCode();
          this.dialogQrSatisfaction2 = true;
        }
      });
    },
    selectRound(round) {
      this.selectedRound = round;
      this.dialogSelectRound = false;
      if (this.qrType === 3 || this.qrType === 4) {
        this.openCustomUrl(round);
      } else {
        this.generateQrCode();
        if (this.qrType == 1) {
          this.dialogQrSatisfaction = true;
        } else {
          this.dialogQrSatisfaction2 = true;
        }
      }
    },
    selectProjectAndShowQrCodeDialog(item) {
      if (!item) return;
      this.Project = item;
      this.ProjectObj = item;
      this.Project_code = item.Project_code;
      this.qrMenuSurveyType = '1';
      this.dialogQrSurveyType = true;
    },
    createSurveyForm() {
      const code = this.ProjectObj ? this.ProjectObj.Project_code : (this.Project ? this.Project.Project_code : '');
      const name = this.ProjectObj ? this.ProjectObj.Project_name : (this.Project ? this.Project.Project_name : '');
      if (!code) {
        this.$swal.fire({ icon: 'error', title: 'ไม่พบรหัสโครงการ' });
        return;
      }
      const url = 'https://assess.medicine.psu.ac.th/assess_project.php?vproject=' +
        encodeURIComponent(code) +
        '&vname=' +
        encodeURIComponent(this.sanitizeProjectNameSatisfaction(name));
      window.open(url, '_blank');
    },
    handleShowQrCodeCustom() {
      this.qrType = 3;
      this.RoundData = [];
      this.dialogLoading = true;
      this.getRoundData().then(() => {
        this.dialogLoading = false;
        this.openCustomAssessUrl();
      });
    },
    handleShowQrCodeCustomResult() {
      this.qrType = 4;
      this.RoundData = [];
      this.dialogLoading = true;
      this.getRoundData().then(() => {
        this.dialogLoading = false;
        this.openCustomAssessUrl();
      });
    },
    openCustomAssessUrl() {
      const projectCode = this.ProjectObj ? this.ProjectObj.Project_code : (this.Project ? this.Project.Project_code : '');
      if (!projectCode) {
        this.$swal.fire({ icon: 'error', title: 'ไม่พบรหัสโครงการ' });
        return;
      }
      this.customAssessLoading = true;
      axios.get(
        `${ConstData.ConnectionHost}/rest/v1/assess-project/project_code/` + projectCode,
        {
          headers: {
            Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MX0.JNMlpZa3QICtTep5N4K2uspUG9QkOYQpDTQHS-7-gCE'
          }
        }
      ).then(res => {
        this.customAssessLoading = false;
        if (res.data && res.data.length > 0) {
          const maxAssess = res.data.reduce((max, item) => 
            parseInt(item.assess_id) > parseInt(max.assess_id) ? item : max, res.data[0]);
          this.customAssessIdBtoa = btoa(maxAssess.assess_id);
          this.customAssessId = maxAssess.assess_id;
          if (this.RoundData && this.RoundData.length > 0) {
            this.dialogSelectRound = true;
          } else {
            this.selectedRound = null;
            this.openCustomUrl(null);
          }
        } else {
          this.$swal.fire({ icon: 'error', title: 'ไม่พบข้อมูลแบบสอบถามของโครงการนี้' });
        }
      }).catch(err => {
        this.customAssessLoading = false;
        console.error(err);
        this.$swal.fire({ icon: 'error', title: 'ไม่สามารถดึงข้อมูลแบบสอบถามได้' });
      });
    },
    openCustomUrl(round) {
      const projectCode = this.ProjectObj ? this.ProjectObj.Project_code : (this.Project ? this.Project.Project_code : '');
      const projectName = this.ProjectObj ? this.ProjectObj.Project_name : (this.Project ? this.Project.Project_name : '');
      const roundInfo = round ? ' รุ่น ' + (round.round || '') + ' ' + (round.round_name || '') : '';
      const uuid = round ? round.No : 0;
      const assessId = this.customAssessId;
      const assessIdBtoa = this.customAssessIdBtoa;
      let url;
      if (this.qrType === 3) {
        url = 'https://assess.medicine.psu.ac.th/assess_form_project.php?assess_id=' + assessIdBtoa +
          '&vch=1&vproject=' + encodeURIComponent(projectCode) +
          '&vname=' + encodeURIComponent(this.sanitizeProjectNameSatisfaction(projectName) + roundInfo) +
          '&uuid=' + uuid;
      } else {
        url = 'https://assess.medicine.psu.ac.th/assess_result_detail.php?assess_id=' + assessId +
          '&vproject=' + encodeURIComponent(projectCode) +
          '&vname=' + encodeURIComponent(this.sanitizeProjectNameSatisfaction(projectName) + roundInfo) +
          '&uuid=' + uuid;
      }
      window.open(url, '_blank');
    },
    sanitizeProjectNameSatisfaction(name) {
      if (!name) return '';
      return name.replace(/&/g, 'and');
    },
    generateQrCode() {
      var uuid = this.selectedRound ? this.selectedRound.No : 0;
      var roundInfo = this.selectedRound ? ' รุ่น ' + (this.selectedRound.round || '') + ' ' + (this.selectedRound.round_name || '') : '';
      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 1,
        margin: 1,
        scale: 20
      };

      // ใช้ this.ProjectObj เพราะเป็นตัวแปรที่ set ใน ShowDetail()
      var projectCode = this.ProjectObj ? this.ProjectObj.Project_code : (this.Project ? this.Project.Project_code : '');
      var projectName = this.sanitizeProjectNameSatisfaction(this.ProjectObj ? this.ProjectObj.Project_name : (this.Project ? this.Project.Project_name : ''));

      if (!projectCode || !projectName) {
        console.error('generateQrCode: Project data not available');
        return;
      }

      QRCode.toDataURL(this.urlSatisfaction + projectCode + '&vname=' + projectName + roundInfo + '&uuid=' + uuid, opts, (err, url) => {
        if (err) {
          console.error(err);
          return;
        }
        this.qrUrlSatisfaction = url;
      });

      QRCode.toDataURL(this.urlSatisfaction2 + projectCode + '&vname=' + projectName + roundInfo + '&uuid=' + uuid, opts, (err, url) => {
        if (err) {
          console.error(err);
          return;
        }
        this.qrUrlSatisfaction2 = url;
      });
    },
    OpenDialogReport() {
      this.exportType = null
      this.exportType4 = null
      this.exportDepGroup = null
      this.dialogExportPlanProj = true
    },
    ExportDataProj() {
      if (this.exportType != null && this.exportType4 != null && this.exportDepGroup != null) {
        if ((this.exportType4 == '2' || this.exportType4 == '0') && (this.exportType3 === null || this.exportType3 === undefined)) {
          this.$swal.fire({
            icon: 'error',
            title: 'กรุณาเลือกข้อมูลให้ครบถ้วน!',
          })
          return
        }
        this.json_data_proj = []
        var count = 0
        if (this.projectDataToTable.length > 0) {
            // Prepare department filter
            let depIds = [];
            if (this.exportDepGroup !== 'all') {
            depIds = this.depart
              .filter(dep => dep.dep_group_id === this.exportDepGroup)
              .map(dep => dep.dep_id);
            }

            // Filter projects
            let filteredProjects = this.projectDataToTable.filter(item =>
            item.FiscalYear == this.FiscalYear &&
            item.Project_category == this.exportType &&
            item.Project_type == '2' &&
              (
                this.exportDepGroup === 'all'
                ? true
                : depIds.includes(item.Dep_Code)
              )
            );

            if (filteredProjects.length > 0) {
              // ป้องกัน Project_code ซ้ำ และแปลง Create_Time เป็นวันที่ภาษาไทย
              const seenProjectCodes = new Set();
              filteredProjects.map((item) => {
                // คำนวณ DateStart และ DateEnd ตาม episode ของแต่ละ item
                let DateStart = '';
                let DateEnd = '';
                switch (item.DatePeriod) {
                  case '1':
                  DateStart = (parseInt(item.FiscalYear) - 1) + '-10-01';
                  DateEnd = (parseInt(item.FiscalYear) - 1) + '-12-31';
                  break;
                  case '2':
                  DateStart = item.FiscalYear + '-01-01';
                  DateEnd = item.FiscalYear + '-03-31';
                  break;
                  case '3':
                  DateStart = item.FiscalYear + '-04-01';
                  DateEnd = item.FiscalYear + '-06-30';
                  break;
                  case '4':
                  DateStart = item.FiscalYear + '-07-01';
                  DateEnd = item.FiscalYear + '-09-30';
                  break;
                  case '9':
                  DateStart = (parseInt(item.FiscalYear) - 1) + '-10-01';
                  DateEnd = item.FiscalYear + '-09-30';
                  break;
                  default:
                  DateStart = (parseInt(item.FiscalYear) - 1) + '-10-01';
                  DateEnd = item.FiscalYear + '-09-30';
                  break;
                }
                // สร้าง Project_date ตามช่วง DatePeriod
                let Project_date = '';
                switch (item.DatePeriod) {
                  case '1':
                  Project_date = 'ต.ค. ' + (parseInt(item.FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(item.FiscalYear) + 543 - 1);
                  break;
                  case '2':
                  Project_date = 'ม.ค. ' + (parseInt(item.FiscalYear) + 543) + '- มี.ค. ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  case '3':
                  Project_date = 'เม.ย. ' + (parseInt(item.FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  case '4':
                  Project_date = 'ก.ค. ' + (parseInt(item.FiscalYear) + 543) + '- ก.ย. ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  case '9':
                  Project_date = 'ตลอดปีงบประมาณ ' + (parseInt(item.FiscalYear) + 543);
                  break;
                  default:
                  Project_date = '';
                }

                function formatThaiDate(dateStr) {
                  if (!dateStr) return '';
                  const months = [
                  '', 'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
                  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
                  ];
                  const d = new Date(dateStr);
                  if (isNaN(d)) return '';
                  const day = d.getDate();
                  const month = months[d.getMonth() + 1];
                  const year = d.getFullYear() + 543;
                  const hour = d.getHours().toString().padStart(2, '0');
                  const min = d.getMinutes().toString().padStart(2, '0');
                  const sec = d.getSeconds().toString().padStart(2, '0');
                  return `${day} ${month} ${year} ${hour}:${min}:${sec}`;
                }

                if (!seenProjectCodes.has(item.Project_code)) {
                  seenProjectCodes.add(item.Project_code);

                  const Create_Time_Thai = formatThaiDate(item.Create_Time);

                    if (
                      this.exportType4 == '0' &&
                      (item.IsPlanStatus == '2' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8')
                    ) {
                      const money = parseFloat(item.MoneyDisburse || 0)
                      const type3 = this.exportType3 // '9' = ทั้งหมด, '0' = MoneyDisburse == 0, '1' = MoneyDisburse > 0
                      const include =
                        type3 === '9' ||
                        (type3 === '0' && money === 0) ||
                        (type3 === '1' && money > 0)

                      if (include) {
                        this.json_data_proj.push({
                          ...item,
                          index: ++count,
                          PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                          WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                          Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                          FiscalYear2: parseInt(item.FiscalYear) + 543,
                          DateStart,
                          DateEnd,
                          Project_date,
                          Create_Time: Create_Time_Thai
                        });
                      }
                    } else if (
                      this.exportType4 == '2' &&
                      (item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8')
                      ) {
                      const money = parseFloat(item.MoneyDisburse || 0)
                      const type3 = this.exportType3 // '9' = ทั้งหมด, '0' = MoneyDisburse == 0, '1' = MoneyDisburse > 0
                      const include =
                        type3 === '9' ||
                        (type3 === '0' && money === 0) ||
                        (type3 === '1' && money > 0)

                      if (include) {
                        this.json_data_proj.push({
                        ...item,
                        index: ++count,
                        PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                        WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                        Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                        FiscalYear2: parseInt(item.FiscalYear) + 543,
                        DateStart,
                        DateEnd,
                        Project_date,
                        Create_Time: Create_Time_Thai
                        })
                      }
                  } else if (this.exportType4 == '1') {
                    this.json_data_proj.push({
                      ...item,
                      index: ++count,
                      PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                      WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                      Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                      FiscalYear2: parseInt(item.FiscalYear) + 543,
                      DateStart,
                      DateEnd,
                      Project_date,
                      Create_Time: Create_Time_Thai
                    });
                  }
                }
              })
            } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลที่ต้องการ Export'
            })
            }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบข้อมูลที่ต้องการ Export'
          })
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
  },
  mounted() {
    this.changeHeaderPage({
      page: '1'
    })
    this.changeManageProjectPage({
      page: '1'
    })
    for (var l = 2020; l <= (new Date().getFullYear() + 3); l++) {
      this.FiscalYearDataSel.push({
        year: l,
        yearth: l + 543
      })
    }
    
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '8',
          page_sub_id: '4',
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '9000') {
                this.getSubMenuPermissData().then(res => {
                  if (res) {
                    if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '4' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '4' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '4')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '4' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '4')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                  }
                })
                this.CheckAdmin = true
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '9000') {
                    this.getSubMenuPermissData().then(res => {
                      if (res) {
                        if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '4' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '4' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '4')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '4' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '4')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                      }
                    })
                    this.CheckSubAdmin = true
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
